(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Grafika"] = factory();
	else
		root["Grafika"] = factory();
})(this, function() {
return webpackJsonpGrafika([6],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(151);


/***/ },

/***/ 151:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _lodash = __webpack_require__(4);
	
	var _tool = __webpack_require__(152);
	
	var Tool = _interopRequireWildcard(_tool);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var _window = window;
	var Cx = _window.Cx;
	
	
	(0, _lodash.assign)(Cx, Tool);

/***/ },

/***/ 152:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _select = __webpack_require__(153);
	
	Object.keys(_select).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _select[key];
	    }
	  });
	});
	
	var _zoom = __webpack_require__(111);
	
	Object.keys(_zoom).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _zoom[key];
	    }
	  });
	});
	
	var _pan = __webpack_require__(112);
	
	Object.keys(_pan).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _pan[key];
	    }
	  });
	});
	
	var _clip = __webpack_require__(157);
	
	Object.keys(_clip).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _clip[key];
	    }
	  });
	});
	
	var _powerClip = __webpack_require__(158);
	
	Object.keys(_powerClip).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _powerClip[key];
	    }
	  });
	});
	
	var _addFigure = __webpack_require__(159);
	
	Object.keys(_addFigure).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _addFigure[key];
	    }
	  });
	});
	
	var _draw = __webpack_require__(160);
	
	Object.keys(_draw).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _draw[key];
	    }
	  });
	});
	
	var _freeDraw = __webpack_require__(161);
	
	Object.keys(_freeDraw).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _freeDraw[key];
	    }
	  });
	});
	
	var _editText = __webpack_require__(162);
	
	Object.keys(_editText).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _editText[key];
	    }
	  });
	});
	
	var _charsTransform = __webpack_require__(163);
	
	Object.keys(_charsTransform).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _charsTransform[key];
	    }
	  });
	});
	
	var _nodeEdit = __webpack_require__(164);
	
	Object.keys(_nodeEdit).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _nodeEdit[key];
	    }
	  });
	});
	
	var _renderInfo = __webpack_require__(165);
	
	Object.keys(_renderInfo).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _renderInfo[key];
	    }
	  });
	});
	
	var _selectBrush = __webpack_require__(166);
	
	Object.keys(_selectBrush).forEach(function (key) {
	  if (key === "default") return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function () {
	      return _selectBrush[key];
	    }
	  });
	});

/***/ },

/***/ 153:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SelectTool = exports.SelectBaseTool = undefined;
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _cdl = __webpack_require__(15);
	
	var _view = __webpack_require__(84);
	
	var _selectTransform = __webpack_require__(154);
	
	var _dragSelector = __webpack_require__(156);
	
	var SelectBaseTool = exports.SelectBaseTool = _view.Tool.extend({
	
	  type: 'Select',
	
	  toolbarName: 'selectTool',
	  allowKeyShortcuts: true,
	  isCommitable: false,
	
	  Properties: {
	    selectAndDragEnabled: { type: 'boolean', def: true }
	  },
	
	  resume: function () {
	    this.callParent();
	    this.handles.update();
	    this.setIddleToolhelp();
	  },
	  initTool: function (view, config) {
	    var _this = this;
	
	    (0, _lodash.assign)(this, config || {});
	
	    this.handles = new _selectTransform.OptimizedFiguresHandles({ view: view, tool: this,
	
	      editingItems: function (view) {
	        return view.selectedFigures;
	      },
	      onItemsDrag: function (event, figures) {
	        view.fireEvent('figuresdrag', event, figures);
	      },
	      onItemsDrop: function (_ref, figures) {
	        var view = _ref.view;
	        var event = _ref.event;
	
	        var onDrop = { cancelMove: false };
	        if (event) {
	          view.fireEvent('figuresdrop', event, figures, onDrop); // [TODO] FiguresDropEvent
	        }
	
	        var cancelMove = onDrop.cancelMove;
	        if (cancelMove) {
	          this.absoluteTranslate(new _cdl.Point(0, 0));
	        }
	
	        var notRemovedFigures = [];
	        var doc = view.doc;
	
	        (0, _lodash.forEach)(figures, function (figure) {
	          if (figure.document === doc) {
	            notRemovedFigures.push(figure);
	          }
	        });
	        return notRemovedFigures.length > 0 && !cancelMove;
	      },
	
	
	      setIddleToolhelp: function () {
	        return _this.setIddleToolhelp();
	      }
	    });
	
	    this._transparentMode = false;
	  },
	  setIddleToolhelp: function () {
	    var th = ['Click or draw rectangle to select', 'Ctrl and drag Canvas to pan'];
	    if (this.view.selectedFigures.length > 0) {
	      th.push('Shift to aggregate to selection');
	      th.push('Alt to make selected figures transparent');
	      th.push('Alt-Click to select figure below selection');
	    }
	    this.toolhelp(th);
	  },
	  link: function (view) {
	    view.on({
	      'rendercomplete': this.on_rendercomplete //,
	      //'change' : this.on_change,
	      //'resize' : this.on_change
	    }, this);
	
	    this.handles.create();
	  },
	  unlink: function (view) {
	    view.un(this);
	
	    this.handles.dispose();
	  },
	  on_dblclick: function (_ref2) {
	    var view = _ref2.view;
	    var docPoint = _ref2.docPoint;
	
	
	    var selectedFigures = view.selectedFigures;
	
	    if (selectedFigures.length === 1) {
	      var figure = selectedFigures[0];
	      if (view.canEditContent(figure)) {
	        // [TODO] && view._dblclickContentEditionEnabled(figure) ) {
	        view.editContent(figure, docPoint);
	      }
	    } else if (view.editingContent()) {
	      view.commitContent$();
	    }
	  },
	  onSelectionChanged: function () /* view */{
	    /*
	    const tm = this._transparentMode;
	    if( tm ) {
	      forEach( this._transparentFigureViews, fv => { fv.hideMask(); });
	      this._transparentMode = false;
	      this.on_keydown_alt(view);
	    }
	    */
	    this.setIddleToolhelp();
	    this.redraw();
	  },
	  draw: function (config) {
	
	    // Draw selected texture island, we should make this a plugin
	    // [TODO] Hacking in missing features from v5, later clean up
	    var view = config.view;
	    var context = config.context;
	    var transformModel = config.transformModel;
	
	    var docIslands = (0, _lodash.filter)(view.selectedFigures, function (figure) {
	      return figure.metadata.get('textureIslandName');
	    });
	    if (view.is3D && view.model && docIslands.length > 0) {
	      (0, _lodash.forEach)(docIslands, function (docIsland) {
	        var modelIsland = view.model.modelIslandFor(docIsland);
	        context.strokeStyle = '#f2f2f2';
	        context.lineWidth = 25;
	        modelIsland.draw(context, transformModel, { customDraw: function (c) {
	            return c.stroke();
	          } });
	        context.strokeStyle = '#388638';
	        context.lineWidth = 20;
	        (0, _gear.setLineDash)(context, [6, 4]);
	        modelIsland.draw(context, transformModel, { customDraw: function (c) {
	            return c.stroke();
	          } });
	      });
	    } else {
	
	      this.handles.draw(config);
	    }
	  },
	  useAggregateMode: function (_ref3) {
	    var shiftKey = _ref3.shiftKey;
	    var cmdKey = _ref3.cmdKey;
	
	    return shiftKey || _config.Config.ctrlAggregation && cmdKey;
	  },
	  useContentEditMode: function (_ref4) {
	    var cmdKey = _ref4.cmdKey;
	
	    return !_config.Config.ctrlAggregation && cmdKey;
	  },
	  try_pointerdown: function (_ref5) {
	    var view = _ref5.view;
	    var event = _ref5.event;
	    var handles = this.handles;
	
	
	    if (handles.isHandle(event)) {
	
	      if (handles.isHandleEnabledAt(event)) {
	        handles.down(event);
	        event.stopPropagation();
	      }
	
	      // Clicking selection
	      // If there is no mouse movement for a few milliseconds,
	      // we should select this figure in the next mouse up.
	      this._possibleClicking = { event: event, time: (0, _lodash.now)() };
	
	      return true;
	    }
	
	    return false;
	  },
	  on_pointerdown: function (_ref6) {
	    var _this2 = this;
	
	    var view = _ref6.view;
	    var event = _ref6.event;
	    var which = _ref6.which;
	    var cmdKey = _ref6.cmdKey;
	    var docPoint = _ref6.docPoint;
	    var pointers = _ref6.pointers;
	    var handles = this.handles;
	
	
	    if (pointers.length === 2) {
	
	      if (handles._editionMode) {
	        event.stopPropagation();
	        return;
	      }
	
	      this._possibleDrag = null;
	      this.helper = null;
	      return;
	    }
	
	    if (handles._editionMode) {
	      this._endMode(event);
	      return;
	    }
	
	    var leftClick = which === 1;
	    if (!leftClick) {
	      // right click on empty design area?
	      if (!event.figure) {
	        // [EVENTS] some( view.selectedFigures, figure => figure.canBeSelected() && figure.frame_().contains(docPoint) )) {
	        // [TODO] stop event?
	        view.clearSelection();
	        view.render$();
	      }
	      return;
	    }
	
	    if (!this.try_pointerdown(event)) {
	      var figureHit = event.figureHit; // get top most figure at point
	
	      var _handles = this.handles;
	
	
	      var possibleDrag = function () {
	        if (!cmdKey) {
	          if (!_this2.useAggregateMode(event)) {
	            view.clearSelection();
	          }
	          view.render$();
	          _this2._possibleDrag = { event: event };
	        }
	      };
	
	      if (figureHit) {
	        // click directly on figure (not handle)?
	
	        var figure = figureHit.figure;
	        var tight = figureHit.tight;
	
	        if (tight && this.selectAndDragEnabled && !(view.is3D && !view.selectAndDragEnabled)) {
	          // [TODO] Review...
	
	          this._figureClicked(figure, event);
	
	          // [TODO] Review, hacking my way to production now, allow to select and drag the 3D model
	          // in case the figure is not movable
	
	          var movable = view.is(figure, 'movable');
	          if (movable) {
	            event.stopPropagation();
	            _handles.update(); // Needed for select and drag
	            _handles.down(event);
	          }
	
	          view.render$();
	        } else {
	          this._possibleClicking = { event: event, time: (0, _lodash.now)() };
	          possibleDrag();
	        }
	
	        return;
	      } else {
	        // click on empty design area?
	        possibleDrag();
	      }
	    }
	  },
	  on_mousemove: function (event) {
	    this.handles.mousemove(event);
	  },
	  on_pointermove: function (_ref7) {
	    var view = _ref7.view;
	    var event = _ref7.event;
	    var _possibleDrag = this._possibleDrag;
	
	    if (_possibleDrag) {
	      this.helper = new _dragSelector.DragSelectorHelper(_possibleDrag.event, this._dragEnd.bind(this));
	      this._possibleDrag = null;
	    }
	    this.handles.move(event);
	  },
	  on_pointerup: function (event) {
	    this._endMode(event);
	  },
	  _endMode: function (_ref8) {
	    var view = _ref8.view;
	    var event = _ref8.event;
	    var viewPoint = _ref8.viewPoint;
	
	
	    this.handles.up(event);
	
	    this._possibleDrag = null;
	
	    var pc = this._possibleClicking;
	    if (pc) {
	      var t = (0, _lodash.now)();
	      if (t - pc.time < 500) {
	        var pc_event = pc.event;
	        var pcViewPoint = pc_event.viewPoint;
	
	        // Allow small shifts, accepted as clicks
	        if (Math.abs(pcViewPoint.x - viewPoint.x) <= 1 && Math.abs(pcViewPoint.y - viewPoint.y) <= 1) {
	          var figure = pc.event.figure;
	
	
	          if (figure) {
	            // Add the selected figure
	            this._figureClicked(figure, pc_event);
	            view.render$();
	          } else if (this.useContentEditMode(pc_event) && view.editingContent()) {
	            view.commitContent$();
	          }
	        }
	      }
	      this._possibleClicking = null;
	    }
	  },
	  on_rendercomplete: function () {
	    this.handles.update();
	  },
	  _dragEnd: function (_ref9, bounds) {
	    var view = _ref9.view;
	    var event = _ref9.event;
	
	
	    if (bounds.width > 0 && bounds.height > 0) {
	      (function () {
	        var selectedFigures = view.selectedFigures;
	
	        var figures = view.activeSelectableFigures(); // [TODO]
	
	        (0, _cdl.updateArray$)(figures).then(function () {
	
	          var selection = (0, _lodash.filter)(figures, function (figure) {
	
	            // Is Inside Bounds
	            var fb = figure.bounds_();
	            return fb.lx > bounds.lx && fb.ly > bounds.ly && fb.hx < bounds.hx && fb.hy < bounds.hy;
	          });
	
	          if (selection.length > 0) {
	            // Force selection of upper layer figures first
	            selection.reverse();
	
	            selectedFigures.add(selection);
	          }
	
	          view.render$();
	        });
	      })();
	    }
	  },
	  _figureClicked: function (figure, event) {
	    var view = this.view;
	    var selectedFigures = view.selectedFigures;
	
	    view.activeDocument = figure.document;
	
	    if (this.useContentEditMode(event) && view.canEditContent(figure)) {
	      // [TODO] && view._dblclickContentEditionEnabled(figure) ) {
	      return view.editContent(figure, view.docPoint(event));
	    }
	
	    if (this.useAggregateMode(event)) {
	
	      if ((0, _lodash.includes)(selectedFigures, figure)) {
	        selectedFigures.remove(figure);
	      } else {
	        selectedFigures.add(figure);
	      }
	    }
	    // Avoid selectionChanged event in case it is already selected
	    else if (!(selectedFigures.length === 1 && selectedFigures[0] === figure)) {
	
	        selectedFigures.set([figure]);
	      }
	  },
	  somethingToDraw: function () {
	    return this.handles.visible;
	  },
	  needsToDrawFor: function (docIsland) {
	    var frame = this.handles.frame;
	
	    return !!frame && _cdl.Frame.areOverlapping(docIsland.frame_(), this.handles.frame);
	  }
	});
	
	var SelectTool = exports.SelectTool = SelectBaseTool.extend({ typeName: 'SelectTool',
	
	  canUndo: function () {
	    return this.view.doc.canUndo();
	  },
	  undo: function () {
	    return this.view.doc.undo();
	  },
	  canRedo: function () {
	    return this.view.doc.canRedo();
	  },
	  redo: function () {
	    return this.view.doc.redo();
	  },
	  supportsClipboard: function () {
	    return true;
	  }
	});
	_view.Tool.Select = SelectTool;

/***/ },

/***/ 154:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.OptimizedFiguresHandles = exports.FiguresHandles = exports.SelectAndTransformHandles = undefined;
	exports.computeScale = computeScale;
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _cdl = __webpack_require__(15);
	
	var _selectHandles = __webpack_require__(155);
	
	var _abs = Math.abs;
	
	var dotProduct = _cdl.Point.dotProduct;
	var substract = _cdl.Point.substract;
	function computeScale(pin, dir, mousePos, initialMousePos, zoomScale) {
	
	  var initialDiff = substract(initialMousePos, pin);
	
	  var currentDiff = substract(mousePos, pin);
	
	  var dpi = dotProduct(initialDiff, dir);
	
	  var dpc = dotProduct(currentDiff, dir);
	  if (_abs(dpc) < 8 * zoomScale) {
	    if (_abs(dpi) < 8 * zoomScale) {
	      dpc = dpi;
	    } else {
	      dpc = 8 * zoomScale * (dpc < 0 ? -1 : 1);
	    }
	  }
	
	  return {
	    pin: pin.clone(),
	    sx: dpc / dpi,
	    deg: dir.angle()
	  };
	}
	
	function computeShear(pin, dir, mousePos, initialMousePos) {
	  // http://www.w3.org/TR/SVG11/coords.html
	  // http://jsfiddle.net/jbpEk/
	  // http://jsfiddle.net/jbpEk/26/
	
	  var initialDiff = substract(initialMousePos, pin);
	  var currentDiff = substract(mousePos, pin);
	  var dpc = dotProduct(currentDiff, dir);
	  var dpi = dotProduct(initialDiff, dir);
	
	  var dpcPa = _abs(dotProduct(initialDiff, dir.perpendicular(-1)));
	
	  if (dpcPa < 8) {
	    dpcPa = 8;
	  }
	
	  var r = {
	    deg: dir.angle(),
	    sx: (dpc - dpi) / dpcPa,
	    sy: 0,
	    pin: pin.clone()
	  };
	
	  return r;
	}
	
	// Computes the rotation in radians.
	function computeRotation(pin, mousePos) {
	  return mousePos.minus(pin).angle();
	}
	
	function computeFiguresFrame_(figures) {
	  if (figures.length === 1) {
	    return figures[0].frame_();
	  }
	  return _cdl.Frame.fromBounds(_cdl.Figures.bounds_(figures));
	}
	
	function figuresSnapToPoints(view, editingFigures) {
	
	  var snapTo = [];
	
	  var viewBounds = view.bounds;
	  (0, _lodash.forEach)(view.horizontalUserLines, function (userLine) {
	    if (userLine._snap) {
	      var snapPoint = new _cdl.Point(userLine._position, viewBounds.ly);
	      snapTo.push({ lx_ly: snapPoint, center: snapPoint, hx_hy: snapPoint });
	    }
	  });
	  (0, _lodash.forEach)(view.verticalUserLines, function (userLine) {
	    if (userLine._snap) {
	      var snapPoint = new _cdl.Point(viewBounds.lx, userLine._position);
	      snapTo.push({ lx_ly: snapPoint, center: snapPoint, hx_hy: snapPoint });
	    }
	  });
	
	  snapTo.push({ center: _cdl.Figures.bounds_(editingFigures).center });
	
	  (0, _lodash.forEach)((0, _lodash.difference)(view.activePageFigures, editingFigures), function (figure) {
	    var _figure$frame_$bounds = figure.frame_().bounds;
	    var lx_ly = _figure$frame_$bounds.lx_ly;
	    var center = _figure$frame_$bounds.center;
	    var hx_hy = _figure$frame_$bounds.hx_hy;
	
	    snapTo.push({ lx_ly: lx_ly, center: center, hx_hy: hx_hy });
	  });
	
	  return snapTo;
	}
	
	// We should divide this into several helpers
	
	var FrameInteractionMixin = {
	
	  // expects
	  //
	  //  members:
	  //    view, handles
	  //
	  //  functions:
	  //    editingItems(view) => items
	  //    getOriginalTransforms(items) => transforms
	  //    setOriginalTransforms(items,transforms)
	  //    transformItems(items,transform)
	  //
	  //  optional:
	  //    setOriginalPositions(items,transforms)
	  //    translateItems(items,offset)
	  //    snapToPoints(view,items) => [ { lx_ly, center, hx_hy }, ... ]
	  //    transformWithFixedCenter(view,items) => boolean
	  //    scaleOriginalXY(view,items) => { scaleX : s00, scaleY : s11 }
	  //    setIddleToolhelp()
	
	  initFrameInteraction: function () {
	    (0, _lodash.assign)(this, {
	      _data: null,
	      _editingItems: null,
	      _originalTransforms: null,
	      _editionMode: false,
	      _downFrame: null
	    });
	  },
	  snapToPoints: function () /*view,items*/{
	    return [];
	  },
	  transformWithFixedCenter: function () /*view,items*/{
	    return false;
	  },
	  scaleOriginalXY: function () /*view,items*/{
	    return null; // { scaleX : s00, scaleY : s11 };
	  },
	  setIddleToolhelp: function () {},
	  setEditionToolhelp: function (transformType, shiftToolhelp, shiftOnlyForSingleSelection) {
	    var tool = this.tool;
	    var _editingItems = this._editingItems;
	
	    var dragText = 'Drag to ' + transformType + ' selection';
	    var altText = 'Alt to make selection transparent';
	    if (_editingItems.length > 1) {
	      tool.toolhelp(dragText + (shiftOnlyForSingleSelection ? '' : '\n' + shiftToolhelp), altText);
	    } else {
	      tool.toolhelp(dragText, shiftToolhelp, altText);
	    }
	  },
	  onItemsDrag: function () /*event, items*/{},
	  onItemsDrop: function () /*event, items*/{
	    return true;
	  },
	
	
	  // Internals
	  //--------------------------------------------------------------------------------------
	
	  startEditionMode: function (transformType, shiftToolhelp, shiftOnlyForSingleSelection) {
	    var view = this.view;
	    var handles = this.handles;
	
	
	    var editingItems = this._editingItems = (0, _gear.clone)(this.editingItems(view));
	    this._originalTransforms = this.getOriginalTransforms(editingItems);
	
	    this._downFrame = handles._frame;
	    this._editionMode = true;
	
	    this.setEditionToolhelp(transformType, shiftToolhelp, shiftOnlyForSingleSelection);
	    view.redraw('annotations');
	  },
	  endEditionMode: function () {
	    this.setIddleToolhelp();
	    this.initFrameInteraction();
	  },
	
	
	  // optional
	  translateItems: function (items, offset) {
	    this.transformItems(items, _cdl.Matrix.translate(offset));
	  },
	  setOriginalPositions: function (figures, originalTransforms) {
	    this.setOriginalTransforms(figures, originalTransforms);
	  },
	  updateHandlesFrame: function (transform) {
	    var view = this.view;
	    var handles = this.handles;
	    var _downFrame = this._downFrame;
	
	    handles.update(_downFrame.transformed(transform));
	    // Batch redraw, the frame will be drawn again at the same time as the document
	    view.batchRedraw('tools');
	  },
	  absoluteTransform: function (transform) {
	    var view = this.view;
	    var _editingItems = this._editingItems;
	    var _originalTransforms = this._originalTransforms;
	
	    this.setOriginalTransforms(_editingItems, _originalTransforms);
	    this.updateHandlesFrame(transform);
	    this.transformItems(_editingItems, transform);
	    view.preview$();
	  },
	  absoluteTranslate: function (offset) {
	    var view = this.view;
	    var _editingItems = this._editingItems;
	    var _originalTransforms = this._originalTransforms;
	
	    this.setOriginalPositions(_editingItems, _originalTransforms);
	    this.updateHandlesFrame(_cdl.Matrix.translate(offset));
	    this.translateItems(_editingItems, offset);
	    view.preview$();
	  },
	  commit$: function () {
	    this.view.commit$();
	  },
	
	
	  // Translate
	  //-------------------------------------------------------------------------------------
	
	  onTranslateStart: function (_ref) {
	    var view = _ref.view;
	
	    this._data = {
	      snapLock: view.snapLock,
	      offset: new _cdl.Point(0, 0),
	      started: false,
	      snapTo: this.snapToPoints(view, this.editingItems(view)) // [ { lx_ly, center, hx_hy }, ... ]
	    };
	  },
	
	
	  // Use docPointRaw that allows jumps depending on the view used to see
	  // the document (Canvas3D, TextureView)
	
	  getOnTranslateValue: function (_ref2) {
	    var view = _ref2.view;
	    var docPointRaw = _ref2.docPointRaw;
	    var cmdKey = _ref2.cmdKey;
	    var shiftKey = _ref2.shiftKey;
	    var handles = this.handles;
	    var _data = this._data;
	    var _downFrame = this._downFrame;
	
	
	    var offset = substract(docPointRaw, handles.mouseDownPos);
	    if (!offset.isZero()) {
	      _data.started = true;
	    }
	
	    var snapTo = _data.snapTo;
	    // [TODO] Move AlignmentLines logic to the plugin
	    var alignmentLines = view._alignmentLines || { _visible: false, _snap: false };
	
	    var forceSnap = shiftKey || cmdKey || _data.snapLock;
	    var al_visible = forceSnap || alignmentLines._visible;
	    var al_snap = forceSnap || alignmentLines._snap;
	    var al_enabled = al_visible || al_snap;
	    if (snapTo && al_enabled && _data.started) {
	      (function () {
	        // snap
	        var snapSize = view.viewDeltaToDoc(14);
	
	        var _downFrame$translated = _downFrame.translated(offset);
	
	        var bounds = _downFrame$translated.bounds;
	
	        var al_x = null,
	            al_y = null,
	            diff_x = Number.MAX_VALUE,
	            diff_y = Number.MAX_VALUE;
	        (0, _lodash.forEach)(snapTo, function (snap) {
	          (0, _lodash.forEach)(snap, function (s, name) {
	
	            var diff = substract(s, bounds[name]);
	
	            var ax = _abs(diff.x);
	            if (ax < snapSize && _abs(diff_x) > ax) {
	              diff_x = diff.x;
	              if (al_visible) {
	                al_x = s.x;
	              }
	            }
	            var ay = _abs(diff.y);
	            if (ay < snapSize && _abs(diff_y) > ay) {
	              diff_y = diff.y;
	              if (al_visible) {
	                al_y = s.y;
	              }
	            }
	          });
	        });
	
	        handles.guideline_x = al_x;
	        if (al_snap && diff_x !== Number.MAX_VALUE) {
	          offset.x += diff_x;
	        }
	
	        handles.guideline_y = al_y;
	        if (al_snap && diff_y !== Number.MAX_VALUE) {
	          offset.y += diff_y;
	        }
	      })();
	    } else {
	      handles.guideline_x = null;
	      handles.guideline_y = null;
	    }
	
	    return view.asFastOffset(offset);
	  },
	  onTranslateMove: function (event) {
	    var _data = this._data;
	    var _editionMode = this._editionMode;
	    var _editingItems = this._editingItems;
	
	    if (!_editionMode) {
	      this.startEditionMode('translate', 'Shift to show snap guidelines');
	    }
	    var offset = _data.offset = this.getOnTranslateValue(event);
	    this.absoluteTranslate(offset);
	    this.onItemsDrag(event, _editingItems);
	  },
	  onTranslateEnd: function (event) {
	    var _data = this._data;
	    var _editionMode = this._editionMode;
	    var _editingItems = this._editingItems;
	    var handles = this.handles;
	
	    if (_editionMode) {
	      var offset = _data.offset;
	
	
	      var needsRedraw = handles.guideline_x || handles.guideline_y;
	
	      handles.guideline_x = null;
	      handles.guideline_y = null;
	
	      this.endEditionMode();
	
	      if ((offset.x !== 0 || offset.y !== 0) && this.onItemsDrop(event, _editingItems)) {
	        this.commit$();
	      } else if (needsRedraw) {
	        this.tool.redraw();
	      }
	    }
	  },
	
	
	  // Scale
	  //-------------------------------------------------------------------------------------
	
	  onScaleStart: function (_ref3) {
	    var view = _ref3.view;
	    var handles = this.handles;
	
	    var editingItems = this.editingItems(view);
	    var pin = handles.current.pin.pos;
	    this._data = {
	      snapLock: view.snapLock,
	      scale: { pin: pin, sx: 1, sy: 1, deg: 0 },
	      fixedCenter: this.transformWithFixedCenter(view, editingItems),
	      center: handles.center,
	      scalePin: pin,
	      scaleDir: handles.scaleDirFromHandle(handles.current),
	      os: this.scaleOriginalXY(view, editingItems)
	    };
	  },
	  getOnScaleValue: function (_ref4) {
	    var view = _ref4.view;
	    var event = _ref4.event;
	    var docPoint = _ref4.docPoint;
	    var cmdKey = _ref4.cmdKey;
	    var shiftKey = _ref4.shiftKey;
	    var handles = this.handles;
	    var _data = this._data;
	    var current = handles.current;
	    var mouseDownPos = handles.mouseDownPos;
	    var fixedCenter = _data.fixedCenter;
	    var center = _data.center;
	    var scalePin = _data.scalePin;
	    var scaleDir = _data.scaleDir;
	
	
	    var pin = fixedCenter || cmdKey ? center : scalePin;
	
	    var scale = computeScale(pin, scaleDir, docPoint, mouseDownPos, view.viewDeltaToDoc(1));
	
	    var name = current.name;
	
	    scale.sy = name === 'ne' || name === 'nw' || name === 'sw' || name === 'se' ? scale.sx : 1;
	
	    var os = _data.os;
	
	    if (shiftKey && os) {
	      // Snapping to sx = sy
	      if (name === 'n' || name === 's') {
	        if (_abs(os.scaleY * scale.sx / os.scaleX - 1) < 0.15) {
	          scale.sx = os.scaleX / os.scaleY;
	        }
	      } else if (name === 'e' || name === 'w') {
	        if (_abs(os.scaleX * scale.sx / os.scaleY - 1) < 0.15) {
	          scale.sx = os.scaleY / os.scaleX;
	        }
	      }
	    }
	    return scale;
	  },
	  onScaleMove: function (event) {
	    var _editionMode = this._editionMode;
	
	    if (!_editionMode) {
	      this.startEditionMode('scale', 'Shift to lock to on isometric scaling', true);
	    }
	
	    this.doScaleMove(event);
	  },
	  doScaleMove: function (event) {
	    var _data = this._data;
	
	    var _data$scale = _data.scale = this.getOnScaleValue(event);
	
	    var pin = _data$scale.pin;
	    var sx = _data$scale.sx;
	    var sy = _data$scale.sy;
	    var deg = _data$scale.deg;
	
	
	    var scaleFrom = _cdl.Matrix.scaleFrom(pin, sx, sy, deg);
	
	    this.absoluteTransform(scaleFrom);
	  },
	  onScaleEnd: function () {
	    var _data = this._data;
	    var _editionMode = this._editionMode;
	
	    if (_editionMode) {
	      var sx = _data.scale.sx;
	
	
	      this.endEditionMode();
	      if (sx !== 1) {
	        this.commit$();
	      }
	    }
	  },
	
	
	  // Rotate
	  //-------------------------------------------------------------------------------------
	
	  onRotateStart: function (_ref5) {
	    var view = _ref5.view;
	    var event = _ref5.event;
	    var docPoint = _ref5.docPoint;
	    var handles = this.handles;
	    var center = handles.center;
	    var current = handles.current;
	
	
	    this._data = {
	      snapLock: view.snapLock,
	      deg: 0,
	      center: center,
	      initialDeg: computeRotation(center, docPoint),
	      initialSnapDeg: computeRotation(center, current.pos)
	    };
	  },
	  getOnRotateValue: function (_ref6) {
	    var event = _ref6.event;
	    var docPoint = _ref6.docPoint;
	    var shiftKey = _ref6.shiftKey;
	    var cmdKey = _ref6.cmdKey;
	    var _data = this._data;
	    var center = _data.center;
	    var initialDeg = _data.initialDeg;
	    var initialSnapDeg = _data.initialSnapDeg;
	
	
	    var r = computeRotation(center, docPoint);
	    if (shiftKey || cmdKey) {
	      // Snap
	      var sm = 15;
	      return Math.round(r / sm) * sm - initialSnapDeg;
	    } else {
	      return r - initialDeg;
	    }
	  },
	  onRotateMove: function (event) {
	    var _editionMode = this._editionMode;
	    var _data = this._data;
	
	
	    if (!_editionMode) {
	      this.startEditionMode('rotate', 'Shift to lock rotation on multiples of 15 degrees');
	    }
	
	    var deg = _data.deg = this.getOnRotateValue(event);
	    var rotateAround = _cdl.Matrix.rotateAround(_data.center, deg);
	
	    this.absoluteTransform(rotateAround);
	  },
	  onRotateEnd: function () {
	    var _editionMode = this._editionMode;
	    var _data = this._data;
	
	
	    if (_editionMode) {
	      var deg = _data.deg;
	
	      this.endEditionMode();
	      if (deg !== 0) {
	        this.commit$();
	      }
	    }
	  },
	
	
	  // Shear
	  //-------------------------------------------------------------------------------------
	
	  onShearStart: function (_ref7) {
	    var view = _ref7.view;
	    var handles = this.handles;
	    var current = handles.current;
	    var center = handles.center;
	
	
	    this._data = {
	      snapLock: view.snapLock,
	      shear: { sx: 0, sy: 0 },
	      center: center,
	      fixedCenter: this.transformWithFixedCenter(view, this.editingItems(view)),
	      shearPin: current.pin.pos,
	      shearDir: handles.shearDirFromHandle(current),
	      shearHandlePos: current.pos,
	      shearOppPin: current.oppPin.pos
	    };
	  },
	  getOnShearValue: function (_ref8) {
	    var view = _ref8.view;
	    var event = _ref8.event;
	    var docPoint = _ref8.docPoint;
	    var handles = this.handles;
	    var _data = this._data;
	    var ctrlKey = handles.ctrlKey;
	    var shiftKey = handles.shiftKey;
	    var fixedCenter = _data.fixedCenter;
	    var center = _data.center;
	    var shearPin = _data.shearPin;
	    var shearOppPin = _data.shearOppPin;
	    var shearHandlePos = _data.shearHandlePos;
	    var shearDir = _data.shearDir;
	
	
	    var downPos = handles.mouseDownPos;
	
	    var pos = docPoint;
	
	    var pin = fixedCenter || ctrlKey ? center : shearPin;
	    if (shiftKey) {
	      // Snap
	      var currentOppPin = pos.plus(substract(shearOppPin, shearHandlePos));
	      var kp = substract(currentOppPin, pin);
	      var dp = dotProduct(kp, shearDir);
	      if (_abs(dp) < 15) {
	        pos = pin.plus(substract(shearHandlePos, shearOppPin));
	        downPos = shearHandlePos;
	      }
	    }
	
	    return computeShear(pin, _data.shearDir, pos, downPos);
	  },
	  onShearMove: function (event) {
	    var _data = this._data;
	    var _editionMode = this._editionMode;
	
	
	    if (!_editionMode) {
	      this.startEditionMode('skew', 'Shift to lock when there is no skewing', true);
	    }
	
	    var _data$shear = _data.shear = this.getOnShearValue(event);
	
	    var pin = _data$shear.pin;
	    var sx = _data$shear.sx;
	    var sy = _data$shear.sy;
	    var deg = _data$shear.deg;
	
	    var shearAround = _cdl.Matrix.shearAround(pin, sx, sy, deg);
	
	    this.absoluteTransform(shearAround);
	  },
	  onShearEnd: function () {
	    var _editionMode = this._editionMode;
	    var _data = this._data;
	
	    if (_editionMode) {
	      var _data$shear2 = _data.shear;
	      var sx = _data$shear2.sx;
	      var sy = _data$shear2.sy;
	
	      this.endEditionMode();
	      if (sx !== 0 || sy !== 0) {
	        this.commit$();
	      }
	    }
	  }
	};
	
	var SelectAndTransformHandles = exports.SelectAndTransformHandles = _gear.Base.extend(FrameInteractionMixin, {
	
	  // To overwrite in the config
	
	  // Check FrameInteractionMixin plus...
	  //
	  // functions:
	  //   computeItemsFrame_(items) => frame
	  //   itemsEnabledTransforms(items) => { anisometricTransforms, translate, scale, rotate, shear, contentEdit }
	  //
	  // optional:
	  //   invalidatedItems(items) => boolean
	
	
	  init: function (config) {
	    this.handles = null;
	    (0, _lodash.assign)(this, config);
	    this.initFrameInteraction();
	  },
	  isHandle: function (event) {
	    return this.handles ? this.handles.isHandle(event) : false;
	  },
	  isHandleEnabledAt: function (event) {
	    return this.handles ? this.handles.isHandleEnabledAt(event) : false;
	  },
	  isPadHandle: function (event) {
	    return this.handles ? this.handles.isPadHandle(event) : false;
	  },
	
	
	  get frame() {
	    return this.handles ? this.handles._frame : null;
	  },
	
	  get visible() {
	    return this.handles ? this.handles.visible : false;
	  },
	
	  down: function (event) {
	    if (this.handles) {
	      this.handles.down(event);
	    }
	  },
	  mousemove: function (event) {
	    if (this.handles) {
	      this.handles.mousemove(event);
	    }
	  },
	  move: function (event) {
	    if (this.handles) {
	      this.handles.move(event);
	    }
	  },
	  up: function (event) {
	    if (this.handles) {
	      this.handles.up(event);
	    }
	  },
	  draw: function (config) {
	    if (this.handles) {
	      this.handles.draw(config);
	    }
	  },
	  create: function () {
	    if (this.handles) {
	      this.dispose();
	    }
	    this.handles = new _selectHandles.SelectHandles({ view: this.view });
	    this.handles.on({ 'rotatestart': this.onRotateStart,
	      'rotatemove': this.onRotateMove,
	      'rotateend': this.onRotateEnd,
	      'scalestart': this.onScaleStart,
	      'scalemove': this.onScaleMove,
	      'scaleend': this.onScaleEnd,
	      'shearstart': this.onShearStart,
	      'shearmove': this.onShearMove,
	      'shearend': this.onShearEnd,
	      'translatestart': this.onTranslateStart,
	      'translatemove': this.onTranslateMove,
	      'translateend': this.onTranslateEnd,
	      'edit': this.onContentEdit }, this);
	  },
	  dispose: function () {
	    if (this.handles) {
	      this.handles.un(this);
	      this.handles = null;
	    }
	  },
	  onContentEdit: function () {
	    var view = this.view;
	
	    var items = this.editingItems(view);
	    if (items.length === 1) {
	      view.editContent(items[0]);
	    }
	  },
	  invalidatedItems: function () /*items*/{
	    return false;
	  },
	  update: function (frame) {
	    var view = this.view;
	    var handles = this.handles;
	
	
	    if (!handles) {
	      return;
	    }
	
	    if (frame) {
	      handles.update(frame);
	    } else {
	
	      var items = this.editingItems(view);
	      if (items.length > 0) {
	
	        // If edition mode is on, the frame is already updated while transforming
	        if (!this._editionMode && !this.invalidatedItems(items)) {
	
	          var config = this.itemsEnabledTransforms(view, items);
	
	          handles.anisometricTransformsEnabled = config.anisometricTransforms || false;
	
	          handles.translateEnabled = config.translate || false;
	          handles.scaleEnabled = config.scale || false;
	          handles.rotateEnabled = config.rotate || false;
	          handles.shearEnabled = config.shear || false;
	
	          handles.editEnabled = config.contentEdit || false;
	
	          handles.resize(this.computeItemsFrame_(items));
	          handles.visible = true;
	        }
	      } else {
	        handles.visible = false;
	      }
	    }
	
	    this.view.batchRedraw('tools');
	  }
	});
	
	var FiguresHandles = exports.FiguresHandles = SelectAndTransformHandles.extend({
	  getOriginalTransforms: function (figures) {
	    return (0, _lodash.map)(figures, function (figure) {
	      return {
	        matrix22: figure.matrix22.clone(),
	        pin: figure.pin.clone()
	      };
	    });
	  },
	  setOriginalTransforms: function (figures, originalTransforms) {
	    (0, _lodash.forEach)(figures, function (figure, n) {
	      var original = originalTransforms[n];
	      figure.pin = original.pin.clone();
	      figure.matrix22 = original.matrix22.clone();
	    });
	  },
	  itemsEnabledTransforms: function (view, figures) {
	    return {
	      anisometricTransforms: view.are(figures, 'aspectRatioChangeable'),
	
	      translate: view.are(figures, 'movable'),
	      scale: view.are(figures, 'scalable'),
	      rotate: view.are(figures, 'rotatable'),
	      shear: view.are(figures, 'skewable'),
	
	      contentEdit: this.itemsEnabledContentEdit(view, figures)
	    };
	  },
	  itemsEnabledContentEdit: function (view, figures) {
	    return view.are(figures, 'contentEditable');
	  },
	
	
	  transformItems: _cdl.Figures.transform,
	  invalidatedItems: _cdl.Figures.invalidated,
	
	  computeItemsFrame_: computeFiguresFrame_,
	
	  snapToPoints: figuresSnapToPoints,
	
	  transformWithFixedCenter: function (view, figures) {
	    return !view.are(figures, 'movable');
	  },
	  scaleOriginalXY: function (view, items) {
	    var figure = items[0];
	    var matrix = figure._matrix22;
	    var urm = _cdl.Matrix.m(_cdl.Matrix.rotate(-matrix.angle()), matrix);
	    return { scaleX: urm.s00, scaleY: urm.s11 };
	  }
	});
	
	// Attempt to avoid an extra Process call to measure ProxyGroups after
	// isometric scaling (pr)
	
	var OptimizedFiguresHandles = exports.OptimizedFiguresHandles = FiguresHandles.extend({
	
	  translateItems: _cdl.Figures.fastTranslate_, // forced, offset is already fixed
	
	  getOriginalTransforms: function (figures) {
	    return (0, _lodash.map)(figures, function (figure) {
	      return {
	        matrix22: figure.matrix22.clone(),
	        pin: figure.pin.clone()
	        //  cache: figure._cache.clone()  (pr)
	      };
	    });
	  },
	  setOriginalPositions: function (figures, originalTransforms) {
	    (0, _lodash.forEach)(figures, function (figure, n) {
	      var original = originalTransforms[n];
	      figure.fastTranslate(original.pin.minus(figure.pin));
	    });
	  },
	
	
	  // Do it by hand, avoid need to compute bounds for proxy groups
	  doScaleMove: function (event) {
	    var _data = this._data;
	
	
	    var lastScale = _data.scale;
	
	    var _data$scale2 = _data.scale = this.getOnScaleValue(event);
	
	    var pin = _data$scale2.pin;
	    var sx = _data$scale2.sx;
	    var sy = _data$scale2.sy;
	    var deg = _data$scale2.deg;
	
	
	    var scaleFrom = _cdl.Matrix.scaleFrom(pin, sx, sy, deg);
	
	    var view = this.view;
	    var _editingItems = this._editingItems;
	
	    this.updateHandlesFrame(scaleFrom);
	
	    // Revert last change and re-apply absolute scaling, caches are kept
	    _cdl.Figures.scaleFrom(_editingItems, lastScale.pin, 1 / lastScale.sx, 1 / lastScale.sy, lastScale.deg);
	    _cdl.Figures.scaleFrom(_editingItems, pin, sx, sy, deg);
	
	    view.preview$();
	  }
	});

/***/ },

/***/ 155:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SelectHandles = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _cdl = __webpack_require__(15);
	
	var _view = __webpack_require__(84);
	
	var distance2 = _cdl.Point.distance2;
	
	
	function maxSideLength2(frame) {
	  var p0 = frame.p0;
	  var p1 = frame.p1;
	  var p2 = frame.p2;
	  var p3 = frame.p3;
	
	  return Math.max(distance2(p1, p0), distance2(p2, p1), distance2(p3, p2), distance2(p0, p3));
	}
	
	function minSideLength2(frame) {
	  var p0 = frame.p0;
	  var p1 = frame.p1;
	  var p2 = frame.p2;
	  var p3 = frame.p3;
	
	  return Math.min(distance2(p1, p0), distance2(p2, p1), distance2(p3, p2), distance2(p0, p3));
	}
	
	/* default */var SelectHandles = exports.SelectHandles = _gear.Base.extend({
	
	  Properties: {
	    view: { type: 'View', def: null, owned: false },
	
	    anisometricTransformsEnabled: { type: 'boolean', def: true },
	    translateEnabled: { type: 'boolean', def: true },
	    scaleEnabled: { type: 'boolean', def: true },
	    rotateEnabled: { type: 'boolean', def: true },
	    shearEnabled: { type: 'boolean', def: true },
	    editEnabled: { type: 'boolean', def: false }
	  },
	  init: function () {
	    this._visible = false;
	
	    this.guideline_x = null;
	    this.guideline_y = null;
	
	    this.mouseDownPos = new _cdl.Point(0, 0);
	
	    this._handles = {
	      center: { mode: 'translate' },
	      nw: { mode: 'scale' },
	      ne: { mode: 'scale' },
	      se: { mode: 'scale' },
	      sw: { mode: 'scale' },
	      n: { mode: 'scale', aniso: true },
	      e: { mode: 'scale', aniso: true },
	      s: { mode: 'scale', aniso: true },
	      w: { mode: 'scale', aniso: true },
	      rotate: { mode: 'rotate' },
	      shearX: { mode: 'shear', aniso: true },
	      shearY: { mode: 'shear', aniso: true },
	      edit: { mode: 'edit' },
	      none: { mode: 'none' }
	    };
	
	    var size = 0.1 * 96;
	
	    var hs = this._handles;
	    (0, _lodash.forEach)(hs, function (h, hn) {
	      h.name = hn;h.size = size;h.cursor = 'pointer';h.disabled = false;
	    });
	    hs.rotate.size = hs.edit.size = size;
	
	    hs.center.cursor = 'move';
	    hs.none.cursor = 'default';
	
	    (0, _lodash.forEach)(hs, function (h) {
	      h.size2 = h.size * h.size + 1;
	    });
	
	    hs.nw.pin = hs.se;hs.ne.pin = hs.sw;
	    hs.se.pin = hs.nw;hs.sw.pin = hs.ne;
	    hs.n.pin = hs.s;hs.e.pin = hs.w;
	    hs.s.pin = hs.n;hs.w.pin = hs.e;
	    hs.shearX.pin = hs.n;hs.shearX.oppPin = hs.s;
	    hs.shearY.pin = hs.w;hs.shearY.oppPin = hs.w;
	
	    this._circlePadHandles = (0, _lodash.pick)(hs, 'rotate', 'nw', 'ne', 'se', 'sw', 'n', 'e', 's', 'w', 'shearX', 'shearY', 'edit');
	
	    this._fillColor = '#22CC33';
	    this._fillOverColor = '#006633';
	    this._fillActiveColor = '#fb603d';
	    this._strokeColor = '#006633';
	    this._guidelineColor = '#993300';
	
	    this.addEvents('rotatestart', 'rotatemove', 'rotateend', 'scalestart', 'scalemove', 'scaleend', 'translatestart', 'translatemove', 'translateend', 'shearstart', 'shearmove', 'shearend', 'edit');
	
	    this._currentActive = this._handles.none;
	    this._currentOver = this._handles.none;
	    this.current = this._handles.none;
	    this._setFrame(_cdl.Frame.fromBounds({ lx: 100, ly: 100, hx: 200, hy: 200 }));
	    this._inited = false;
	    this.enable(true);
	  },
	  _rotateHandlePosition: function (p1, p2, distance) {
	    var de = p2.minus(p1).normalized();
	    return p2.plus(de.scaled(this.view.viewDeltaToDoc(distance)));
	  },
	  _editHandlePosition: function (p1, p2, distance) {
	    var de = p2.minus(p1).normalized();
	    return p2.plus(de.scaled(this.view.viewDeltaToDoc(distance)));
	  },
	  _setFrame: function (frame) {
	    this._frame = frame;
	    this._inited = true;
	    var interpolate = _cdl.Point.interpolate;
	    var nw = this._frame.p0,
	        ne = this._frame.p1,
	        se = this._frame.p2,
	        sw = this._frame.p3;
	    var p = {
	      nw: nw, ne: ne, se: se, sw: sw,
	      n: interpolate(nw, ne, 0.5),
	      e: interpolate(ne, se, 0.5),
	      s: interpolate(se, sw, 0.5),
	      w: interpolate(sw, nw, 0.5)
	    };
	
	    p.shearX = interpolate(p.s, se, 0.5);
	    p.shearY = interpolate(se, p.e, 0.5);
	
	    p.rotate = this._rotateHandlePosition(p.w, p.e, 20);
	    p.edit = this._editHandlePosition(p.e, p.w, 20);
	
	    var hs = this._handles;
	    (0, _lodash.forOwn)(p, function (pos, hn) {
	      hs[hn].pos = pos;
	    });
	  },
	
	
	  // frame: The figure frame in the View coordinates.
	  resize: function (frame) {
	    var view = this.view;
	
	    var frameMinSideLength2 = minSideLength2(frame);
	    //frameMaxSideLength2 = maxSideLength2(frame);
	
	    var vtds = view.viewDeltaToDoc(1),
	        vtds2 = vtds * vtds;
	
	    var smallFrame = frameMinSideLength2 < 45 * 45 * vtds2;
	
	    if (smallFrame) {
	      var ex = 12 * vtds;
	      // console.log(vtds);
	      frame = frame.extended(ex, ex, ex, ex);
	      //this._anisometricTransformsEnabled = false;
	    }
	
	    // const ps = view.viewDeltaToDoc(padScaling);
	
	    // const hs = this._handles;
	    // const { width, height } = frame;
	    // const shearCut1 = 40 * ps,
	    //       shearCut2 = 60 * ps,
	    //       scaleCut1 = 20 * ps,
	    //       scaleCut2 = 30 * ps;
	    // hs.shearX.disabled = height < shearCut1 || width < shearCut2;
	    // hs.shearY.disabled = height < shearCut2 || width < shearCut1;
	    // hs.e.disabled = width < scaleCut1 || height < scaleCut2;
	    // hs.w.disabled = width < scaleCut1 || height < scaleCut2;
	    // hs.n.disabled = width < scaleCut2 || height < scaleCut1;
	    // hs.s.disabled = width < scaleCut2 || height < scaleCut1;
	    this.update(frame);
	  },
	  update: function (frame) {
	    this._setFrame(frame);
	  },
	  enable: function (isEnabled) {
	    if (isEnabled === undefined) {
	      this.enabled = true;
	    } else {
	      this.enabled = isEnabled;
	    }
	  },
	  isEnabled: function () {
	    return this.enabled;
	  },
	  handleEnabled: function (c) {
	    return c.mode === 'none' || this[c.mode + 'Enabled'] && (this._anisometricTransformsEnabled || !c.aniso);
	  },
	  down: function (_ref) {
	    var event = _ref.event;
	    var docPoint = _ref.docPoint;
	
	    if (!this.isEnabled()) {
	      return;
	    }
	
	    var c = this._handleFromEvent(event);
	
	    if (!this.handleEnabled(c)) {
	      return;
	    }
	    this.current = c;
	
	    if (c.mode === 'none') {
	      return;
	    } else if (c.mode === 'edit') {
	      this.fireEvent('edit', event);
	      this.current = this._handles.none;
	      return;
	    }
	
	    this._currentActive = this.current;
	
	    this._currentOver = this._handles.none;
	
	    this.mouseDownPos = docPoint;
	
	    this.fireEvent(this.current.mode + 'start', event); // shear, rotate, scale, or translate
	  },
	  mousemove: function (_ref2) {
	    var view = _ref2.view;
	    var event = _ref2.event;
	
	
	    if (view.is3D) {
	      // Ignore feedback for 3D views
	      return;
	    }
	
	    // Handle pad Over
	    if (this._visible && this.current.mode === 'none') {
	      var newOver = this._handleFromEvent(event);
	      if (this._currentOver !== newOver) {
	
	        this._currentOver = newOver;
	
	        if (newOver.mode === 'none' || this.handleEnabled(newOver)) {
	          view.cursor = newOver.cursor;
	        }
	
	        view.redraw('tools');
	
	        event.stopPropagation();
	      }
	    }
	  },
	
	
	  move: (0, _view.fastThrottle)(function (_ref3) {
	    var view = _ref3.view;
	    var event = _ref3.event;
	
	
	    if (this.current.mode === 'none') {
	      return;
	    }
	    this.fireEvent(this.current.mode + 'move', event); // rotate, scale, select, shear or translate
	  }, 12),
	
	  up: function (_ref4) {
	    var view = _ref4.view;
	    var event = _ref4.event;
	
	    var mode = this.current.mode;
	    if (mode === 'none') {
	      return;
	    }
	
	    this._currentActive = this._handles.none;
	
	    this.fireEvent(mode + 'end', event); // rotate, scale, select, or translate
	
	    this.current = this._handles.none;
	
	    if (mode !== 'translate') {
	      // avoid glitch
	      view.cursor = this.current.cursor;
	    }
	  },
	  shearDirFromHandle: function (h) {
	    var hs = this._handles;
	    switch (h.name) {
	      case 'shearX':
	        return hs.e.pos.minus(hs.w.pos).normalized();
	      case 'shearY':
	        return hs.n.pos.minus(hs.s.pos).normalized();
	    }
	  },
	  scaleDirFromHandle: function (h) {
	    var transform = arguments.length <= 1 || arguments[1] === undefined ? (0, _cdl.Matrix)() : arguments[1];
	
	    return transform.apply(h.pos).minus(transform.apply(h.pin.pos)).normalized();
	  },
	  strokeFrame: function (context, transform) {
	    var hs = this._handles;
	
	    // rotate arm
	    if (this.rotateEnabled) {
	      (0, _gear.strokeSegment)(context, hs.e.pos, this._rotateHandlePosition(hs.w.pos, hs.e.pos, 20), transform);
	    }
	
	    // Center handle
	    this._frame.draw(context, transform);
	    context.stroke();
	  },
	  draw: function (_ref5) {
	    var _this = this;
	
	    var view = _ref5.view;
	    var context = _ref5.context;
	    var transform = _ref5.transform;
	
	
	    if (this._inited && this._visible) {
	      (function () {
	
	        context.save();
	
	        var hs = _this._handles;
	
	        var textureScale = view.viewDeltaToTexture(1);
	
	        (0, _gear.setLineDash)(context, (0, _lodash.map)([5, 2], function (v) {
	          return textureScale * v;
	        }));
	        context.lineWidth = 2.4 * textureScale;
	        var strokeStyle = context.strokeStyle = '#e3e3e3';
	        _this.strokeFrame(context, transform);
	
	        (0, _gear.setLineDash)(context, (0, _lodash.map)([0, 0.5, 4, 2.5], function (v) {
	          return textureScale * v;
	        }));
	        context.lineWidth = 1.2 * textureScale;
	        context.strokeStyle = '#388638';
	        _this.strokeFrame(context, transform);
	
	        context.strokeStyle = strokeStyle;
	        context.lineWidth = 1 * textureScale; // [TODO]
	        (0, _gear.setLineDash)(context, []);
	
	        if (_this.scaleEnabled) {
	          (0, _lodash.forEach)(['nw', 'ne', 'se', 'sw'], function (hn) {
	            var h = hs[hn];
	            _this._drawScaleHandle(context, h, transform, textureScale);
	            context.stroke();
	            context.fillStyle = _this.fillStyle(h);
	            context.fill();
	          });
	        }
	
	        if (_this.rotateEnabled) {
	          // Rotate handle, raphael was taking a lot of time to rotate the handle
	          var rotateHandle = hs.rotate;
	          context.beginPath();
	
	          // [TODO] Clean up, running to release
	          rotateHandle.pos = _this._rotateHandlePosition(hs.w.pos, hs.e.pos, 28);
	
	          var rotationPos = transform.apply(rotateHandle.pos);
	          var rotationAngle = transform.apply(hs.e.pos).minus(transform.apply(hs.w.pos)).angle();
	          var rotationPathTransform = _cdl.Matrix.concat(_cdl.Matrix.translate(rotationPos), _cdl.Matrix.scale(0.65 * textureScale), _cdl.Matrix.rotate(rotationAngle));
	          canvasRotationPath(context, rotationPathTransform);
	          context.stroke();
	          context.fillStyle = _this.fillStyle(rotateHandle);
	          context.fill();
	        }
	
	        if (_this.editEnabled) {
	          var editHandle = hs.edit;
	          context.beginPath();
	
	          // [TODO] Clean up, running to release
	          editHandle.pos = _this._editHandlePosition(hs.e.pos, hs.w.pos, 20);
	
	          var editAngle = transform.apply(hs.e.pos).minus(transform.apply(hs.w.pos)).angle();
	          canvasEditContentPath(context, _cdl.Matrix.concat(_cdl.Matrix.translate(transform.apply(editHandle.pos)), _cdl.Matrix.scale(0.6 * textureScale), _cdl.Matrix.rotate(editAngle), _cdl.Matrix.translate(-16, -16)));
	          context.stroke();
	          context.fillStyle = _this.fillStyle(editHandle);
	          context.fill();
	        }
	
	        if (_this._anisometricTransformsEnabled) {
	
	          if (_this.scaleEnabled) {
	            (0, _lodash.forEach)(['n', 'e', 's', 'w'], function (hn) {
	              var h = hs[hn];
	              if (!h.disabled) {
	                _this._drawScaleHandle(context, h, transform, textureScale);
	                context.stroke();
	                context.fillStyle = _this.fillStyle(h);
	                context.fill();
	              }
	            });
	          }
	
	          if (_this.shearEnabled) {
	            (0, _lodash.forEach)(['shearX', 'shearY'], function (hn) {
	              var h = hs[hn];
	              if (!h.disabled) {
	
	                var tp = transform.apply(h.pos);
	                context.beginPath();context.arc(tp.x, tp.y, 3.5 * textureScale, 0, 2 * Math.PI); // [TODO] dot
	                context.stroke();
	                context.fillStyle = _this.fillStyle(h);
	                context.fill();
	              }
	            });
	          }
	        }
	
	        // Guidelines
	
	        var bounds = view.bounds;
	        context.strokeStyle = _this._guidelineColor;
	        context.lineWidth = 0.75;
	        (0, _gear.setLineDash)(context, [3, 2]);
	
	        var x = _this.guideline_x;
	        if (x !== null) {
	          (0, _gear.strokeSegment)(context, new _cdl.Point(x, bounds.ly), new _cdl.Point(x, bounds.hy), transform);
	        }
	
	        var y = _this.guideline_y;
	        if (y !== null) {
	          (0, _gear.strokeSegment)(context, new _cdl.Point(bounds.lx, y), new _cdl.Point(bounds.hx, y), transform);
	        }
	
	        context.restore();
	      })();
	    }
	  },
	  fillStyle: function (h) {
	    return h === this._currentActive ? this._fillActiveColor : h === this._currentOver ? this._fillOverColor : this._fillColor;
	  },
	  isHandle: function (event) {
	    return this._handleFromEvent(event).name !== 'none';
	  },
	  isPadHandle: function (event) {
	    var n = this._handleFromEvent(event).name;
	    return n !== 'none' && n !== 'center';
	  },
	  isHandleEnabledAt: function (event) {
	    return this.handleEnabled(this._handleFromEvent(event));
	  },
	  _handleFromEvent: function (_ref6) {
	    var event = _ref6.event;
	    var docPoint = _ref6.docPoint;
	
	    var view = this.view;
	    var hs = this._handles;
	    if (this._visible) {
	      var point = docPoint;
	      var ps = view.viewDeltaToDoc(_view.padScaling),
	          ps2 = ps * ps; // [TODO]
	
	      var padHandles = (0, _lodash.keys)(this._circlePadHandles);
	      for (var k = 0, kEnd = padHandles.length; k < kEnd; ++k) {
	        var hk = hs[padHandles[k]];
	        if (this.handleEnabled(hk) && !hk.disabled && hk.pos.minus(point).norm2() < hk.size2 * ps2) {
	          return hk;
	        }
	      }
	
	      if (this._frame.contains(point)) {
	        return hs.center;
	      }
	    }
	    return hs.none;
	  },
	
	
	  // Returns center point in View coordinates.
	  get center() {
	    return this._frame.center;
	  },
	
	  get visible() {
	    return this._visible;
	  },
	  set visible(visible_) {
	    this._visible = visible_;
	  },
	
	  _drawScaleHandle: function (context, h, transform, textureScale) {
	    var scale = 4.5;
	    var dir = this.scaleDirFromHandle(h, transform);
	    var dirp = dir.perpendicular(-scale * textureScale);
	    var p = transform.apply(h.pos).plus(dir.scaled(0.3 * scale * textureScale));
	    var t1 = p.plus(dir.scaled(scale * textureScale));
	    var tb = p.plus(dir.scaled(-scale * textureScale));
	    var t2 = tb.plus(dirp.scaled(-scale * textureScale));
	    var t3 = tb.plus(dirp.scaled(scale * textureScale));
	
	    context.beginPath();
	    (0, _gear.moveTo)(context, t1);
	    (0, _gear.lineTo)(context, t2);
	    (0, _gear.lineTo)(context, t3);
	    context.closePath();
	  }
	});
	
	exports.default = SelectHandles;
	
	// Handle paths, we need to find a better way, this is here since we moved
	// away from Raphael. It was unrolled thinking on performance but it is
	// probably not making us gain much
	
	var moveToXY = function (c, t, x, y) {
	  var p = t.apply_(x, y);
	  c.moveTo(p.x, p.y);
	};
	
	var lineToXY = function (c, t, x, y) {
	  var p = t.apply_(x, y);
	  c.lineTo(p.x, p.y);
	};
	
	var bezierCurveTo = function (c, t, p0_x, p0_y, p1_x, p1_y, p2_x, p2_y) {
	  var p0 = t.apply_(p0_x, p0_y),
	      p1 = t.apply_(p1_x, p1_y),
	      p2 = t.apply_(p2_x, p2_y);
	  c.bezierCurveTo(p0.x, p0.y, p1.x, p1.y, p2.x, p2.y);
	};
	
	function canvasRotationPath(c, t) {
	  moveToXY(c, t, -8.084, 0.500);
	  bezierCurveTo(c, t, -8.075, 5.240, -4.240, 9.074, 0.499, 9.083);
	  bezierCurveTo(c, t, 5.240, 9.074, 9.076, 5.239, 9.084, 0.500);
	  bezierCurveTo(c, t, 9.076, -4.241, 5.240, -8.077, 0.499, -8.085);
	  bezierCurveTo(c, t, -1.414, -8.085, -3.166, -7.456, -4.591, -6.399);
	  bezierCurveTo(c, t, -4.591, -6.399, -2.809, -4.616, -2.809, -4.616);
	  bezierCurveTo(c, t, -2.809, -4.616, -11.238, -2.360, -11.238, -2.360);
	  bezierCurveTo(c, t, -11.238, -2.360, -8.978, -10.787, -8.978, -10.787);
	  bezierCurveTo(c, t, -8.978, -10.787, -7.088, -8.897, -7.088, -8.897);
	  bezierCurveTo(c, t, -5.016, -10.574, -2.371, -11.585, 0.499, -11.585);
	  bezierCurveTo(c, t, 7.173, -11.582, 12.581, -6.174, 12.583, 0.500);
	  bezierCurveTo(c, t, 12.581, 7.175, 7.173, 12.583, 0.500, 12.583);
	  bezierCurveTo(c, t, -6.175, 12.583, -11.584, 7.175, -11.584, 0.500);
	  bezierCurveTo(c, t, -11.584, 0.500, -8.084, 0.500, -8.084, 0.500);
	  bezierCurveTo(c, t, -8.084, 0.500, -8.084, 0.500, -8.084, 0.500);
	  c.closePath();
	}
	
	function canvasEditContentPath(c, t) {
	  moveToXY(c, t, 15.067, 2.250);
	  bezierCurveTo(c, t, 9.088, 2.250, 4.032, 6.160, 2.289, 11.559);
	  lineToXY(c, t, 5.502, 11.559);
	  bezierCurveTo(c, t, 7.104, 7.854, 10.773, 5.258, 15.067, 5.250);
	  bezierCurveTo(c, t, 20.831, 5.260, 25.495, 9.924, 25.504, 15.687);
	  bezierCurveTo(c, t, 25.495, 21.451, 20.831, 26.115, 15.067, 26.125);
	  bezierCurveTo(c, t, 10.773, 26.118, 7.103, 23.520, 5.501, 19.814);
	  lineToXY(c, t, 2.289, 19.814);
	  bezierCurveTo(c, t, 4.033, 25.213, 9.088, 29.124, 15.068, 29.126);
	  bezierCurveTo(c, t, 22.487, 29.124, 28.505, 23.110, 28.506, 15.688);
	  bezierCurveTo(c, t, 28.504, 8.265, 22.486, 2.252, 15.067, 2.250);
	  c.closePath();
	
	  moveToXY(c, t, 10.918, 19.813);
	  lineToXY(c, t, 18.068, 15.687);
	  lineToXY(c, t, 10.918, 11.558);
	  lineToXY(c, t, 10.918, 13.855);
	  lineToXY(c, t, -0.057, 13.855);
	  lineToXY(c, t, -0.057, 17.516);
	  lineToXY(c, t, 10.918, 17.516);
	  lineToXY(c, t, 10.918, 19.813);
	  c.closePath();
	}

/***/ },

/***/ 156:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DragSelectorHelper = undefined;
	
	var _gear = __webpack_require__(8);
	
	var _cdl = __webpack_require__(15);
	
	function stableLine(context, p0, p1) {
	  context.beginPath();
	  context.moveTo(p0.x, p0.y);
	  context.lineTo(p1.x, p1.y);
	  context.stroke();
	}
	
	var DragSelectorHelper = exports.DragSelectorHelper = function (_ref, onEnd) {
	  var docPoint = _ref.docPoint;
	  var strokeColor = arguments.length <= 2 || arguments[2] === undefined ? '#006633' : arguments[2];
	
	  this.onEnd = onEnd;
	  this._pd = docPoint;
	  this._fd = docPoint;
	  this._sc = strokeColor;
	};
	DragSelectorHelper.prototype = {
	  draw: function (_ref2) {
	    var context = _ref2.context;
	    var transform = _ref2.transform;
	
	
	    var frame = _cdl.Frame.fromBounds(this.bounds).transformed(transform);
	
	    // This is done piece by piece so the dash will be
	    // more stable when dragging, the direction of each line
	    // is important to make this trick work
	
	    context.save();
	    context.strokeStyle = this._sc;
	    context.lineWidth = 1;
	    (0, _gear.setLineDash)(context, [4, 3]);
	
	    stableLine(context, frame.p3, frame.p0);
	    stableLine(context, frame.p2, frame.p1);
	    stableLine(context, frame.p3, frame.p2);
	    stableLine(context, frame.p0, frame.p1);
	    context.restore();
	  },
	  move: function (_ref3) {
	    var view = _ref3.view;
	    var docPoint = _ref3.docPoint;
	
	    this._pd = docPoint;
	  },
	  end: function (event) {
	    var onEnd = this.onEnd;
	
	    onEnd(event, this.bounds);
	  },
	
	
	  get bounds() {
	    return _cdl.Bounds.ofPoints([this._pd, this._fd]);
	  }
	};

/***/ },

/***/ 157:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ClipTool = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _lodash = __webpack_require__(4);
	
	var _view = __webpack_require__(84);
	
	var _selectTransform = __webpack_require__(154);
	
	var _cdl = __webpack_require__(15);
	
	var dotProduct = _cdl.Point.dotProduct;
	var substract = _cdl.Point.substract;
	
	var _abs = Math.abs;
	
	var ClipTool = exports.ClipTool = _view.Tool.extend({ typeName: 'ClipTool',
	
	  type: 'Final',
	  toolbarName: 'clipTool',
	  allowKeyShortcuts: true,
	
	  initTool: function (view, config) {
	    var _this = this;
	
	    (0, _lodash.assign)(this, config || {});
	    this._data = null;
	
	    this.handles = new _selectTransform.FiguresHandles({ view: view, tool: this,
	
	      editingItems: function () {
	        var figure = _this._selectedFigure;
	        return figure ? [figure] : [];
	      },
	
	      itemsEnabledContentEdit: function () /* view, figures */{
	        return false;
	      },
	
	
	      commit$: function () {},
	
	      itemsEnabledTransforms: function (view, figures) {
	        return {
	          anisometricTransforms: view.are(figures, 'aspectRatioChangeable'),
	          translate: view.are(figures, 'movable'),
	          scale: view.are(figures, 'scalable'),
	          rotate: false,
	          shear: false,
	          contentEdit: false
	        };
	      },
	      getOnTranslateValue: function (_ref) {
	        var view = _ref.view;
	        var docPointRaw = _ref.docPointRaw;
	        var cmdKey = _ref.cmdKey;
	        var shiftKey = _ref.shiftKey;
	        var handles = this.handles;
	        var _data = this._data;
	        var _downFrame = this._downFrame;
	
	
	        var offset = substract(docPointRaw, handles.mouseDownPos);
	        if (!offset.isZero()) {
	          _data.started = true;
	        }
	
	        var snapTo = _data.snapTo;
	        var alignmentLines = view._alignmentLines || { _visible: false, _snap: false };
	        var forceSnap = shiftKey || cmdKey;
	        var al_visible = forceSnap || alignmentLines._visible;
	        var al_snap = forceSnap || alignmentLines._snap;
	        var al_enabled = al_visible || al_snap;
	        if (snapTo && al_enabled && _data.started) {
	          (function () {
	            // snap
	            var snapSize = view.viewDeltaToDoc(14);
	
	            var _downFrame$translated = _downFrame.translated(offset);
	
	            var bounds = _downFrame$translated.bounds;
	
	            var al_x = null,
	                al_y = null,
	                diff_x = Number.MAX_VALUE,
	                diff_y = Number.MAX_VALUE;
	            (0, _lodash.forEach)(snapTo, function (snap) {
	              (0, _lodash.forEach)(snap, function (s, name) {
	
	                var diff = substract(s, bounds[name]);
	
	                var ax = _abs(diff.x);
	                if (ax < snapSize && _abs(diff_x) > ax) {
	                  diff_x = diff.x;
	                  if (al_visible) {
	                    al_x = s.x;
	                  }
	                }
	                var ay = _abs(diff.y);
	                if (ay < snapSize && _abs(diff_y) > ay) {
	                  diff_y = diff.y;
	                  if (al_visible) {
	                    al_y = s.y;
	                  }
	                }
	              });
	            });
	
	            handles.guideline_x = al_x;
	            if (al_snap && diff_x !== Number.MAX_VALUE) {
	              offset.x += diff_x;
	            }
	
	            handles.guideline_y = al_y;
	            if (al_snap && diff_y !== Number.MAX_VALUE) {
	              offset.y += diff_y;
	            }
	          })();
	        } else {
	          handles.guideline_x = null;
	          handles.guideline_y = null;
	        }
	
	        //get the minimum and maximum translation, then fix the offset if it will go out of the parent frame
	        var lParent = this.clipTool._selectedParent;
	        var lParentFrame = lParent.globalFrame_();
	        var lFigureFrame = _downFrame.translated(offset);
	        var lTransform = lParent.rwPowerClipTransform();
	        var lInvTransform = _cdl.Matrix.invert(lTransform);
	        lParentFrame.transform(lInvTransform);
	        lFigureFrame.transform(lInvTransform);
	
	        var lDeltaP0 = substract(lParentFrame.p0, lFigureFrame.p0);
	        if (lDeltaP0.x > 0) {
	          var lP = new _cdl.Point(lDeltaP0.x, 0);
	          lP.transform(lTransform);
	          lP.translate(-lParent.pin.x, -lParent.pin.y);
	          offset.x += lP.x;
	          offset.y += lP.y;
	        }
	        if (lDeltaP0.y > 0) {
	          var _lP = new _cdl.Point(0, lDeltaP0.y);
	          _lP.transform(lTransform);
	          _lP.translate(-lParent.pin.x, -lParent.pin.y);
	          offset.x += _lP.x;
	          offset.y += _lP.y;
	        }
	
	        var lDeltaP2 = substract(lParentFrame.p2, lFigureFrame.p2);
	        if (lDeltaP2.x < 0) {
	          var _lP2 = new _cdl.Point(lDeltaP2.x, 0);
	          _lP2.transform(lTransform);
	          _lP2.translate(-lParent.pin.x, -lParent.pin.y);
	          offset.x += _lP2.x;
	          offset.y += _lP2.y;
	        }
	        if (lDeltaP2.y < 0) {
	          var _lP3 = new _cdl.Point(0, lDeltaP2.y);
	          _lP3.transform(lTransform);
	          _lP3.translate(-lParent.pin.x, -lParent.pin.y);
	          offset.x += _lP3.x;
	          offset.y += _lP3.y;
	        }
	
	        return view.asFastOffset(offset);
	      },
	      getOnScaleValue: function (_ref2) {
	        var view = _ref2.view;
	        var event = _ref2.event;
	        var docPoint = _ref2.docPoint;
	        var cmdKey = _ref2.cmdKey;
	        var shiftKey = _ref2.shiftKey;
	        var handles = this.handles;
	        var _data = this._data;
	        var _downFrame = this._downFrame;
	        var current = handles.current;
	        var mouseDownPos = handles.mouseDownPos;
	        var fixedCenter = _data.fixedCenter;
	        var center = _data.center;
	        var scalePin = _data.scalePin;
	        var scaleDir = _data.scaleDir;
	
	
	        var pin = scalePin;
	
	        var scale = (0, _selectTransform.computeScale)(pin, scaleDir, docPoint, mouseDownPos, view.viewDeltaToDoc(1));
	
	        var name = current.name;
	
	        scale.sy = name === 'ne' || name === 'nw' || name === 'sw' || name === 'se' ? scale.sx : 1;
	
	        var lRetry = 0;
	        var lFailedToScale = true;
	        var lParent = this.clipTool._selectedParent;
	        var lParentFrame = lParent.globalFrame_();
	        var lTransform = lParent.rwPowerClipTransform();
	        var lInvTransform = _cdl.Matrix.invert(lTransform);
	        lParentFrame.transform(lInvTransform);
	
	        var lOldScaleFrom = _cdl.Matrix.scaleFrom(scale.pin, _data.scale.sx, _data.scale.sy, scale.deg);
	        var lOldFigureFrame = _downFrame.clone().transform(lOldScaleFrom);
	        lOldFigureFrame.transform(lInvTransform);
	
	        while (lRetry++ < 5 && lFailedToScale) {
	          if (scale.sx <= 0 || scale.sy <= 0) {
	            break;
	          }
	          lFailedToScale = false;
	
	          var scaleFrom = _cdl.Matrix.scaleFrom(scale.pin, scale.sx, scale.sy, scale.deg);
	          var lFigureFrame = _downFrame.clone().transform(scaleFrom);
	          lFigureFrame.transform(lInvTransform);
	
	          var lFigureDeltaP0 = substract(lFigureFrame.p0, lOldFigureFrame.p0);
	          var lFigureDeltaP2 = substract(lFigureFrame.p2, lOldFigureFrame.p2);
	
	          var lDeltaP0 = substract(lParentFrame.p0, lFigureFrame.p0);
	          if (lDeltaP0.x > 0 && lFigureDeltaP0.x < 0) {
	            scale.sx = (_data.scale.sx + scale.sx) / 2;
	            scale.sy = (_data.scale.sy + scale.sy) / 2;
	            lFailedToScale = true;
	          }
	          if (lDeltaP0.y > 0 && lFigureDeltaP0.y < 0) {
	            scale.sx = (_data.scale.sx + scale.sx) / 2;
	            scale.sy = (_data.scale.sy + scale.sy) / 2;
	            lFailedToScale = true;
	          }
	
	          var lDeltaP2 = substract(lParentFrame.p2, lFigureFrame.p2);
	          if (lDeltaP2.x < 0 && lFigureDeltaP2.x > 0) {
	            scale.sx = (_data.scale.sx + scale.sx) / 2;
	            scale.sy = (_data.scale.sy + scale.sy) / 2;
	            lFailedToScale = true;
	          }
	          if (lDeltaP2.y < 0 && lFigureDeltaP2.y > 0) {
	            scale.sx = (_data.scale.sx + scale.sx) / 2;
	            scale.sy = (_data.scale.sy + scale.sy) / 2;
	            lFailedToScale = true;
	          }
	        }
	        if (lFailedToScale) {
	          scale.sx = _data.scale.sx;
	          scale.sy = _data.scale.sy;
	        }
	        return scale;
	      }
	    });
	
	    this.handles.clipTool = this;
	  },
	  link: function (view) {
	    view.on({ 'preview': this.on_preview }, this);
	
	    this.handles.create();
	  },
	  unlink: function (view) {
	    var parent = this._selectedParent;
	    if (parent) {
	      parent.endEditClip$();
	    }
	    view.un(this);
	    this.handles.dispose();
	  },
	  dispose: function () {
	    this.handles.dispose();
	    this.callParent();
	  },
	  draw: function (config) {
	    this.handles.draw(config);
	  },
	  on_keydown: function (_ref3) {
	    var view = _ref3.view;
	    var event = _ref3.event;
	    var altKey = _ref3.altKey;
	    var which = _ref3.which;
	
	    if (!view._keyShortcuts) {
	      return;
	    }
	
	    switch (which) {
	      case 46:
	        // 'Del'
	        event.preventDefault();
	        if (view.canRemove(this._selectedFigure)) {
	
	          this._selectedParent.clippedBy = "";
	          view.remove(this._selectedFigure);
	          this._selectedFigure = null;
	          this._selectedParent = null;
	          this.handles.update();
	          return view.commit$();
	        }
	        break;
	    }
	  },
	  on_pointerdown: function (_ref4) {
	    var _this2 = this;
	
	    var view = _ref4.view;
	    var event = _ref4.event;
	    var isPrimary = _ref4.isPrimary;
	    var docPoint = _ref4.docPoint;
	
	    if (!isPrimary) {
	      return;
	    }
	
	    var handles = this.handles;
	
	    if (handles._editionMode) {
	      //this._endMode(event);
	      return;
	    }
	
	    var leftClick = event.which === 1;
	    if (!leftClick) {
	      return;
	    }
	
	    if (handles.isHandle(event)) {
	      event.stopPropagation();
	      handles.down(event);
	    } else {
	      (function () {
	        var parent = _this2._selectedParent;
	        if (parent) {
	          parent.endEditClip$();
	          _this2._selectedFigure = null;
	          _this2._selectedParent = null;
	          _this2.handles.update();
	          //return;
	        }
	
	        parent = event.figure; // [EVENTS] view.figureAtPoint( docPoint ); // get top most figure at point
	        if (parent) {
	          (function () {
	            // click directly on figure (not handle)?
	
	            event.stopPropagation();
	
	            var _parent$getClippedBy = parent.getClippedBy();
	
	            var _parent$getClippedBy2 = _slicedToArray(_parent$getClippedBy, 2);
	
	            var lClipContent = _parent$getClippedBy2[0];
	            var lClipParent = _parent$getClippedBy2[1];
	
	
	            if (lClipContent) {
	              parent.beginEditClip$().then(function () {
	                _this2._figureClicked(lClipContent, parent);
	                return view.render$();
	              }).then(function () {
	                handles.down(event);
	              });
	            } else if (parent.isRaster) {
	              // TODO We are restricting to rasters now, but clipping can be done on any figure
	              var lId = _this2._computeUniqueId();
	              parent.addClippingRect$(lId).then(function () {
	                var _parent$getClippedBy3 = parent.getClippedBy();
	
	                var _parent$getClippedBy4 = _slicedToArray(_parent$getClippedBy3, 2);
	
	                lClipContent = _parent$getClippedBy4[0];
	                lClipParent = _parent$getClippedBy4[1];
	
	                _this2._figureClicked(lClipContent, parent);
	                return view.render$();
	              }).then(function () {
	                handles.down(event);
	              });
	            }
	          })();
	        } else {
	          // click on empty design area?
	
	          _this2._selectedFigure = null;
	          _this2._selectedParent = null;
	          _this2.handles.update();
	        }
	      })();
	    }
	  },
	  _computeUniqueId: function () {
	    var lDoc = this.view.document;
	    var lUniqueIdFound = false;
	    var lUniqueId = void 0;
	    for (var lUniqueIdx = 1; !lUniqueIdFound; lUniqueIdx++) {
	      lUniqueId = "c" + lUniqueIdx;
	      lUniqueIdFound = true;
	      for (var i = 0; lUniqueIdFound && i < lDoc.figures.length; i++) {
	        if (lDoc.figures[i].id == lUniqueId) {
	          lUniqueIdFound = false;
	        }
	      }
	    }
	    return lUniqueId;
	  },
	  _figureClicked: function (figure, parent) {
	
	    this.view.activeDocument = parent.document;
	
	    this._selectedFigure = figure;
	    this._selectedParent = parent;
	
	    this.handles.update();
	    this.view.render$();
	  },
	  on_mousemove: function (event) {
	    this.handles.mousemove(event);
	  },
	  on_pointermove: function (event) {
	    this.handles.move(event);
	  },
	  on_pointerup: function (event) {
	    this.handles.up(event);
	  },
	  on_preview: function () {
	    this.handles.update();
	  },
	  somethingToDraw: function () {
	    return this.handles.visible;
	  },
	  needsToDrawFor: function (docIsland) {
	    var frame = this.handles.frame;
	
	    return !!frame && _cdl.Frame.areOverlapping(docIsland.frame_(), this.handles.frame);
	  }
	});
	
	_view.Tool.Clip = ClipTool;

/***/ },

/***/ 158:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PowerClipTool = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _cdl = __webpack_require__(15);
	
	var _view = __webpack_require__(84);
	
	var _selectTransform = __webpack_require__(154);
	
	// [TODO] We should be able to allow multi selection
	
	var PowerClipTool = exports.PowerClipTool = _view.Tool.extend({ typeName: 'PowerClipTool',
	
	  type: 'Final',
	  toolbarName: 'powerClipTool',
	
	  initTool: function (view, config) {
	    var _this = this;
	
	    (0, _lodash.assign)(this, config || {});
	    this._data = null;
	
	    this.handles = new _selectTransform.FiguresHandles({ view: view, tool: this,
	
	      editingItems: function () {
	        var figure = _this._selectedFigure;
	        return figure ? [figure] : [];
	      },
	
	      computeItemsFrame_: function () {
	        var figure = _this._selectedFigure;
	        var parent = _this._selectedParent;
	        var frame = figure.frame_();
	        return frame.transformed(parent.rwPowerClipTransform());
	      },
	
	      itemsEnabledContentEdit: function () /* view, figures */{
	        return false;
	      },
	
	
	      translateItems: function (items, offset) {
	        _this.transformItems(items, _cdl.Matrix.translate(offset));
	      },
	
	      transformItems: this.transformItems.bind(this),
	
	      commit$: function () {
	        var parent = _this._selectedParent;
	        if (!parent.usingPowerClipLink()) {
	          parent.invalidate();
	        }
	        view.commit$();
	      }
	    });
	  },
	  transformItems: function (items, transform) {
	    // Ignore items
	    var figure = this._selectedFigure;
	    var parent = this._selectedParent;
	
	    var parentMatrix = parent.rwPowerClipTransform();
	
	    // And transform again
	    figure.transform(_cdl.Matrix.concat(parentMatrix.inverted(), transform, parentMatrix));
	
	    // We only need to invalidate the view, this should be automatic when
	    // calling figure.transform(..) [TODO][PC]
	    if (parent.usingPowerClipLink()) {
	      parent.invalidateView();
	    }
	  },
	  link: function (view) {
	    view.on({ 'preview': this.on_preview }, this);
	
	    this.handles.create();
	  },
	  unlink: function (view) {
	    view.un(this);
	    this.handles.dispose();
	  },
	  dispose: function () {
	    this.handles.dispose();
	    this.callParent();
	  },
	  draw: function (config) {
	    this.handles.draw(config);
	  },
	  on_pointerdown: function (_ref) {
	    var _this2 = this;
	
	    var view = _ref.view;
	    var event = _ref.event;
	    var isPrimary = _ref.isPrimary;
	    var docPoint = _ref.docPoint;
	
	    if (!isPrimary) {
	      return;
	    }
	
	    var handles = this.handles;
	
	    if (handles._editionMode) {
	      this._endMode(event);
	      return;
	    }
	
	    var leftClick = event.which === 1;
	    if (!leftClick) {
	      return;
	    }
	
	    if (handles.isHandle(event)) {
	      event.stopPropagation();
	      handles.down(event);
	    } else {
	
	      var parent = event.figure; // [EVENTS] view.figureAtPoint( docPoint ); // get top most figure at point
	      if (parent) {
	        (function () {
	          // click directly on figure (not handle)?
	
	          event.stopPropagation();
	
	          // Find figure inside of powerclip to move
	          var pcContent = parent.powerClipContents[0];
	          var parentMatrixInv = parent.rwPowerClipTransform().inverted();
	          var pcPoint = parentMatrixInv.apply(docPoint);
	          if (pcContent) {
	
	            // [TODO] This needs to be abstracted
	            var figure = (0, _lodash.findLast)(pcContent.figures, function (f) {
	              return f.containsPoint(pcPoint);
	            });
	            if (!figure) {
	              // Try frame hit testing
	              figure = (0, _lodash.findLast)(pcContent.figures, function (f) {
	                return f._outputFigure && f.frame_().contains(pcPoint);
	              });
	            }
	
	            if (figure) {
	              _this2._figureClicked(figure, parent);
	
	              view.render$().then(function () {
	                handles.down(event);
	              });
	            }
	          }
	        })();
	      } else {
	        // click on empty design area?
	
	        this._selectedFigure = null;
	        this._selectedParent = null;
	        this.handles.update();
	      }
	    }
	  },
	  _figureClicked: function (figure, parent) {
	
	    this.view.activeDocument = parent.document;
	
	    this._selectedFigure = figure;
	    this._selectedParent = parent;
	
	    this.handles.update();
	    this.view.render$();
	  },
	  on_mousemove: function (event) {
	    this.handles.mousemove(event);
	  },
	  on_pointermove: function (event) {
	    this.handles.move(event);
	  },
	  on_pointerup: function (event) {
	    this.handles.up(event);
	  },
	  on_preview: function () {
	    this.handles.update();
	  },
	  somethingToDraw: function () {
	    return this.handles.visible;
	  },
	  needsToDrawFor: function (docIsland) {
	    var frame = this.handles.frame;
	
	    return !!frame && _cdl.Frame.areOverlapping(docIsland.frame_(), this.handles.frame);
	  }
	});
	
	_view.Tool.PowerClip = PowerClipTool;

/***/ },

/***/ 159:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DrawEllipseTool = exports.DrawRectangleTool = exports.DrawCurveTool = exports.AddFigureTool = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _cdl = __webpack_require__(15);
	
	var _view = __webpack_require__(84);
	
	var _style = __webpack_require__(29);
	
	var AddFigureTool = exports.AddFigureTool = _view.Tool.extend({ typeName: 'AddFigureTool',
	
	  type: 'Final',
	
	  toolbarName: 'addFigureTool',
	
	  useCursor: 'crosshair',
	
	  initTool: function (view, figure) {
	    this._figure = figure;
	    return figure.update$();
	  },
	  link: function (view) {
	    view.cursor = 'crosshair';
	  },
	  unlink: function (view) {
	    view.cursor = 'default';
	  },
	
	
	  get brush() {
	    return this._figure.brush;
	  },
	  set brush(brush_) {
	    var figure = this._figure;
	    if (figure.isShape) {
	      (0, _lodash.forEach)(figure.polyregions, function (p) {
	        return p.brush = brush_;
	      });
	    } else {
	      figure.brush = brush_;
	    }
	  },
	
	  get pen() {
	    return this._figure.pen;
	  },
	  set pen(pen_) {
	    var figure = this._figure;
	    if (figure.isShape) {
	      (0, _lodash.forEach)(figure.polyregions, function (p) {
	        return p.pen = pen_;
	      });
	    } else {
	      figure.pen = pen_;
	    }
	  },
	
	  cleanUpFigure: function () /*figure*/{
	    // ...
	  },
	  _commitFigure$: function () {
	    var addedFigure = this._addedFigure;
	    if (!addedFigure) {
	      return (0, _gear.resolve)();
	    }
	
	    this.cleanUpFigure(addedFigure);
	    this._addedFigure = null;
	    return this.view.commit$();
	  },
	  _commit$: function () {
	    return this._commitFigure$();
	  },
	  _cancel$: function (view) {
	    view.remove(this._addedFigure);
	    return view.preview$();
	  },
	  on_pointerdown: function (_ref) {
	    var _this = this;
	
	    var view = _ref.view;
	    var event = _ref.event;
	    var docPoint = _ref.docPoint;
	    var which = _ref.which;
	
	    var leftClick = which === 1;
	
	    if (leftClick) {
	      (function () {
	        event.stopPropagation();
	
	        _this._minSize = view.viewDeltaToDoc(10);
	
	        _this._posDoc = docPoint;
	        _this._downPosDoc = _this._posDoc.clone();
	
	        var figure = _this._addedFigure = _this._figure.clone();
	        figure.bounds$().then(function (bounds) {
	
	          _this._initialWidth = view.viewDeltaToDoc(400);
	          _this._initialHeight = _this._initialWidth * bounds.height / bounds.width;
	          var initialBounds = _cdl.Bounds.ofPoints([_this._downPosDoc, _this._downPosDoc.plus_(_this._initialWidth, _this._initialHeight)]);
	
	          figure.fit$(initialBounds).then(function () {
	
	            _this._originalMatrix22 = figure.matrix22.clone();
	            _this._originalPin = figure.pin.clone();
	
	            view.add(figure);
	
	            _this.on_pointermove(event);
	          });
	        });
	      })();
	    }
	  },
	
	
	  on_pointermove: (0, _view.fastThrottle)(function (_ref2) {
	    var view = _ref2.view;
	    var event = _ref2.event;
	    var docPoint = _ref2.docPoint;
	    var cmdKey = _ref2.cmdKey;
	
	    var figure = this._addedFigure;
	    if (!figure) {
	      return;
	    }
	
	    this._posDoc = docPoint;
	
	    this._ctrlKey = cmdKey;
	    var t = this.computeTransform();
	
	    figure.matrix22 = this._originalMatrix22.clone();
	    figure.pin = this._originalPin.clone();
	
	    figure.transform(t);
	
	    view.preview$();
	  }, 10),
	
	  on_pointerup: function () {
	    this._commitFigure$();
	  },
	  computeTransform: function () {
	    var cp = this._posDoc,
	        dp = this._downPosDoc;
	    var bounds = _cdl.Bounds.ofPoints([cp, dp]);
	
	    var minSize = this._minSize;
	
	    var initialWidth = this._initialWidth,
	        initialHeight = this._initialHeight;
	
	    var nextWidth = bounds.width;
	    var nextHeight = bounds.height;
	
	    // Guard against to small figures
	    if (nextWidth < minSize) {
	      nextWidth = minSize;
	      if (cp.x < dp.x) {
	        bounds.lx = dp.x - minSize;
	      }
	    }
	    if (nextHeight < minSize) {
	      nextHeight = minSize;
	      if (cp.y < dp.y) {
	        bounds.ly = dp.y - minSize;
	      }
	    }
	
	    var sx = nextWidth / initialWidth,
	        sy = nextHeight / initialHeight;
	
	    if (this._ctrlKey) {
	      // Isometric locking
	      if (sx > sy) {
	        sy = sx;
	        if (cp.y < dp.y) {
	          bounds.ly = dp.y - initialHeight * sy;
	        }
	      } else {
	        sx = sy;
	        if (cp.x < dp.x) {
	          bounds.lx = dp.x - initialWidth * sx;
	        }
	      }
	    }
	
	    var lx_ly = bounds.lx_ly;
	
	    var transform = _cdl.Matrix.m(_cdl.Matrix.scaleFrom(lx_ly, sx, sy), _cdl.Matrix.translate(lx_ly.minus(dp)));
	    return transform;
	  }
	});
	
	_view.Tool.AddFigure = AddFigureTool;
	
	var DrawCurveTool = exports.DrawCurveTool = AddFigureTool.extend({ typeName: 'DrawCurveTool',
	  initTool: function (view, curve) {
	    var config = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	    if (!config.pen) {
	      config.pen = (0, _style.EmptyPen)();
	    }
	    if (!config.brush) {
	      config.brush = _view.Tool.defaultBrush();
	    }
	    var figure = _cdl.Shape.createFromCurve(curve, config);
	
	    this.callParent(view, figure, config);
	  },
	  cleanUpFigure: function (figure) {
	    // Apply transform to the polyregion
	    var matrix = figure._computeMatrix();
	
	    var polyregion = figure.polyregions[0];
	
	    polyregion.transform(matrix);
	    polyregion.renderFrame = null;
	    polyregion.renderMatrix = null;
	
	    var center = polyregion.bounds.center;
	    figure.anchor = (0, _cdl.AbsoluteAnchor)(center.clone());
	    figure.matrix22 = new _cdl.Matrix();
	    figure.pin = center.clone();
	  }
	});
	
	var DrawRectangleTool = exports.DrawRectangleTool = DrawCurveTool.extend({ typeName: 'DrawRectangleTool',
	  toolbarName: 'drawRectangleTool',
	  initTool: function (view, config) {
	    var curve = _cdl.Boundary.createRectangle((0, _lodash.assign)({ width: 500, height: 500 }, config));
	    this.callParent(view, curve, config);
	  }
	});
	_view.Tool.DrawRectangle = DrawRectangleTool;
	
	var DrawEllipseTool = exports.DrawEllipseTool = DrawCurveTool.extend({ typeName: 'DrawEllipseTool',
	  toolbarName: 'drawEllipseTool',
	  initTool: function (view, config) {
	    var curve = _cdl.Boundary.createEllipse((0, _lodash.assign)({ width: 500, height: 500 }, config));
	    this.callParent(view, curve, config);
	  }
	});
	_view.Tool.DrawEllipse = DrawEllipseTool;

/***/ },

/***/ 160:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.DrawShapeTool = exports.DrawTool = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _cdl = __webpack_require__(15);
	
	var _view = __webpack_require__(84);
	
	var redraw = function () {
	  this.view.redraw('tools');
	};
	
	var DrawTool = exports.DrawTool = _view.Tool.extend({ typeName: 'DrawTool',
	
	  Properties: {
	    pen: { type: 'Pen', def: _view.Tool.defaultPen(), onChange: redraw },
	    brush: { type: 'Brush', def: _view.Tool.defaultBrush(), onChange: redraw }
	  },
	
	  target: 'document',
	
	  type: 'Final',
	  toolbarName: 'drawTool',
	
	  initTool: function (view) {
	    var config = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    this._closedConfig = config.closed !== undefined ? config.closed : false;
	    this._flushShape();
	    this._flushPath();
	    this.closeDistance = 0.1 * 96;
	    this.editingDistance = 0.05 * 96;
	  },
	  _flushShape: function () {
	    this._paths = [];
	    this._closed = this._closedConfig;
	  },
	  _flushPath: function () {
	    this.toolhelp('Click to begin path', 'Enter or Double Click to commit, Esc to cancel');
	    this._nextPiece = null;
	    this._pieces = [];
	    this._redoPieces = [];
	    this._editingPiece = null;
	    this._initialPoint = null;
	  },
	  on_nextpiece: function () {
	    this.toolhelp('Click to add new point', 'Click and hold to add a curve', 'Click on the initial point to close', 'Double Click to leave open');
	  },
	  draw: function (_ref) {
	    var view = _ref.view;
	    var context = _ref.context;
	    var transform = _ref.transform;
	
	
	    // Draw semitransparent mask
	    // context.fillStyle = 'rgba(255,255,255,0.75)';
	    // view.fill(context);
	
	    var pieces = this._pieces.slice();
	    var pen = this._pen,
	        brush = this._brush;
	
	    var lastWasClosed = false;
	
	    var drawPath = function (closed) {
	      pen.setupContext(context, transform);
	      context.stroke();
	
	      if (closed) {
	        if (brush._type === 'Brush') {
	          context.fillStyle = brush._color.rgba;
	        } else {
	          // Draw temporary semitransparent mask
	          // Brush is applied to the Polyregion in commitChanges$()
	          // This way all brush types are supported
	          context.fillStyle = 'rgba(255,255,255,0.5)';
	        }
	
	        context.fill('evenodd');
	      }
	
	      context.beginPath();
	    };
	
	    context.beginPath();
	    var paths = 0;
	
	    for (var k = 0, kEnd = this._paths.length; k < kEnd; ++k) {
	      var paths_k = this._paths[k];
	      var closed = paths_k.closed;
	
	
	      if (closed !== lastWasClosed && paths > 0) {
	        drawPath(lastWasClosed);
	        paths = 0;
	      }
	
	      paths_k.draw(context, transform);
	      paths++;
	      lastWasClosed = closed;
	    }
	
	    var dotSize = view.viewDeltaToTexture(3);
	
	    if (this._drawing) {
	
	      var _closed = this._closed || this._pathIsClosed();
	
	      if (_closed !== lastWasClosed && paths > 0) {
	        drawPath(lastWasClosed);
	        paths = 0;
	      }
	
	      var ep = this._editingPiece;
	      if (ep) {
	        pieces.push(ep);
	      } else if (this._nextPiece && !_view.usingTouch) {
	        pieces.push(this._nextPiece);
	      }
	      if (pieces.length > 0) {
	        var curve = new _cdl.Curve(pieces, _closed); // Always false to show feedback on the missing part
	        curve.draw(context, transform);
	        paths++;
	
	        drawPath(_closed);
	        paths = 0;
	
	        context.lineWidth = view.viewDeltaToTexture(1);
	        context.strokeStyle = 'rgba(10,150,50,1.0)';
	
	        if (ep && ep instanceof _cdl.Cubic) {
	          context.beginPath();
	          var c1 = ep.P2,
	              c2 = ep.P3.plus(ep.P3.minus(ep.P2));
	          (0, _gear.strokeSegment)(context, c1, c2, transform);
	          context.fillStyle = 'rgba(10,100,30,1.0)';
	          (0, _gear.dot)(context, c1, dotSize, transform);
	          (0, _gear.dot)(context, c2, dotSize, transform);
	        } else if (this._lastPieceWasModified && this._pieces.length > 0) {
	          var piece = (0, _lodash.last)(this._pieces);
	          if (piece instanceof _cdl.Cubic) {
	            context.beginPath();
	            var _c = piece.P2,
	                _c2 = piece.P3.plus(piece.P3.minus(piece.P2));
	            (0, _gear.strokeSegment)(context, _c, _c2, transform);
	            context.stroke();
	          }
	        }
	      }
	    }
	
	    if (paths > 0) {
	      drawPath(lastWasClosed);
	    }
	
	    if (this._drawing) {
	      var l = this._nextPiece ? this._nextPiece.P0 : this._pieces.length > 0 ? (0, _lodash.last)(this._pieces).last() : null;
	      if (l) {
	        // Draw a dot in the last commited point, because we do not have pointer move feedback in touch
	        context.beginPath();
	        context.fillStyle = 'rgba(240,60,40,1.0)';
	        (0, _gear.dot)(context, l, dotSize, transform);
	      }
	    }
	  },
	  on_pointerdown: function (_ref2) {
	    var event = _ref2.event;
	    var isPrimary = _ref2.isPrimary;
	    var which = _ref2.which;
	    var docPoint = _ref2.docPoint;
	    var viewPoint = _ref2.viewPoint;
	
	
	    if (!isPrimary) {
	      return; // ignore multitouch
	    }
	
	    var leftClick = which === 1;
	    if (leftClick) {
	
	      event.stopPropagation();
	
	      this._downPos = viewPoint;
	
	      this._drawing = true;
	      this.on_nextpiece();
	
	      this._redoNextPiece = null;
	      this._redoPieces = [];
	      var np = docPoint;
	      this._currentPoint = np;
	
	      var nextPiece = this._nextPiece;
	      if (nextPiece) {
	        if (nextPiece.P2) {
	          nextPiece.P2 = np.clone();
	        }
	        nextPiece.last(np.clone());
	      }
	
	      if (this._pushPathIfClosed()) {
	        return;
	      }
	
	      if (!this._initialPoint) {
	        this._initialPoint = np.clone();
	      }
	
	      this._editingPiece = this._nextPiece;
	
	      this._nextPiece = new _cdl.Segment(np, np);
	
	      if (this._pieces.length > 0 && np.isEqual((0, _lodash.last)(this._pieces).P0)) {
	        this._nextPiece = null;
	        this._pushPath(this._closed);
	      }
	
	      this.redraw();
	    }
	    var rightClick = event.which === 3;
	    if (rightClick) {
	      event.stopPropagation();
	      this.commit$();
	    }
	  },
	  on_mousemove: function (event) {
	    this.on_pointermove(event);
	    event.stopPropagation();
	  },
	  on_pointermove: function (_ref3) {
	    var event = _ref3.event;
	    var view = _ref3.view;
	    var isPrimary = _ref3.isPrimary;
	
	    if (!isPrimary) {
	      return; // ignore multitouch
	    }
	    if (!this._drawing) {
	      return;
	    }
	
	    var editingDistance = this.editingDistance * _view.padScaling;
	
	    var np = event.docPoint;
	    this._currentPoint = np;
	
	    var pieces = this._pieces,
	        nextPiece = this._nextPiece;
	
	    if (!nextPiece && pieces.length > 0) {
	      var P0 = (0, _lodash.last)(pieces).last();
	      nextPiece = this._nextPiece = this._lastPieceWasModified ? new _cdl.Cubic(P0, np, np, np) : new _cdl.Segment(P0, np);
	      this._redoNextPiece = null;
	    }
	
	    var editingPiece = this._editingPiece;
	
	    if (editingPiece && !this._downPos.isNear(event.viewPoint, editingDistance)) {
	      if (editingPiece instanceof _cdl.Segment) {
	        this.toolhelp('Hold and move to change control point');
	        editingPiece = this._editingPiece = _cdl.Cubic.fromSegment(editingPiece.P0, editingPiece.P1);
	        editingPiece.P1 = editingPiece.P0.clone();
	      }
	      editingPiece.P2 = editingPiece.P3.plus(editingPiece.P3.minus(np));
	      this._editingPieceModified = true;
	    } else if (nextPiece) {
	      if (nextPiece.P2) {
	        nextPiece.P2 = np.clone();
	      }
	      nextPiece.last(np.clone());
	    }
	
	    this.redraw();
	  },
	  on_pointerup: function (_ref4) {
	    var event = _ref4.event;
	    var isPrimary = _ref4.isPrimary;
	
	    if (!isPrimary) {
	      return; // ignore multitouch
	    }
	    if (!this._drawing) {
	      return;
	    }
	
	    var editingDistance = this.editingDistance * _view.padScaling;
	
	    var editingPiece = this._editingPiece,
	        pieces = this._pieces;
	
	    if (editingPiece && !editingPiece.P0.isNear(editingPiece.last(), editingDistance)) {
	
	      pieces.push(editingPiece);
	
	      if (this._editingPieceModified) {
	        var lastPiece = (0, _lodash.last)(pieces);
	        var P0 = lastPiece.P3;
	        var PC = P0.plus(P0.minus(lastPiece.P2));
	        this._nextPiece = new _cdl.Cubic(P0, PC.clone(), PC.clone(), PC.clone());
	        this.on_nextpiece();
	      }
	    }
	    this._editingPiece = null;
	    this._lastPieceWasModified = this._editingPieceModified;
	    this._editingPieceModified = false;
	    this._downPos = null;
	    this.redraw();
	  },
	  on_dblclick: function () {
	    this.commit$();
	  },
	  undo: function () {
	    if (!this._drawing) {
	      if (this._paths.length > 0) {
	        this._redoPaths.push(this._paths.pop());
	      }
	      this.view.redraw('tools');
	    } else {
	      if (this._nextPiece) {
	        this._redoNextPiece = this._nextPiece;
	        this._nextPiece = null;
	      } else if (this._pieces.length > 0) {
	        this._redoPieces.push(this._pieces.pop());
	      }
	      this.view.redraw('tools');
	    }
	  },
	  redo: function () {
	    if (!this._drawing) {
	      if (this._redoPaths.length > 0) {
	        this._paths.push(this._redoPaths.pop());
	      }
	      this.view.redraw('tools');
	    } else {
	      if (this._redoPieces.length > 0) {
	        var rp = this._redoPieces.pop();
	        this._pieces.push(rp);
	        this._nextPiece = null;
	      } else if (this._redoNextPiece) {
	        this._nextPiece = this._redoNextPiece;
	        this._redotNextPiece = null;
	      }
	      this.view.redraw('tools');
	    }
	  },
	  _pathIsClosed: function () {
	    var view = this.view;
	
	
	    var ip = this._initialPoint,
	        cp = this._currentPoint;
	    return ip && cp && this._pieces.length > 0 && ip.isNear(cp, view.viewDeltaToDoc(this.closeDistance) * _view.padScaling);
	  },
	  _pushPathIfClosed: function () {
	    if (this._pathIsClosed()) {
	      if (this._nextPiece) {
	        this._nextPiece.last(this._initialPoint);
	        this._pieces.push(this._nextPiece);
	        this._nextPiece = this._editingPiece = null;
	      }
	      var closed = true;
	      this._pushPath(closed);
	      return true;
	    }
	    return false;
	  },
	  _pushPath: function (closed) {
	    if (closed === undefined) {
	      if (this._pushPathIfClosed()) {
	        return (0, _gear.resolve)();
	      } else {
	        closed = false;
	      }
	    }
	
	    var pieces = this._pieces;
	
	    var nextPiece = this._nextPiece;
	    if (nextPiece && !nextPiece.P0.isEqual(nextPiece.last())) {
	      pieces.push(nextPiece.clone());
	    }
	
	    this._pieces = [];
	    if (pieces.length >= 1) {
	      if (closed && !pieces[0].P0.isEqual((0, _lodash.last)(pieces).last())) {
	        pieces.push(new _cdl.Segment(nextPiece.last(), pieces[0].P0));
	      }
	
	      var curve = _cdl.Curve.fromNonTiedPieces(pieces, closed);
	      this._paths.push(curve);
	      this.view.redraw('tools');
	    }
	
	    this._flushPath();
	
	    // Force a commit after each path
	    return this.commitChanges$();
	  },
	  _cancel$: function () {
	    // Nothing to do...
	  },
	  commit$: function () {
	    if (this._drawing && this._pieces.length > 0) {
	      return this._pushPath(this._closed);
	    } else {
	      return this.callParent();
	    }
	  },
	  _commit$: function () {
	    this.commitChanges$();
	  },
	  commitChanges$: function () {
	    var view = this.view;
	    if (this._paths.length === 0) {
	      return;
	    }
	    var pen = this._pen,
	        brush = this._brush;
	
	    var polyregions = [];
	    var pushPolyregion = function (regions, closed) {
	      var polyregion = new _cdl.Polyregion({ regions: regions, pen: pen, fillMode: 'Alternate' });
	      if (closed) {
	        polyregion.brush = brush;
	      }
	      polyregions.push(polyregion);
	    };
	
	    var regions = [];
	    var lastWasClosed = false;
	
	    for (var k = 0, kEnd = this._paths.length; k < kEnd; ++k) {
	      var paths_k = this._paths[k];
	      var closed = paths_k.closed;
	      if (closed !== lastWasClosed && regions.length > 0) {
	        pushPolyregion(regions, lastWasClosed);
	        regions = [];
	      }
	      var region = new _cdl.Region([paths_k]);
	      regions.push(region);
	      lastWasClosed = closed;
	    }
	
	    if (regions.length > 0) {
	      pushPolyregion(regions, lastWasClosed);
	    }
	    var anchor = _cdl.Bounds.ofThings(polyregions).center;
	    view.add((0, _cdl.Shape)({ polyregions: polyregions,
	      anchor: (0, _cdl.AbsoluteAnchor)(anchor),
	      pin: anchor.clone() }));
	
	    this._flushPath();
	    this._flushShape();
	    view.keepSelection();
	    return view.commit$();
	  }
	});
	_view.Tool.Draw = DrawTool;
	
	var DrawShapeTool = exports.DrawShapeTool = DrawTool.extend({ typeName: 'DrawShapeTool',
	  init: function () {
	    var config = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    config.closed = true;
	    this.callParent(config);
	  }
	});
	_view.Tool.DrawShape = DrawShapeTool;

/***/ },

/***/ 161:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FreeDrawTool = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _cdl = __webpack_require__(15);
	
	var _view = __webpack_require__(84);
	
	var distance2 = _cdl.Point.distance2;
	var FreeDrawTool = exports.FreeDrawTool = _view.Tool.extend({ typeName: 'FreeDrawTool',
	
	  Properties: {
	    pen: { type: 'Pen', def: _view.Tool.defaultPen(), onChange: function () {
	        this.redraw();
	      }
	    },
	    brush: { type: 'Brush', def: _view.Tool.defaultBrush(), onChange: function () {
	        this.redraw();
	      }
	    },
	    detectCorners: { type: 'boolean', def: true }
	  },
	
	  type: 'Final',
	  toolbarName: 'freeDrawTool',
	
	  Modes: { 0: 'Free', 1: 'Rectangle', 2: 'Circle' },
	
	  initTool: function (view) {
	    var config = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	    this._bind('switchCorners');
	
	    this._closedConfig = config.closed !== undefined ? config.closed : false;
	    this.flushShape();
	    this._mode = 0; // 'Free'
	    this.closeDistance = 0.1 * 96;
	    this.flushCurrentPath();
	  },
	  flushShape: function () {
	    this._closed = this._closedConfig;
	    this._paths = [];
	    this._redoPaths = [];
	  },
	  switchCorners: function () {
	    this._detectCorners = !this._detectCorners;
	    // this.updateActions();
	  },
	  draw: function (_ref) {
	    var view = _ref.view;
	    var context = _ref.context;
	    var transform = _ref.transform;
	
	
	    // Draw semitransparent mask
	    //context.fillStyle = 'rgba(255,255,255,0.75)';
	    //fillContext(context);
	
	    this._pen.setupContext(context, transform);
	
	    var brush = this._brush,
	        solidBrush = brush._type === 'Brush';
	
	    if (solidBrush) {
	      context.fillStyle = brush._color.rgba;
	    } else {
	      // Draw temporary semitransparent mask
	      // Brush is applied to the Polyregion in commitChanges$()
	      // This way all brush types are supported
	      context.fillStyle = 'rgba(255,255,255,0.5)';
	    }
	
	    context.beginPath();
	
	    var paths = (0, _gear.clone)(this._paths);
	
	    if (this.inMode('Free')) {
	      var currentPoints = (0, _gear.clone)(this._points);
	      if (this._nextPoint) {
	        currentPoints.push(this._nextPoint);
	      }
	      if (currentPoints.length > 1) {
	        paths.push(currentPoints);
	      }
	    } else if (this._drawing) {
	      var stampPath = this.stampPath();
	      if (stampPath) {
	        paths.push(stampPath);
	      }
	    }
	
	    var lastIsClosed = false;
	
	    for (var k = 0, kEnd = paths.length; k < kEnd; ++k) {
	
	      var paths_k = paths[k];
	
	      var isCurve = paths_k instanceof _cdl.Curve;
	
	      var closed = isCurve || this._closed || paths_k[0].isNear((0, _lodash.last)(paths_k), this.closeDistance / transform.scaleFactor() * _view.padScaling);
	
	      if (!closed && lastIsClosed) {
	        context.stroke();
	        if (solidBrush) {
	          context.fill('evenodd');
	        }
	        context.beginPath();
	      }
	
	      if (paths_k instanceof _cdl.Curve) {
	        paths_k.draw(context, transform);
	      } else {
	        var path = (0, _lodash.map)(paths_k, function (p) {
	          return transform.apply(p);
	        });
	        var length = path.length - 1;
	
	        path.unshift(path[0]);
	        path.push(path[path.length - 1]);
	
	        if (length <= 0) {
	          return;
	        }
	        for (var n = 0; n < length; n++) {
	          var p1 = path[n],
	              p2 = path[n + 1],
	              p3 = path[n + 2],
	              p4 = path[n + 3];
	
	          if (n === 0) {
	            context.moveTo(p2.x, p2.y);
	          }
	          if (!(0, _gear.areEqual)(p2, p3)) {
	            context.bezierCurveTo(p2.x + (p3.x - p1.x) / 6, p2.y + (p3.y - p1.y) / 6, p3.x + (p2.x - p4.x) / 6, p3.y + (p2.y - p4.y) / 6, p3.x, p3.y);
	          }
	        }
	
	        if (closed) {
	          context.closePath();
	        } else {
	          context.stroke();
	          context.beginPath();
	        }
	        lastIsClosed = closed;
	      }
	    }
	    if (lastIsClosed) {
	      context.stroke();
	      if (solidBrush) {
	        context.fill('evenodd');
	      }
	      context.beginPath();
	    }
	  },
	  switchMode: function () {
	    this._mode++;
	    if (this._mode >= (0, _lodash.size)(this.Modes)) {
	      this._mode = 0;
	    }
	    this.redraw();
	  },
	  inMode: function (m) {
	    return this.Modes[this._mode] === m;
	  },
	  stampBounds: function () {
	    return _cdl.Bounds.ofPoints([this._pointDown, this._pointTo]);
	  },
	  stampPath: function () {
	    if ((0, _gear.areEqual)(this._pointDown, this._pointTo)) {
	      return null;
	    }
	    var bounds = this.stampBounds();
	    if (this.inMode('Rectangle')) {
	      return _cdl.Boundary.createRectangle(bounds);
	    } else if (this.inMode('Circle')) {
	      return _cdl.Boundary.createEllipse(bounds);
	    }
	    return null;
	  },
	  on_pointerdown: function (_ref2) {
	    var event = _ref2.event;
	    var isPrimary = _ref2.isPrimary;
	    var which = _ref2.which;
	    var docPoint = _ref2.docPoint;
	
	    if (isPrimary === false) {
	      return; // ignore multitouch
	    }
	    var t = (0, _lodash.now)();
	    if (t - this._lastTime < 500) {
	      this.commit$();
	      return;
	    }
	
	    event.stopPropagation();
	
	    this._lastTime = t;
	
	    var leftClick = which === 1;
	    if (leftClick) {
	      this.toolhelp('Hold and move to draw path', 'Release near initial point to close');
	      this._drawing = true;
	      var np = docPoint;
	
	      if (this.inMode('Free')) {
	
	        this._points.push(np);
	        this._lastTime = t;
	
	        this._pointsR.push(np);
	        this._lastTimeR = t;
	      } else {
	        this._pointDown = np;
	        this._pointTo = np;
	      }
	
	      this.redraw();
	      this._redoPaths = [];
	    }
	  },
	  on_pointermove: function (_ref3) {
	    var event = _ref3.event;
	    var view = _ref3.view;
	    var isPrimary = _ref3.isPrimary;
	    var cmdKey = _ref3.cmdKey;
	
	    if (!isPrimary) {
	      return; // ignore multitouch
	    }
	
	    var ctrl = this._ctrl = cmdKey;
	    if (this._drawing) {
	      var points = this._points,
	          pointsR = this._pointsR;
	
	      var t = (0, _lodash.now)();
	      var docPoint = event.docPoint;
	
	
	      if (this.inMode('Free')) {
	
	        if (this._detectCorners) {
	
	          if (t - this._lastTimeR > 25) {
	
	            var lp = (0, _lodash.last)(pointsR);
	
	            var deltaVL = view.viewDeltaToDoc(3);
	
	            if (distance2(docPoint, lp) > deltaVL * deltaVL) {
	              var lp3TimeR = this._lastTimeRPrevPrev;
	
	              pointsR.push(docPoint);
	
	              this._lastTimeRPrevPrev = this._lastTimeRPrev;
	              this._lastTimeRPrev = this._lastTimeR;
	              this._lastTimeR = t;
	
	              var delta = view.viewDeltaToDoc(14),
	                  delta2 = delta * delta;
	
	              var pointsR_length = pointsR.length;
	              if (pointsR_length > 7) {
	
	                var lp0 = pointsR[pointsR_length - 1];
	                var lp1 = pointsR[pointsR_length - 2];
	                var lp2 = pointsR[pointsR_length - 3];
	                var lp3 = pointsR[pointsR_length - 4];
	                var lp4 = pointsR[pointsR_length - 5];
	                var lp5 = pointsR[pointsR_length - 6];
	                var lp6 = pointsR[pointsR_length - 7];
	
	                var turnAngle1 = _cdl.Point.turnAngle(lp2.minus(lp3), lp3.minus(lp4));
	
	                var turnAngle2 = _cdl.Point.turnAngle(lp0.minus(lp3).add(lp1.minus(lp3).add(lp2.minus(lp3))), lp3.minus(lp6).add(lp3.minus(lp5).add(lp3.minus(lp6))));
	
	                if (Math.abs(turnAngle1) > 50 && Math.abs(turnAngle2) > 75) {
	                  if (!(0, _lodash.last)(points).__corner__ && (lp3TimeR < this._lastTime || distance2((0, _lodash.last)(points), lp3) < delta2)) {
	                    points.pop();
	                  }
	                  if (points.length > 0 && !(0, _lodash.last)(points).__corner__ && (lp3TimeR < this._lastTimePrev || distance2((0, _lodash.last)(points), lp3) < delta2)) {
	                    points.pop();
	                  }
	                  while (points.length > 0 && !(0, _lodash.last)(points).__corner__ && distance2((0, _lodash.last)(points), lp3) < delta2) {
	                    points.pop();
	                  }
	
	                  var lpd3 = pointsR[pointsR.length - 4];
	                  points.push(lpd3);
	                  points.push(lpd3);
	                  lpd3.__corner__ = true;
	                }
	              }
	            }
	          }
	        }
	
	        if (ctrl && points.length > 2) {
	          var l = points.length;
	          if (!(0, _gear.areEqual)(points[l - 1], points[l - 2])) {
	            points.push(points[l - 1]);
	            points[l - 1].__corner__ = true;
	          }
	          this._nextPoint = docPoint;
	          this.redraw();
	        } else if (t - this._lastTime > 40) {
	          var _delta = view.viewDeltaToDoc(17);
	          if (distance2(docPoint, (0, _lodash.last)(points)) > _delta * _delta) {
	            points.push(docPoint);
	            this.redraw();
	            this._lastTimePrev = this._lastTime;
	            this._lastTime = t;
	            this._nextPoint = null;
	          }
	        }
	        if (this._lastTime !== t) {
	          this._nextPoint = docPoint;
	          this.redraw();
	        }
	      } else {
	        this._pointTo = docPoint;
	        if (ctrl) {
	          var w = this._pointTo.x - this._pointDown.x;
	          var h = this._pointTo.y - this._pointDown.y;
	          if (w && h) {
	            var wa = Math.abs(w);
	            var ha = Math.abs(h);
	            if (wa > ha) {
	              this._pointTo.y = this._pointDown.y + h * wa / ha;
	            } else if (ha > wa) {
	              this._pointTo.x = this._pointDown.x + w * ha / wa;
	            }
	          }
	        }
	        this.redraw();
	      }
	    }
	  },
	  on_pointerup: function (event) {
	    if (event.isPrimary === false) {
	      return; // ignore multitouch
	    }
	    if (!this._drawing) {
	      return;
	    }
	
	    if (this.inMode('Free')) {
	      var np = this._nextPoint;
	      if (np && !np.isEqual((0, _lodash.last)(this._points))) {
	        this._points.push(np);
	      }
	      if (this._points.length > 2) {
	        this._paths.push(this._points);
	      }
	    } else {
	      var stampPath = this.stampPath();
	      if (stampPath) {
	        this._paths.push(stampPath);
	      }
	    }
	    this.flushCurrentPath();
	    this.commitChanges$();
	  },
	  flushCurrentPath: function () {
	    this.toolhelp('Click and hold to draw path');
	    this._redoPaths = [];
	    this._points = [];
	    this._pointsR = [];
	    this._nextPoint = null;
	    this._drawing = false;
	    this._ctrl = false;
	  },
	  catmull2beziers: function (points) {
	    var path = points.slice(0);
	
	    var length = path.length - 1;
	
	    path.splice(0, 0, path[0]);
	    path.push(path[path.length - 1]);
	
	    var pieces = [];
	    if (length <= 0) {
	      return;
	    }
	    for (var n = 0; n < length; n++) {
	      var p1 = path[n],
	          p2 = path[n + 1],
	          p3 = path[n + 2],
	          p4 = path[n + 3];
	
	      if (!(0, _gear.areEqual)(p2, p3)) {
	        var q1 = p2.clone(),
	            q2 = new _cdl.Point(p2.x + (p3.x - p1.x) / 6, p2.y + (p3.y - p1.y) / 6),
	            q3 = new _cdl.Point(p3.x + (p2.x - p4.x) / 6, p3.y + (p2.y - p4.y) / 6),
	            q4 = p3.clone();
	
	        pieces.push(new _cdl.Cubic(q1, q2, q3, q4));
	      }
	    }
	    return pieces;
	  },
	  undo: function () {
	    if (!this._drawing) {
	      if (this._paths.length > 0) {
	        this._redoPaths.push(this._paths.pop());
	      }
	      this.redraw();
	    }
	  },
	  redo: function () {
	    if (!this._drawing) {
	      if (this._redoPaths.length > 0) {
	        this._paths.push(this._redoPaths.pop());
	      }
	      this.redraw();
	    }
	  },
	  _cancel$: function () {
	    // Nothing to do...
	  },
	  _commit$: function () {
	    return this.commitChanges$();
	  },
	  commitChanges$: function () {
	    var _this = this;
	
	    var view = this.view,
	        paths = this._paths;
	    if (paths.length > 0) {
	      var _ret = function () {
	
	        var pen = _this._pen,
	            brush = _this._brush;
	
	        var polyregions = [];
	        var addPolyregion = function (regions, closed) {
	
	          var polyregion = new _cdl.Polyregion({ regions: regions, fillMode: 'Alternate', pen: pen });
	          if (closed) {
	            polyregion.brush = brush;
	          }
	          polyregions.push(polyregion);
	        };
	
	        var regions = [];
	        var lastWasClosed = false;
	        for (var k = 0, kEnd = paths.length; k < kEnd; ++k) {
	          var paths_k = paths[k];
	          var isCurve = paths_k instanceof _cdl.Curve;
	
	          var curve = void 0;
	
	          // [TODO] We need to perform this check at the mousemove level, and not here.
	          var closed = isCurve || _this._closed || paths_k[0].isNear((0, _lodash.last)(paths_k), _this.view.viewDeltaToDoc(_this.closeDistance) * _view.padScaling);
	
	          if (closed !== lastWasClosed && regions.length > 0) {
	            addPolyregion(regions, lastWasClosed);
	            regions = [];
	          }
	
	          if (isCurve) {
	            curve = paths_k;
	          } else {
	            var pieces = _this.catmull2beziers(paths_k);
	            curve = _cdl.Curve.fromNonTiedPieces(pieces, closed);
	          }
	          var region = new _cdl.Region([curve]);
	          regions.push(region);
	
	          lastWasClosed = closed;
	        }
	
	        if (regions.length > 0) {
	          addPolyregion(regions, lastWasClosed);
	          regions = [];
	        }
	
	        var anchor = _cdl.Bounds.ofThings(polyregions).center;
	
	        view.add((0, _cdl.Shape)({ polyregions: polyregions,
	          anchor: (0, _cdl.AbsoluteAnchor)(anchor),
	          pin: anchor.clone() }));
	
	        _this.flushShape();
	        view.keepSelection();
	        return {
	          v: view.commit$()
	        };
	      }();
	
	      if (typeof _ret === "object") return _ret.v;
	    }
	  }
	});
	
	_view.Tool.FreeDraw = FreeDrawTool;

/***/ },

/***/ 162:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EditTextTool = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _cdl = __webpack_require__(15);
	
	var _view = __webpack_require__(84);
	
	var _style = __webpack_require__(29);
	
	var updateBrush = function () {
	  var brush = this._brush,
	      text = this._text;
	
	  this._baseText.brush = brush;
	
	  if (text) {
	    text.brush = brush;
	    this.view.commit$();
	  }
	};
	
	var updatePen = function () {
	  var pen = this._pen,
	      text = this._text;
	
	  this._baseText.pen = pen;
	
	  if (text) {
	    text.pen = pen;
	    this.view.commit$();
	  }
	};
	
	var EditTextTool = exports.EditTextTool = _view.Tool.extend({ typeName: 'EditTextTool',
	
	  Properties: {
	    pen: { type: 'Pen', def: (0, _style.EmptyPen)(), onChange: updatePen },
	    brush: { type: 'Brush', def: _view.Tool.defaultBrush(), onChange: updateBrush }
	  },
	
	  type: 'Final',
	  toolbarName: 'textTool',
	
	  initTool: function (view, text) {
	    var config = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
	    var _this = this;
	    _this._cursorOn = true;
	    _this.reset();
	    _this._baseText = new _cdl.Text({ text: '',
	      brush: _this._brush,
	      fontSize: view.viewDeltaToDoc(30), // [TODO] do we want a stable one?
	      pen: _this._pen
	    });
	    var baseTextUpdate = _this._baseText.update$();
	    return text ? this.startEdit(text, config.event) : baseTextUpdate;
	  },
	  reset: function () {
	    var _this = this;
	    _this._cursor = null;
	    _this._cursorEnd = null;
	    _this._center = null;
	    _this._currentChar = 0;
	    _this._currentLine = 0;
	    _this._changed = false;
	    _this._text = null;
	  },
	  link: function (view) {
	    var _this = this;
	    view.cursor = 'text';
	    _this._interval = setInterval(function () {
	      _this._cursorOn = !_this._cursorOn;
	      _this.view.redraw('tools');
	    }, 500);
	  },
	  unlink: function (view) {
	    clearInterval(this._interval);
	    view.cursor = 'default';
	  },
	  _commit$: function (view, doc) {
	    if (!this._center) {
	      return;
	    }
	    var text = this._text;
	    if (text.isEmpty) {
	      doc.remove(text);
	    } else {
	      view.selectedFigures = [text];
	    }
	    return doc.commit$();
	  },
	  _cancel$: function (view) {
	    return view.revert$();
	  },
	  canEdit: function (figure) {
	    return EditTextTool.canEdit(figure);
	  },
	  startEdit: function (text, event) {
	    var _this2 = this;
	
	    var _this = this,
	        view = _this.view;
	    if (_this.canEdit(text)) {
	      _this._text = text;
	      _this._center = text.pin;
	      return text.update$().then(function () {
	        if (event) {
	          var point = event.docPoint;
	          _this.findCurrentChar(point);
	        } else {
	          _this._currentChar = text.lines[0].length;
	          _this._currentLine = 0;
	        }
	        _this.findCursor();
	        _this2.triggerKeyboard(event);
	        view.preview$();
	      });
	    } else {
	      _this.reset();
	      view.fireEvent('textedit', view, text, event);
	    }
	  },
	  on_pointerdown: function (_ref) {
	    var _this3 = this;
	
	    var event = _ref.event;
	    var view = _ref.view;
	    var which = _ref.which;
	    var docPoint = _ref.docPoint;
	
	    var _this = this;
	    (0, _gear.if$)(_this._text && _this._changed, function () {
	
	      var text = _this._text;
	      _this.reset();
	      if (text.isEmpty) {
	        view.remove(text);
	      }
	      view.keepSelection();
	      return view.commit$();
	    }).then(function () {
	
	      var leftClick = which === 1;
	
	      if (leftClick) {
	        var point = docPoint;
	
	        var figure = event.figure; // [EVENTS] view.figureAtPoint(point);
	        if (figure && figure.isText) {
	          _this.startEdit(figure, event);
	        } else {
	          _this._text = _this._baseText.clone();
	          _this._text.fontSize = view.viewDeltaToDoc(30);
	          var center = _this._center = point;
	          _this._text.pin = center;
	          _this._currentChar = 0;
	          _this._currentLine = 0;
	          _this._changed = true;
	          _this.findCursor();
	          _this3.triggerKeyboard(event);
	          view.add(_this._text); // We need a better abstraction here
	          view.preview$();
	        }
	      }
	    });
	  },
	  on_keydown: function (_ref2) {
	    var event = _ref2.event;
	    var cmdKey = _ref2.cmdKey;
	    var which = _ref2.which;
	
	
	    // console.log('edit text - keydown');
	
	    var _this = this;
	    var currentChar = _this._currentChar;
	    var currentLine = _this._currentLine;
	    var keyHome = which === 36,
	        keyEnd = which === 35;
	
	    if (which === 27) {
	      event.stopPropagation();
	      return this.commit$();
	    }
	
	    var figure = _this._text;
	
	    if (!figure) {
	      return;
	    }
	
	    var lines = figure.lines;
	    var line = lines[currentLine];
	
	    if (which === 13) {
	      // Enter
	      event.stopPropagation();
	
	      if (_this._text.isEmpty) {
	        return;
	      }
	
	      if ((0, _lodash.find)(figure._processes, function (p) {
	        return p instanceof _cdl.Process.FitOnPath || p instanceof _cdl.Process.FitEllipse || p instanceof _cdl.Process.ClassicArc || p instanceof _cdl.Process.FitEnvelope;
	      })) {
	        // Do not accept line break
	        return;
	      }
	
	      _this._changed = true;
	      lines[currentLine] = line.slice(0, currentChar);
	      lines.splice(currentLine + 1, 0, "");
	      lines[currentLine + 1] = line.slice(currentChar);
	      figure.lines = lines;
	      if (currentChar > 0) {
	        _this._currentLine++;
	        _this._currentChar = 0;
	      }
	      _this.updateText();
	    } else if (which === 8) {
	      // Backspace
	      event.preventDefault();
	      if (currentChar > 0) {
	        _this._changed = true;
	        lines[currentLine] = line.slice(0, currentChar - 1) + line.slice(currentChar);
	        figure.lines = lines;
	        _this._currentChar--;
	        _this.updateText();
	      } else if (currentChar === 0 && currentLine > 0) {
	        _this._changed = true;
	        _this._currentChar = lines[currentLine - 1].length;
	        _this._currentLine--;
	        lines[currentLine - 1] = lines[currentLine - 1] + lines[currentLine];
	        lines.splice(currentLine, 1);
	        figure.lines = lines;
	        _this.updateText();
	      }
	    } else if (which === 46) {
	      // Delete
	      event.stopPropagation();
	      if (currentChar < line.length) {
	        _this._changed = true;
	        lines[currentLine] = line.slice(0, currentChar) + line.slice(currentChar + 1);
	        figure.lines = lines;
	        _this.updateText();
	      } else if (currentChar === line.length && currentLine < lines.length) {
	        _this._changed = true;
	        lines[currentLine] = lines[currentLine] + lines[currentLine + 1];
	        lines.splice(currentLine + 1, 1);
	        figure.lines = lines;
	        _this.updateText();
	      }
	    } else if (which === 37 || keyHome) {
	      // Left arrow
	      event.stopPropagation();
	      if (currentChar > 0) {
	        if (cmdKey || keyHome) {
	          _this._currentChar = 0;
	        } else {
	          _this._currentChar--;
	        }
	        _this.updateText();
	      }
	    } else if (which === 39 || keyEnd) {
	      // Right arrow
	      event.stopPropagation();
	      if (currentChar < line.length) {
	        if (cmdKey || keyEnd) {
	          _this._currentChar = line.length;
	        } else {
	          _this._currentChar++;
	        }
	        _this.updateText();
	      }
	    } else if (which === 38) {
	      // Up
	      event.stopPropagation();
	      if (currentLine > 0) {
	        _this._currentLine--;
	        _this._currentChar = Math.floor(lines[_this._currentLine].length / 2);
	        _this.updateText();
	      }
	    } else if (which === 40) {
	      // Down
	      event.stopPropagation();
	      if (currentLine < lines.length - 1) {
	        _this._currentLine++;
	        _this._currentChar = Math.floor(lines[_this._currentLine].length / 2);
	        _this.updateText();
	      }
	    }
	  },
	  on_keypress: function (_ref3) {
	    var event = _ref3.event;
	    var which = _ref3.which;
	    var char = _ref3.char;
	
	    // console.log('edit text - keypress');
	    var _this = this;
	    if (!_this._text) {
	      return;
	    }
	    event.stopPropagation();
	    if (which === 13) {
	      // We handle Enter on keydown
	      return;
	    }
	
	    var currentChar = _this._currentChar,
	        currentLine = _this._currentLine;
	    var figure = _this._text;
	    var lines = figure.lines;
	
	    var line = lines[currentLine];
	
	    _this._changed = true;
	    lines[currentLine] = line.slice(0, currentChar) + char + line.slice(currentChar);
	    figure.lines = lines;
	    _this._currentChar++;
	
	    _this.updateText();
	  },
	  updateText: function () {
	    var _this = this,
	        view = _this.view,
	        text = _this._text;
	
	    text.update$().then(function () {
	      _this.findCursor();
	
	      view.preview$();
	    });
	  },
	  findCurrentChar: function (point) {
	    var figure = this._text;
	    if (figure.isEmpty) {
	      this._currentChar = 0;
	      this._currentLine = 0;
	    } else {
	      var matrix = figure.matrix_(),
	          tp = matrix.inverted().apply(point),
	          layout = figure._textLayout,
	          textLines = layout.textLines();
	
	      var currentChar = 0,
	          currentLine = 0,
	          minDist = Number.MAX_VALUE;
	
	      for (var kl = 0, klEnd = textLines.length; kl < klEnd; ++kl) {
	
	        var textLine = textLines[kl],
	            lineChars = textLine.allChars(),
	            charsLength = lineChars.length;
	
	        if (textLine._chars.length > 0) {
	          // there should be at least one proper glyph (do not use _allChars here)
	          var dToEnd = _cdl.Point.distance2(this.closerGlyph(lineChars, charsLength - 1)._baselineRightGrip, tp);
	          if (dToEnd < minDist) {
	            minDist = dToEnd;
	            currentChar = charsLength;
	            currentLine = kl;
	          }
	          for (var kc = 0; kc < charsLength; kc++) {
	            var char = lineChars[kc];
	            if (char) {
	              var d = _cdl.Point.distance2(char._grip, tp);
	              if (d < minDist) {
	                minDist = d;
	                currentChar = kc;
	                currentLine = kl;
	              }
	            }
	          }
	        } else {
	          var baseDist = _cdl.Point.distance2(textLine._baseline.P0, tp);
	          if (baseDist < minDist) {
	            minDist = baseDist;
	            currentChar = 0;
	            currentLine = kl;
	          }
	        }
	      }
	      this._currentChar = currentChar;
	      this._currentLine = currentLine;
	    }
	  },
	  closerGlyph: function (allChars, pos) {
	    var count = allChars.length;
	    var char = allChars[pos],
	        n = pos - 1;
	    while (!char && n >= 0) {
	      char = allChars[n--];
	    }
	    n = pos + 1;
	    while (!char && n < count) {
	      char = allChars[n++];
	    }
	    return char;
	  },
	  findCursor: function () {
	    var figure = this._text,
	        center = this._center;
	    var fontSize = figure.fontSize;
	    var matrix = figure.matrix_();
	    if (figure.isEmpty) {
	      this._cursor = center;
	      this._cursorEnd = matrix.apply(matrix.inverted().apply(center).plus_(0, fontSize));
	    } else {
	      var currentChar = this._currentChar;
	      var layout = figure._textLayout;
	      var line = layout.textLines()[this._currentLine];
	      var allChars = line.allChars();
	      var bs = line._baseline;
	      if (line._chars.length > 0) {
	        // If there is a proper glyph
	        var char = this.closerGlyph(allChars, currentChar);
	        var before = char._originalIdx <= currentChar;
	        var grip = before ? char._baselineRightGrip : char._grip;
	        var frameDirX = char._frame.dir_x;
	        var c = grip.plus(frameDirX.scaled(fontSize / 20 * (before ? 1 : -1)));
	        this._cursor = matrix.apply(c);
	
	        if (figure._processes.length > 0) {
	          var frame = char._frame;
	          var cursorH = before ? frame.p2.minus(frame.p1) : frame.p3.minus(frame.p0);
	          this._cursorEnd = matrix.apply(c.plus(cursorH));
	        } else {
	          this._cursorEnd = matrix.apply(c.plus(bs.P1.minus(bs.P0).normalize().perpendicular().sm(fontSize)));
	        }
	      } else {
	        this._cursor = matrix.apply(bs.P0);
	        this._cursorEnd = matrix.apply(bs.P0.plus(bs.P1.minus(bs.P0).normalize().perpendicular().sm(fontSize)));
	      }
	    }
	    this.view.redraw('tools');
	  },
	  drawCursorLine: function (context, transform, lineWidth, strokeStyle) {
	    context.lineWidth = lineWidth;
	    context.strokeStyle = strokeStyle;
	    (0, _gear.strokeSegment)(context, this._cursor, this._cursorEnd, transform);
	  },
	  draw: function (_ref4) {
	    var view = _ref4.view;
	    var context = _ref4.context;
	    var transform = _ref4.transform;
	
	    var center = this._center;
	    if (!center || !this._cursorOn || !this._cursor) {
	      return;
	    }
	    var textureScale = view.viewDeltaToTexture(1);
	    this.drawCursorLine(context, transform, 3 * textureScale, "#dbdbdb");
	    this.drawCursorLine(context, transform, 1 * textureScale, "#248e1f");
	  }
	});
	
	_view.Tool.Text = _view.Tool.EditText = EditTextTool;
	
	EditTextTool.canEdit = function (figure) {
	  return figure.isText && figure.canBeProcessedLocally() && !figure.isMultiPart;
	};

/***/ },

/***/ 163:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CharsTransformTool = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _cdl = __webpack_require__(15);
	
	var _view = __webpack_require__(84);
	
	var CharsTransformTool = exports.CharsTransformTool = _view.Tool.extend({ typeName: 'CharsTransformTool',
	  type: 'Final',
	  toolbarName: 'charsTransformTool',
	  initTool: function (view, text) {
	    var _this = this;
	    _this._char = null;
	    _this._text = null;
	
	    if (text && _this.canEdit(text)) {
	      _this._text = text;
	      return _this.updateText$();
	    }
	  },
	  canEdit: function (figure) {
	    return figure.isText && figure.canBeProcessedLocally() && (0, _lodash.every)(figure.processes, function (p) {
	      return p.outputsText();
	    }) && !figure.isMultiPart;
	  },
	  updateText$: function () {
	    var _this = this;
	    return _this._text.update$().then(function () {
	      _this._matrix = _this._text.matrix_();
	      _this.view.redraw('tools');
	    });
	  },
	  link: function (view) {
	    view.cursor = 'pointer';
	  },
	  unlink: function (view) {
	    view.cursor = 'default';
	  },
	  _commit$: function (view, doc) {
	    var text = this._text;
	    if (text) {
	      view.selectedFigures = [text];
	    }
	    return doc.commit$();
	  },
	  _cancel$: function (view) {
	    return view.revert$();
	  },
	  on_pointerdown: function (_ref) {
	    var view = _ref.view;
	    var event = _ref.event;
	    var which = _ref.which;
	    var docPoint = _ref.docPoint;
	
	    var _this = this;
	    var leftClick = which === 1;
	    if (leftClick) {
	      var _ret = function () {
	        var point = docPoint;
	
	        var text = _this._text;
	        if (text) {
	          var char = _this._char = text.charAtPoint_(point);
	          if (char) {
	            event.stopPropagation();
	            _this._point = point;
	            _this._downPoint = point.clone();
	            var matrix = text.matrix_();
	            _this._charGrip = matrix.apply(char._grip);
	            _this.view.redraw('tools');
	            return {
	              v: void 0
	            };
	          }
	        }
	
	        var figure = event.figure; // [EVENTS] view.figureAtPoint(point);
	        if (figure && _this.canEdit(figure)) {
	          event.stopPropagation();
	          (0, _gear.if$)(_this._changed, function () {
	            _this._changed = false;
	            return view.commit$();
	          }).then(function () {
	            _this._text = figure;
	            _this.updateText$();
	          });
	        } else {
	          _this._point = _this._downPoint = null;
	          _this.view.redraw('tools');
	        }
	      }();
	
	      if (typeof _ret === "object") return _ret.v;
	    }
	  },
	  on_pointermove: function (_ref2) {
	    var event = _ref2.event;
	    var view = _ref2.view;
	
	    var char = this._char;
	    if (char && this._point) {
	      var text = this._text;
	      var pn = this._point = event.docPoint;
	      var invMatrix = text.matrix_().inverted();
	      var offset = pn.minus(this._downPoint);
	
	      char.placeAt('Grip', invMatrix.apply(this._charGrip.plus(offset)));
	
	      // Regenerate output figure, we need a helper here.
	      // Manually preserve the anchor for the moment
	      var anchor = text.outputFigure.anchor;
	      var newOutput = text._textLayout.shape();
	      newOutput.anchor = anchor;
	
	      text.outputFigure = newOutput;
	
	      text._cache.clear();
	      text.invalidateView();
	
	      view.batchRedraw('tools');
	
	      view.preview$();
	    }
	  },
	  on_pointerup: function () {
	    var _this2 = this;
	
	    var char = this._char;
	    if (char) {
	      (function () {
	        _this2._changed = true;
	
	        var text = _this2._text,
	            textLayout = text._textLayout,
	            spaceWidth = textLayout.spaceWidth(),
	            invMatrix = _this2._matrix.inverted(),
	            docOffset = _this2._point.minus(_this2._downPoint),
	            finalPos = invMatrix.apply(_this2._charGrip.plus(docOffset)),
	            offset = finalPos.minus(invMatrix.apply(_this2._charGrip));
	
	        var idx = char._idx,
	            lineIdx = char._lineIdx;
	
	        // Update layout transforms, in case other processes call layout.outdate()
	        char._charData._transformers.push(new _cdl.TextChar.PinPlacer('Grip', char._grip.clone()));
	
	        // Update text processes
	        var processes = text._processes;
	        var charsTransform = (0, _gear.findByType)(processes, _cdl.Process.CharsTransform);
	        if (!charsTransform) {
	          charsTransform = new _cdl.Process.CharsTransform();
	          processes._push(charsTransform); // Avoid events, the output is already modified
	        }
	        var ctl = (0, _lodash.find)(charsTransform._chars, function (c) {
	          return c._lineIdx === lineIdx && c._idx === idx;
	        });
	        if (!ctl) {
	          ctl = new _cdl.CharTransformList({ lineIdx: lineIdx, idx: idx });
	          charsTransform._chars._push(ctl);
	        }
	        var to = (0, _gear.findByType)(ctl._transforms, _cdl.CharTransform.TangencialOffset);
	        if (!to) {
	          to = new _cdl.CharTransform.TangencialOffset();
	          ctl._transforms._push(to);
	        }
	        var dirX = char._frame.dir_x;
	        var co_h = _cdl.Point.dotProduct(dirX, offset);
	        var co_v = _cdl.Point.dotProduct(dirX.perpendicular(), offset);
	        to._h = new _gear.Magnitude((_gear.Magnitude.absoluteMMValueFor(to._h, spaceWidth) + co_h) / spaceWidth * 100, '%');
	        to._v = new _gear.Magnitude((_gear.Magnitude.absoluteMMValueFor(to._v, spaceWidth) + co_v) / spaceWidth * 100, '%');
	
	        _this2._point = _this2._downPoint = null;
	      })();
	    }
	  },
	  draw: function (_ref3) {
	    var view = _ref3.view;
	    var context = _ref3.context;
	    var transform = _ref3.transform;
	
	    var char = this._char;
	    var e = view.viewDeltaToTexture(3);
	    context.lineWidth = view.viewDeltaToTexture(1);
	    if (char) {
	      context.strokeStyle = "#248e1f";
	      var frame = char._frame.transformed(this._matrix).extended(e, e, e, e);
	      frame.draw(context, transform);
	      context.stroke();
	    } else if (this._text) {
	      var figure = this._text;
	      var figureFrame = figure.frame_().transformed(transform).extended(e, e, e, e);
	      context.strokeStyle = "#248e1f";
	      figureFrame.draw(context);
	      context.stroke();
	    }
	  }
	});
	
	_view.Tool.CharsTransform = CharsTransformTool;

/***/ },

/***/ 164:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NodeEditEnvelopeTool = exports.NodeEditTool = undefined;
	
	var _config = __webpack_require__(2);
	
	var _lodash = __webpack_require__(4);
	
	var _gear = __webpack_require__(8);
	
	var _cdl = __webpack_require__(15);
	
	var _view = __webpack_require__(84);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var Point_add = _cdl.Point.add,
	    Point_substract = _cdl.Point.substract,
	    Point_sm = _cdl.Point.sm,
	    Color_fromRgb = _cdl.Color.fromRgb,
	    knotSize = 3,
	    knotSelectedSize = 4;
	
	// [TODO] directly use fillStyle colors here, and flatten this object
	var colors = {
	  pad: new _cdl.Color({ rgb: 'FFFFFF', alpha: 0.7 }),
	  curve: Color_fromRgb('8888FF'),
	  knot: Color_fromRgb('4444FF'),
	  knot_selected: Color_fromRgb('000000'),
	  knot_over: Color_fromRgb('44AA88'),
	  controlSegment: Color_fromRgb('4444FF'),
	  curveControlSegment: Color_fromRgb('9944CC'),
	  cuspControlSegment: Color_fromRgb('AA4433'),
	  nextControlSegment: Color_fromRgb('666666'),
	  control: Color_fromRgb('0000FF'),
	  control_over: Color_fromRgb('44AA88'),
	  addKnot: Color_fromRgb('000000'),
	  addKnot_over: Color_fromRgb('44AA88'),
	  removeKnot: Color_fromRgb('FF0000'),
	  removeKnot_over: Color_fromRgb('44AA88'),
	  dragSelector: Color_fromRgb('009900'),
	  curvePadBack: Color_fromRgb('E8E8FF')
	};
	
	function drawDot(context, style, size, point, transform, textureScale) {
	  context.fillStyle = colors.pad.rgba;
	  (0, _gear.dot)(context, point, (size + 1.4) * textureScale, transform);
	  context.fillStyle = style;
	  (0, _gear.dot)(context, point, size * textureScale, transform);
	}
	
	function drawSegment(context, style, p0, p1, transform, textureScale) {
	  context.lineWidth = 3.5 * textureScale;
	  context.strokeStyle = colors.pad.rgba;
	  (0, _gear.strokeSegment)(context, p0, p1, transform);
	  context.lineWidth = 1.5 * textureScale;
	  context.strokeStyle = style;
	  (0, _gear.strokeSegment)(context, p0, p1, transform);
	}
	
	// States
	//   Iddle: nothing is selected, waiting for user input
	//   DragSelection: user is selecting multiple knots with a rectangle
	//   EditingKnot: one knot is selected, user can move it and move the control points
	//   SelectedKnots:
	//   MovingControlPoint: control point is being moved
	//   MovingKnots: multiple knots are selected
	
	function nextKi(side, curve, ki) {
	  var length = curve.pieces.length,
	      closed = curve.closed;
	  if (side === 'left') {
	    if (!closed && ki === 0) {
	      return null;
	    }
	    return ki === 0 && closed ? length - 1 : ki - 1;
	  } else {
	    // right
	
	    if (!closed && ki === length) {
	      return null;
	    }
	    return ki === length - 1 && closed ? 0 : ki + 1;
	  }
	}
	
	function knotPoint(curve, ki) {
	  var pieces = curve.pieces;
	  if (ki === null) {
	    return null;
	  }
	  if (ki >= pieces.length) {
	    return (0, _lodash.last)(pieces).last();
	  }
	  return pieces[ki].P0;
	}
	
	function nextKnotPoint(side, curve, ki) {
	  return knotPoint(curve, nextKi(side, curve, ki));
	}
	
	function pieceIndexAt(side, curve, ki) {
	  if (side === 'left') {
	    return nextKi(side, curve, ki);
	  } else {
	    return !curve.closed && ki === curve.pieces.length ? null : ki;
	  }
	}
	
	function pieceAt(side, curve, ki) {
	  var pi = pieceIndexAt(side, curve, ki);
	  return pi !== null ? curve.pieces[pi] : null;
	}
	
	function controlPoint(side, curve, ki) {
	  var pieces = curve.pieces;
	
	  var piece = void 0;
	  if (ki === null) {
	    return null;
	  }
	  if (side === 'left') {
	    piece = null;
	    if (ki === 0 && curve.closed) {
	      piece = (0, _lodash.last)(pieces);
	    } else {
	      piece = pieces[ki - 1];
	    }
	    if (piece && piece.type === 'Cubic') {
	      return piece.P2;
	    }
	    return null;
	  } else {
	    // 'right'
	    if (ki >= pieces.length) {
	      return null;
	    }
	    piece = pieces[ki];
	    if (piece && piece.type === 'Cubic') {
	      return piece.P1;
	    }
	    return null;
	  }
	}
	
	function nextControlPoint(side, curve, ki) {
	  return controlPoint(oppSide(side), curve, nextKi(side, curve, ki));
	}
	
	function removeKnot(curve, ki, tool) {
	
	  // Check if it is the last knot
	  if (curve.pieces.length === 1) {
	    // [TODO] Curves should be included in the type system, remove lazy loading, is not gaining us much
	    var region = curve._owner;
	    var curves = region._curves;
	    curves.splice(curves.indexOf(curve), 1);
	
	    if (curves.length === 0) {
	      var polyregion = region._owner;
	      var regions = polyregion._regions;
	
	      regions._remove(region);
	      if (regions.length === 0) {
	        var figure = polyregion._owner;
	        figure._polyregions._remove(polyregion);
	      }
	    }
	    var toolCurves = tool._curves;
	    toolCurves.splice(toolCurves.indexOf(curve), 1);
	    return;
	  }
	
	  var pieces = curve.pieces;
	  if (ki === pieces.length) {
	    // open curve
	    pieces.pop();
	    return;
	  }
	
	  var kiLeft = nextKi('left', curve, ki);
	  if (kiLeft === null) {
	    // open curve
	    pieces.shift();
	    return;
	  }
	
	  var pieceLeft = pieces[kiLeft];
	  var piece = pieces[ki];
	
	  pieceLeft.last(piece.last());
	  if (pieceLeft.P3) {
	    if (piece.P3) {
	      // Both are cubic, try to avoid big modifications in the curve
	      pieceLeft.P1 = Point_sm(pieceLeft.P1, 2).substract(pieceLeft.P0);
	      pieceLeft.P2 = Point_sm(piece.P2, 2).substract(piece.P3);
	    } else {
	      pieces[kiLeft] = new _cdl.Segment(pieceLeft.P0, piece.last());
	    }
	  }
	  pieces.splice(ki, 1);
	  curve.tieExtremePoints();
	}
	
	function oppSide(side) {
	  return side === 'left' ? 'right' : 'left';
	}
	
	var Knot = function (curve, ki) {
	  this.curve = curve;
	  this.ki = ki;
	};
	Knot.prototype = {
	  isEqual: function (ok) {
	    return ok && this.curve === ok.curve && this.ki === ok.ki;
	  },
	  point: function () {
	    return knotPoint(this.curve, this.ki);
	  },
	  nextKi: function (side) {
	    return nextKi(side, this.curve, this.ki);
	  },
	  nextPoint: function (side) {
	    return nextKnotPoint(side, this.curve, this.ki);
	  },
	  pieceAt: function (side) {
	    return pieceAt(side, this.curve, this.ki);
	  },
	  pieceIndexAt: function (side) {
	    return pieceIndexAt(side, this.curve, this.ki);
	  },
	  pointAt: function (side, t) {
	    return this.pieceAt(side).eval(t);
	  },
	  controlPoint: function (side) {
	    return controlPoint(side, this.curve, this.ki);
	  },
	  nextControlPoint: function (side) {
	    return nextControlPoint(side, this.curve, this.ki);
	  },
	  nextKnot: function (side) {
	    var nki = nextKi(side, this.curve, this.ki);
	    if (nki === null) {
	      return null;
	    }
	    return new Knot(this.curve, nki);
	  },
	  tangentAt: function (side) {
	    var to = this.controlPoint(side) || this.nextPoint(side);
	    if (!to) {
	      return null;
	    }
	    var from = this.point();
	    var tangent = Point_substract(from, to);
	    if (tangent.isZero()) {
	      return null;
	    }
	    return tangent.normalized();
	  },
	  normal: function () {
	    var leftTangent = this.tangentAt("left");
	    var rightTangent = this.tangentAt("right");
	    if (!leftTangent && !rightTangent) {
	      leftTangent = new _cdl.Point(1.0, 0.0);
	      rightTangent = new _cdl.Point(-1.0, 0.0);
	    } else if (!leftTangent) {
	      leftTangent = _cdl.Point.minus(rightTangent);
	    } else if (!rightTangent) {
	      rightTangent = _cdl.Point.minus(leftTangent);
	    }
	
	    var normal = new _cdl.Point(leftTangent.y - rightTangent.y, -leftTangent.x + rightTangent.x);
	
	    return normal.isZero() ? leftTangent : normal.normalize();
	  },
	  locked: function () {
	    return this.point().__cadx_locked === true;
	  },
	
	  // You can not use the knot after calling this function
	  remove: function (tool) {
	    removeKnot(this.curve, this.ki, tool);
	  },
	  addKnot: function (side) {
	    var curve = this.curve;
	    var pi = this.pieceIndexAt(side);
	    // [TODO] Move locked annotations out of points
	    var locked = curve.pieces[pi].P0.__cadx_locked;
	    this.curve.splitPiece(pi, 0.5);
	    if (locked) {
	      curve.pieces[pi].P0.__cadx_locked = true;
	    }
	    return new Knot(this.curve, side === 'left' ? this.ki : this.ki + 1);
	  },
	  _computeCorner: function () {
	    var left = this.controlPoint('left');
	    var right = this.controlPoint('right');
	    if (left && right) {
	      var point = this.point();
	      if (point.isNear(left, 0.01) || point.isNear(right, 0.01)) {
	        return 'cusp';
	      }
	      var lp = Point_substract(point, left);
	      var rp = Point_substract(right, point);
	      if (lp.isNear(rp, 0.01)) {
	        return 'symmetric';
	      }
	      if (Math.abs(lp.x * rp.y - lp.y * rp.x) < 0.01) {
	        return 'curve';
	      }
	      return 'cusp';
	    }
	    return 'cusp';
	  },
	  corner: function () {
	    if (!this._corner) {
	      this._corner = this._computeCorner();
	    }
	    return this._corner;
	  },
	  changeCorner: function (side) {
	    var _side = this.controlPoint(side);
	    var _opp = this.controlPoint(oppSide(side));
	    var point = this.point();
	    var corner = this.corner();
	    var newCorner = corner === 'cusp' ? 'curve' : corner === 'curve' ? 'symmetric' : 'cusp';
	    if (!(_side && _opp)) {
	      return;
	    }
	    var sh = Point_substract(point, _side);
	    if (newCorner === 'symmetric') {
	      _opp.set(Point_add(point, sh));
	    } else if (newCorner === 'curve') {
	      if (corner === 'cusp') {
	        var oh = Point_substract(_opp, point);
	        sh = Point_sm(sh.normalized(), oh.norm());
	        _opp.set(Point_add(point, sh));
	      } else {
	        // Symmetric
	        sh = Point_add(sh, Point_sm(sh.normalized(), 0.1));
	        _opp.set(Point_add(point, sh));
	      }
	    } else if (newCorner === 'cusp') {
	      var p = sh.perpendicular(-1);
	      sh = Point_add(Point_substract(_opp, point), Point_sm(p.normalized(), 0.1));
	      _opp.set(Point_add(point, sh));
	    }
	    this._corner = newCorner;
	  },
	  convertToCurve: function (side) {
	    var pieces = this.curve.pieces;
	    var kp = side === 'left' ? nextKi(side, this.curve, this.ki) : this.ki;
	    var p = pieces[kp];
	    pieces.splice(kp, 1, _cdl.Cubic.fromSegment(p.P0, p.P1));
	    this.curve.tieExtremePoints();
	    this._corner = null;
	  },
	  convertToSegment: function (side) {
	    var pieces = this.curve.pieces;
	    var kp = side === 'left' ? nextKi(side, this.curve, this.ki) : this.ki;
	    var p = pieces[kp];
	    pieces.splice(kp, 1, new _cdl.Segment(p.P0, p.last()));
	    this.curve.tieExtremePoints();
	    this._corner = null;
	  }
	};
	
	function forEachKnot(curve, func) {
	  var pieces = curve.pieces;
	  for (var n = 0, nEnd = pieces.length; n < nEnd; ++n) {
	    if (func(new Knot(curve, n)) === false) {
	      return curve;
	    }
	  }
	  if (!curve.closed) {
	    if (func(new Knot(curve, curve.pieces.length)) === false) {
	      return curve;
	    }
	  }
	  return curve;
	}
	
	function findKnot(curve, func) {
	  var pieces = curve.pieces;
	  var k = void 0;
	  for (var n = 0, nEnd = pieces.length; n < nEnd; ++n) {
	    k = new Knot(curve, n);
	    if (func(k) === true) {
	      return k;
	    }
	  }
	  if (!curve.closed) {
	    k = new Knot(curve, pieces.length);
	    if (func(k) === true) {
	      return k;
	    }
	  }
	  return null;
	}
	
	var BaseState = _gear.Base.extend({
	  init: function (tool) {
	    this._tool = tool;
	    this._padSize = 0.1 * 96;
	    this._cursor = null;
	    this.showToolhelp();
	  },
	  showToolhelp: function () {
	    this._tool.toolhelp(this.toolhelp().concat(this.baseToolhelp()));
	  },
	  toolhelp: function () {
	    return [];
	  },
	  baseToolhelp: function () {
	    return ['Click or Draw rectangle to select knots', 'Enter to Commit, Escape to Cancel'];
	  },
	  undoState: function () {
	    this._tool.undoState();
	  },
	  state: function (s, k, a, b, c) {
	    this._tool.state(s, k, a, b, c);
	  },
	  curveToDoc: function (point) {
	    return this.matrix.apply(point);
	  },
	  viewToCurve_dx: function (d) {
	    return this.matrixInverted.scaleFactor() * this.view.viewDeltaToDoc(d);
	  },
	  curvePoint: function (_ref) {
	    var docPoint = _ref.docPoint;
	
	    return this.matrixInverted.apply(docPoint);
	  },
	
	
	  get textureScale() {
	    return this.view.viewDeltaToTexture(1);
	  },
	
	  get view() {
	    return this._tool.view;
	  },
	  get matrix() {
	    return this._tool._matrix;
	  },
	  get matrixInverted() {
	    return this._tool._matrixInverted;
	  },
	
	  focus: function () {
	    this.showToolhelp();
	    this._possibleClick = null;
	  },
	
	
	  get cursor() {
	    return this._tool.cursor;
	  },
	  set cursor(cursor_) {
	    this._tool.cursor = cursor_;
	  },
	
	  redraw: function () {
	    this._tool.redraw();
	  },
	  onUpdate: function () {
	    this._tool.onUpdate();
	  },
	  draw: function (context, transform) {
	    this.drawCurve(context, transform);
	    this.drawKnots(context, transform);
	  },
	  drawCurve: function (context, transform) {
	    var textureScale = this.textureScale;
	
	    context.lineWidth = 3.5 * textureScale;
	    context.strokeStyle = colors.pad.rgba;
	    this._strokeCurve(context, transform);
	    context.lineWidth = 1.5 * textureScale;
	    context.strokeStyle = colors.curve.rgba;
	    this._strokeCurve(context, transform);
	  },
	  _strokeCurve: function (context, transform) {
	    (0, _lodash.forEach)(this._tool._curves, function (curve) {
	      context.beginPath();
	      curve.draw(context, transform);
	      context.stroke();
	    });
	  },
	  drawKnots: function (context, transform) {
	    var tool = this._tool;
	    var over_knot = this._over_knot;
	    var textureScale = this.textureScale;
	
	    (0, _lodash.forEach)(tool._curves, function (curve) {
	      forEachKnot(curve, function (knot) {
	        var ok = knot.isEqual(over_knot);
	        drawDot(context, ok ? colors.knot_over.rgba : colors.knot.rgba, ok ? knotSelectedSize : knotSize, knot.point(), transform, textureScale);
	      });
	    });
	    var fillStyle = this._over_selectedKnots ? colors.knot_over.rgba : colors.knot_selected.rgba;
	    (0, _lodash.forEach)(this.selectedKnots(), function (knot) {
	      drawDot(context, fillStyle, knotSelectedSize, knot.point(), transform, textureScale);
	    });
	  },
	  overKnot: function (event) {
	    var padSize = this.viewToCurve_dx(this._padSize * _view.padScaling),
	        point = this.curvePoint(event);
	    var overKnot = null;
	    (0, _lodash.find)(this._tool._curves, function (curve) {
	      overKnot = findKnot(curve, function (knot) {
	        return point.isNear(knot.point(), padSize);
	      });
	      if (overKnot) {
	        return true;
	      }
	    });
	    return overKnot;
	  },
	  overSelectedKnots: function (event) {
	    var padSize = this.viewToCurve_dx(this._padSize * _view.padScaling),
	        point = this.curvePoint(event);
	
	    return (0, _lodash.find)(this.selectedKnots(), function (knot) {
	      return point.isNear(knot.point(), padSize);
	    });
	  },
	  selectedKnot: function () {
	    return this._tool._selectedKnots[0];
	  },
	  selectedKnots: function () {
	    return this._tool._selectedKnots;
	  },
	  down: function (_ref2) {
	    var event = _ref2.event;
	    var docPoint = _ref2.docPoint;
	    var shiftKey = _ref2.shiftKey;
	
	    var selectedKnots = this.selectedKnots();
	    var knot = this.overKnot(event);
	    if (knot) {
	      if (shiftKey && selectedKnots) {
	        return this.state('SelectedKnots', selectedKnots.concat(knot));
	      } else {
	        this._possibleClick = { docPoint: docPoint, knot: knot };
	        return true;
	      }
	    }
	    this.state('DragSelection', selectedKnots, docPoint);
	    return false;
	  },
	  move: function (_ref3) {
	    var event = _ref3.event;
	    var docPoint = _ref3.docPoint;
	
	    if (this._possibleClick && !docPoint.isEqual(this._possibleClick.docPoint)) {
	      this.state('EditingKnot', this._possibleClick.knot);
	      this.state('MovingKnots', this._possibleClick.knot, this.curvePoint(event));
	      this._possibleClick = null;
	      this.redraw();
	    }
	  },
	  mousemove: function (event) {
	    this._over_knot = this.overKnot(event);
	    this._over_selectedKnots = this.overSelectedKnots(event);
	    if (this._changeCursorTo) {
	      this.cursor = this._changeCursorTo;
	      this._changeCursorTo = null;
	    } else if (this._over_knot || this._over_selectedKnots) {
	      this.cursor = 'pointer';
	    } else {
	      this.cursor = 'default';
	    }
	    this.redraw(); // [TODO] Avoid redrawing when it is not needed
	  },
	  up: function () /*view,event*/{
	    if (this._possibleClick) {
	      this.state('EditingKnot', this._possibleClick.knot);
	      this._possibleClick = null;
	    }
	  },
	  on_dblclick: function () /*view,event*/{
	    // ...
	  },
	  deleteAction: function () {
	    // nothing...
	  }
	});
	
	var HandleBase = _gear.Base.extend({
	  init: function (state, side) {
	    this._state = state;
	    this._knot = state._knot;
	    this._side = side;
	    this._over = false;
	    this._point = this.point();
	    this._padSize = 0.1 * 96;
	  },
	  over: function (event) {
	    var state = this._state;
	    var p = this._point;
	    return p && state.curvePoint(event).isNear(p, state.viewToCurve_dx(this._padSize * _view.padScaling));
	  },
	  down: function (event) {
	    if (!this._point) {
	      return;
	    }
	
	    if (this.over(event)) {
	      this.click(event);
	      return true;
	    }
	    return false;
	  },
	  move: function () /* event */{},
	  mousemove: function (event) {
	    if (!this._point) {
	      return;
	    }
	    this._over = this.over(event);
	    if (this._over) {
	      this._state._changeCursorTo = 'pointer';
	    }
	  },
	  on_dblclick: function (event) {
	    if (!this._point) {
	      return;
	    }
	    if (this.over(event)) {
	      this.dblClick(event);
	      return true;
	    }
	    return false;
	  },
	  click: function () /*view,event*/{},
	  dblClick: function () /*view,event*/{},
	  drawCurvePadBack: function (context, transform) {
	    var textureScale = this.textureScale;
	
	    context.strokeStyle = colors.curve.rgba;
	    context.lineWidth = 1;
	    (0, _gear.strokeDot)(context, this._point, 5 * textureScale, transform);
	    context.fillStyle = colors.curvePadBack.rgba;
	    (0, _gear.dot)(context, this._point, 4.5 * textureScale, transform);
	  },
	  state: function (a, b, c, d, e) {
	    this._state.state(a, b, c, d, e);
	  },
	  curvePoint: function (event) {
	    return this._state.curvePoint(event);
	  },
	  viewToCurve_dx: function (d) {
	    return this._state.viewToCurve_dx(d);
	  },
	  onUpdate: function () {
	    this._state.onUpdate();
	  },
	
	
	  get textureScale() {
	    return this._state.textureScale;
	  }
	});
	
	var Handle = {
	
	  'Control': HandleBase.extend({
	    //==========================================================================
	
	    point: function () {
	      return this._knot.controlPoint(this._side);
	    },
	    draw: function (context, transform) {
	      if (!this._point) {
	        return;
	      }
	
	      // [TODO]
	
	      var corner = this._knot.corner();
	      var strokeStyle = this._side === 'right' ? colors.controlSegment.rgba : corner === 'cusp' ? colors.cuspControlSegment.rgba : corner === 'curve' ? colors.curveControlSegment.rgba : colors.controlSegment.rgba;
	
	      var textureScale = this.textureScale;
	
	
	      drawSegment(context, strokeStyle, this._knot.point(), this._point, transform, textureScale);
	
	      drawDot(context, this._over ? colors.control_over.rgba : colors.control.rgba, 2, this._point, transform, textureScale);
	    },
	    click: function (event) {
	      return this.state('MovingControl', this._knot, this._side, this.curvePoint(event));
	    },
	    dblClick: function () /*view,event*/{
	      this._knot.changeCorner(this._side);
	      this.onUpdate();
	      this._state.focus();
	    }
	  }),
	
	  'NextControl': HandleBase.extend({
	    //==========================================================================
	    point: function () {
	      return this._knot.nextControlPoint(this._side);
	    },
	    draw: function (context, transform) {
	
	      if (!this._point) {
	        return;
	      }
	
	      var textureScale = this.textureScale;
	
	
	      drawSegment(context, colors.nextControlSegment.rgba, this._knot.nextKnot(this._side).point(), this._point, transform, textureScale);
	
	      drawDot(context, this._over ? colors.control_over.rgba : colors.control.rgba, 2, this._point, transform, textureScale);
	    },
	    click: function (event) {
	      var nextKnot = this._knot.nextKnot(this._side);
	      this.state('EditingKnot', nextKnot);
	      this.state('MovingControl', nextKnot, oppSide(this._side), this.curvePoint(event));
	    }
	  }),
	
	  'AddKnot': HandleBase.extend({
	    //==========================================================================
	    point: function () {
	      // Use the middle of the curve
	      var p = this._knot.pieceAt(this._side);
	      return p ? p.eval(0.5) : null;
	    },
	    draw: function (context, transform) {
	      if (!this._point) {
	        return;
	      }
	      this.drawCurvePadBack(context, transform);
	      var textureScale = this.textureScale;
	
	      if (this._over) {
	        context.fillStyle = colors.addKnot_over.rgba;
	        (0, _gear.dot)(context, this._point, textureScale * knotSelectedSize, transform);
	      } else {
	        context.strokeStyle = colors.addKnot.rgba;
	        context.lineWidth = textureScale * 0.5;
	        (0, _gear.strokeDot)(context, this._point, textureScale * 2, transform);
	      }
	    },
	    click: function (event) {
	      var newKnot = this._knot.addKnot(this._side);
	      this.state('EditingKnot', newKnot);
	      this.state('MovingKnots', newKnot, this.curvePoint(event));
	    }
	  }),
	
	  'RemoveKnot': HandleBase.extend({
	    //==========================================================================
	
	    point: function () {
	      var k = this._knot;
	      return Point_add(k.point(), Point_sm(k.normal(), this.viewToCurve_dx(30)));
	    },
	    draw: function (context, transform) {
	      if (!this.point) {
	        return;
	      }
	      var textureScale = this.textureScale;
	      // [TODO]
	
	      var lineWidth = (this._over ? 2 : 1) * textureScale;
	      var rs = (this._over ? 4 : 2) * textureScale;
	      var point = this._point;
	
	      context.lineWidth = lineWidth + 2 * textureScale;
	      context.strokeStyle = colors.pad.rgba;
	      (0, _gear.strokeCross)(context, point, rs + 1 * textureScale, transform);
	
	      context.lineWidth = lineWidth;
	      context.strokeStyle = colors.removeKnot.rgba;
	      (0, _gear.strokeCross)(context, point, rs, transform);
	      if (this._over) {
	        context.lineWidth = lineWidth + 2 * textureScale;
	        context.strokeStyle = colors.pad.rgba;
	        (0, _gear.strokeDot)(context, this._knot.point(), (knotSelectedSize + 3) * textureScale, transform);
	
	        context.strokeStyle = colors.removeKnot.rgba;
	        context.lineWidth = lineWidth;
	        (0, _gear.strokeDot)(context, this._knot.point(), (knotSelectedSize + 3) * textureScale, transform);
	      }
	    },
	    click: function () /*view,event*/{
	      this._knot.remove(this._state._tool);
	      this.state('Iddle');
	      this.onUpdate();
	    }
	  }),
	
	  'ConvertToCurve': HandleBase.extend({
	    //==========================================================================
	    point: function () {
	      var p = this._knot.pieceAt(this._side);
	      if (!(p instanceof _cdl.Segment)) {
	        return null;
	      }
	      return p.eval(this._side === 'left' ? 2 / 3.0 : 1 / 3.0);
	    },
	    draw: function (context, transform) {
	      if (!this._point) {
	        return;
	      }
	      this.drawCurvePadBack(context, transform);
	
	      var textureScale = this.textureScale;
	
	
	      drawSegment(context, colors.controlSegment.rgba, this._knot.point(), this._point, transform, textureScale);
	
	      context.fillStyle = colors.control.rgba;
	      (0, _gear.dot)(context, this._point, 2 * textureScale, transform);
	    },
	    click: function (event) {
	      this._knot.convertToCurve(this._side);
	      this.state('MovingControl', this._knot, this._side, this.curvePoint(event));
	      this.onUpdate();
	    }
	  }),
	
	  'ConvertToSegment': HandleBase.extend({
	    //==========================================================================
	    point: function () {
	      var p = this._knot.pieceAt(this._side);
	      if (!p || p instanceof _cdl.Segment) {
	        return null;
	      }
	      return p.eval(this._side === 'left' ? 2 / 3.0 : 1 / 3.0);
	    },
	    draw: function (context, transform) {
	      if (!this._point) {
	        return;
	      }
	
	      var textureScale = this.textureScale;
	
	
	      if (this._over) {
	        var piece = this._knot.pieceAt(this._side);
	        context.lineWidth = 4 * textureScale;
	        context.strokeStyle = colors.pad.rgba;
	        context.beginPath();
	        piece.draw(context, transform);
	        context.stroke();
	
	        context.lineWidth = 2 * textureScale;
	        context.strokeStyle = colors.removeKnot.rgba;
	        context.beginPath();
	        piece.draw(context, transform);
	        context.stroke();
	
	        context.lineWidth = 1 * textureScale;
	        drawSegment(context, colors.curve.rgba, this._knot.point(), this._knot.nextKnot(this._side).point(), transform, textureScale);
	      }
	
	      this.drawCurvePadBack(context, transform);
	
	      context.strokeStyle = colors.removeKnot.rgba;
	      context.lineWidth = 1 * textureScale;
	      var rs = 2 * textureScale;
	      (0, _gear.strokeCross)(context, this._point, rs, transform);
	    },
	    click: function () /*view,event*/{
	      this._knot.convertToSegment(this._side);
	      this._state.focus();
	    }
	  })
	};
	
	var State = {
	
	  'Iddle': BaseState.extend({
	    // =========================================================
	  }),
	
	  'EditingKnot': BaseState.extend({
	    // =========================================================
	    init: function (tool) {
	      this.callParent(tool);
	      this.focus();
	    },
	    toolhelp: function () {
	      return ['Drag knots and control handles to modify curve', 'Double Click control handle to change curve type'];
	    },
	    focus: function () {
	      var _this2 = this;
	
	      this.showToolhelp();
	
	      var knot = this._knot = this.selectedKnot();
	
	      this._handles = [];
	
	      var moreHandles = [new Handle.AddKnot(this, 'left'), new Handle.AddKnot(this, 'right'), new Handle.ConvertToCurve(this, 'left'), new Handle.ConvertToCurve(this, 'right'), new Handle.ConvertToSegment(this, 'left'), new Handle.ConvertToSegment(this, 'right')];
	
	      // Only add handles if the buttons aren't that close to the knot
	      var knotPoint = knot.point();
	      var delta = this.view.viewDeltaToDoc(15);
	      (0, _lodash.forEach)(moreHandles, function (h) {
	        var point = h.point();
	        if (point && !point.isNear(knotPoint, delta)) {
	          _this2._handles.push(h);
	        }
	      });
	
	      // Order is important, first move control points, then knots...
	      this._handles = this._handles.concat([new Handle.Control(this, 'left'), new Handle.Control(this, 'right'), new Handle.NextControl(this, 'left'), new Handle.NextControl(this, 'right')]);
	
	      // Do not let the user remove locked knots
	      if (!this._knot.locked()) {
	        this._handles.push(new Handle.RemoveKnot(this));
	      }
	    },
	    draw: function (context, transform) {
	      this.drawCurve(context, transform);
	      (0, _lodash.forEach)(this._handles, function (h) {
	        h.draw(context, transform);
	      });
	      this.drawKnots(context, transform);
	    },
	    down: function (event) {
	      if ((0, _lodash.find)(this._handles, function (h) {
	        return h.down(event);
	      })) {
	        return true;
	      }
	      return this.callParent(event);
	    },
	    mousemove: function (event) {
	      (0, _lodash.forEach)(this._handles, function (h) {
	        h.mousemove(event);
	      });
	      this.redraw();
	      this.callParent(event);
	    },
	    move: function (event) {
	      (0, _lodash.forEach)(this._handles, function (h) {
	        h.move(event);
	      });
	      this.redraw();
	      this.callParent(event);
	    },
	    on_dblclick: function (event) {
	      (0, _lodash.find)(this._handles, function (h) {
	        return h.on_dblclick(event);
	      });
	    },
	    deleteAction: function () {
	      var knot = this._knot;
	      if (!knot.locked()) {
	        knot.remove(this._tool);
	        this.state('Iddle');
	        this.onUpdate();
	      }
	    }
	  }),
	
	  'DragSelection': BaseState.extend({
	    // =========================================================
	    init: function (tool, fromPoint) {
	      this.callParent(tool);
	      this._fromPoint = fromPoint;
	      this._toPoint = fromPoint;
	    },
	    draw: function (context, transform) {
	      this.callParent(context, transform);
	      context.strokeStyle = colors.dragSelector.rgba;
	      var fixedTransform = _cdl.Matrix.m(transform, this.matrixInverted);
	
	      var frame = _cdl.Frame.ofPoints([this._fromPoint, this._toPoint]);
	      frame.draw(context, fixedTransform);
	      context.lineWidth = this.textureScale * 1;
	      context.stroke();
	    },
	    down: function () {
	      this.state('Iddle');
	      return false;
	    },
	    move: function (_ref4) {
	      var event = _ref4.event;
	      var docPoint = _ref4.docPoint;
	
	      this._toPoint = docPoint;
	      this.redraw();
	    },
	    up: function (_ref5) {
	      var _this3 = this;
	
	      var event = _ref5.event;
	      var shiftKey = _ref5.shiftKey;
	
	      var tool = this._tool;
	      var knots = [];
	      var db = _cdl.Bounds.ofPoints([this._fromPoint, this._toPoint]);
	      (0, _lodash.forEach)(tool._curves, function (curve) {
	        forEachKnot(curve, function (knot) {
	          if (db.contains(_this3.curveToDoc(knot.point()))) {
	            knots.push(knot);
	          }
	        });
	      });
	      if (shiftKey) {
	        knots = this.selectedKnots().concat(knots);
	      }
	      if (knots.length === 1) {
	        this.state('EditingKnot', knots[0]);
	      } else if (knots.length > 0) {
	        this.state('SelectedKnots', knots);
	      } else {
	        this.state('Iddle');
	      }
	    }
	  }),
	
	  'SelectedKnots': BaseState.extend({
	    // =========================================================
	    init: function (tool) {
	      this.callParent(tool);
	    },
	    toolhelp: function () {
	      return ['Drag knots to modify curve'];
	    },
	    focus: function () {
	      this.showToolhelp();
	      var c = this._possibleClick;
	      if (c && (0, _lodash.now)() - c.time < 500) {
	        this.state('EditingKnot', c.knot);
	      } else {
	        this._possibleClick = null;
	      }
	    },
	    down: function (_ref6) {
	      var event = _ref6.event;
	      var shiftKey = _ref6.shiftKey;
	
	      var knot = this.overSelectedKnots(event);
	      if (knot) {
	        if (!shiftKey) {
	          this._possibleClick = { knot: knot, time: (0, _lodash.now)() };
	        }
	        this.state('MovingKnots', this.selectedKnots(), this.curvePoint(event));
	        return true;
	      }
	      return this.callParent(event);
	    },
	    move: function (event) {
	      this.callParent(event);
	    },
	    deleteAction: function () {
	      var tool = this._tool;
	      var knots = this.selectedKnots();
	      for (var k = 0, kEnd = knots.length; k < kEnd; k++) {
	        var knot = knots[k];
	        if (!knot.locked()) {
	
	          var ki = knot.ki;
	          knot.remove(tool);
	
	          // Correct indexes, to be able to continue removing other knots
	          // This ended up quite complex because of using a direct view of
	          // the curve representation [curve,ki]
	          for (var i = k + 1, iEnd = knots.length; i < iEnd; i++) {
	            var knot_i = knots[i];
	            if (knot_i.ki > ki) {
	              knot_i.ki--;
	            }
	          }
	        }
	      }
	      this.state('Iddle');
	      this.onUpdate();
	    }
	  }),
	
	  'MovingKnots': BaseState.extend({
	    // =========================================================
	    init: function (tool, fromPoint) {
	      this.callParent(tool);
	      this._fromPoint = fromPoint;
	      this._points = (0, _lodash.map)(this.selectedKnots(), function (knot) {
	        var point = knot.point();
	        var left = knot.controlPoint('left');
	        var right = knot.controlPoint('right');
	        var r = { point: point, original: point.clone() };
	        if (left) {
	          r.left = left;
	          r.originalLeft = left.clone();
	        }
	        if (right) {
	          r.right = right;
	          r.originalRight = right.clone();
	        }
	        return r;
	      });
	
	      //filter duplicated selected points
	      var lFilteredPoints = [];
	      this._points.forEach(function (p1) {
	        if (!(0, _lodash.find)(lFilteredPoints, function (p2) {
	          return p1.point == p2.point;
	        })) lFilteredPoints.push(p1);
	      });
	      this._points = lFilteredPoints;
	    },
	    down: function () {
	      this.state('Iddle');
	      return false;
	    },
	    cacheOppositeKnot: function (aKnotId) {
	      var lOppositeKnot = new Knot(this._tool._curves[0], aKnotId);
	      if (this._oppositeKnotId != aKnotId) {
	        if (this._oppositeKnotId != undefined) {
	          this._oppositeKnot.point.set(this._oppositeKnot.original);
	          this._oppositeKnot.left.set(this._oppositeKnot.originalLeft);
	          this._oppositeKnot.right.set(this._oppositeKnot.originalRight);
	        }
	
	        this._oppositeKnotId = aKnotId;
	        var lOppositePoint = lOppositeKnot.point();
	        var lOppositeLeft = lOppositeKnot.controlPoint('left');
	        var lOppositeRight = lOppositeKnot.controlPoint('right');
	        this._oppositeKnot = { point: lOppositePoint, original: lOppositePoint.clone() };
	        if (lOppositeLeft) {
	          this._oppositeKnot.left = lOppositeLeft;
	          this._oppositeKnot.originalLeft = lOppositeLeft.clone();
	        }
	        if (lOppositeRight) {
	          this._oppositeKnot.right = lOppositeRight;
	          this._oppositeKnot.originalRight = lOppositeRight.clone();
	        }
	      }
	      return this._oppositeKnot;
	    },
	    move: function (event) {
	      var fromPoint = this._fromPoint;
	      var toPoint = this.curvePoint(event);
	      var diff = Point_substract(toPoint, fromPoint);
	      var diffOpposite = void 0;
	      //This special shortcut works only if the figure is an envelope with no removed or added knots
	      //So just 1 curve, with 8 knots
	      //Also the user need to have only 1 point selected
	      if ((event.ctrlKey || event.shiftKey) && this._points.length == 1 && this._tool._curves.length == 1 && this._tool._curves[0].pieces.length == 8) {
	        var lIdx = this.selectedKnots()[0].ki;
	        var p = this._points[0];
	        var lOppositeKnot = void 0;
	        //lIdx is the envelope knot index:
	        // 6 5 4
	        // 7   3
	        // 0 1 2
	
	        var lOpposite = 0;
	        if (lIdx == 3 //3 and 7 move only right-left
	        || lIdx == 7 || Math.abs(diff.x) > Math.abs(diff.y) && lIdx != 1 && lIdx != 5) //1 and 5 cant be moved right-left
	          {
	            switch (lIdx) {
	              case 0:
	                lOpposite = 2;break;
	              case 2:
	                lOpposite = 0;break;
	              case 3:
	                lOpposite = 7;break;
	              case 4:
	                lOpposite = 6;break;
	              case 6:
	                lOpposite = 4;break;
	              case 7:
	                lOpposite = 3;break;
	            }
	            diff = new _cdl.Point(diff.x, 0);
	            lOppositeKnot = this.cacheOppositeKnot(lOpposite);
	            if (event.shiftKey) diffOpposite = new _cdl.Point(-diff.x, p.original.y - lOppositeKnot.original.y);else diffOpposite = new _cdl.Point(diff.x, p.original.y - lOppositeKnot.original.y);
	          } else {
	          switch (lIdx) {
	            case 0:
	              lOpposite = 6;break;
	            case 1:
	              lOpposite = 5;break;
	            case 2:
	              lOpposite = 4;break;
	            case 4:
	              lOpposite = 2;break;
	            case 5:
	              lOpposite = 1;break;
	            case 6:
	              lOpposite = 0;break;
	          }
	          diff = new _cdl.Point(0, diff.y);
	          lOppositeKnot = this.cacheOppositeKnot(lOpposite);
	          if (event.shiftKey) diffOpposite = new _cdl.Point(p.original.x - lOppositeKnot.original.x, -diff.y);else diffOpposite = new _cdl.Point(p.original.x - lOppositeKnot.original.x, diff.y);
	        }
	        p.point.set(Point_add(p.original, diff));
	        p.left.set(Point_add(p.originalLeft, diff));
	        p.right.set(Point_add(p.originalRight, diff));
	        lOppositeKnot.point.set(Point_add(lOppositeKnot.original, diffOpposite));
	        lOppositeKnot.left.set(Point_add(lOppositeKnot.originalLeft, diffOpposite));
	        lOppositeKnot.right.set(Point_add(lOppositeKnot.originalRight, diffOpposite));
	      } else {
	        if (this._oppositeKnotId != undefined) {
	          this._oppositeKnotId = undefined;
	          this._oppositeKnot.point.set(this._oppositeKnot.original);
	          this._oppositeKnot.left.set(this._oppositeKnot.originalLeft);
	          this._oppositeKnot.right.set(this._oppositeKnot.originalRight);
	        }
	
	        (0, _lodash.forEach)(this._points, function (p) {
	          p.point.set(Point_add(p.original, diff));
	          if (p.left) {
	            p.left.set(Point_add(p.originalLeft, diff));
	          }
	          if (p.right) {
	            p.right.set(Point_add(p.originalRight, diff));
	          }
	        });
	      }
	      this.redraw();
	      this.callParent(event);
	    },
	    up: function () /*view,event*/{
	      this.onUpdate();
	      this.undoState();
	    }
	  }),
	
	  'MovingControl': BaseState.extend({
	    // =========================================================
	    init: function (tool, side, fromPoint) {
	      var _this = this;
	      _this.callParent(tool);
	      _this._side = side;
	      _this._fromPoint = fromPoint;
	      var knot = _this._knot = _this.selectedKnot();
	      _this._knotPoint = knot.point();
	      _this._point = knot.controlPoint(side);
	      _this._original = _this._point.clone();
	      _this._corner = knot.corner();
	      var opp = _this._opp = knot.controlPoint(oppSide(side));
	      if (opp) {
	        _this._originalOpp = opp.clone();
	      }
	      _this._handle = new Handle.Control(_this, side);
	      _this._oppHandle = new Handle.Control(_this, oppSide(side));
	    },
	    draw: function (context, transform) {
	      this._handle.draw(context, transform);
	      this._oppHandle.draw(context, transform);
	      this.callParent(context, transform);
	    },
	    down: function () {
	      this.state('Iddle');
	      return false;
	    },
	    move: function (event) {
	      var _this = this,
	          fromPoint = _this._fromPoint,
	          toPoint = _this.curvePoint(event),
	          diff = Point_substract(toPoint, fromPoint),
	          point = _this._point,
	          opp = _this._opp,
	          knotPoint = _this._knotPoint;
	
	      point.set(Point_add(_this._original, diff));
	      _this._handle._point = point;
	
	      if (opp) {
	        var oppVec = Point_substract(point, knotPoint).sm(-1);
	        if (_this._corner === 'curve') {
	          if (!oppVec.isZero()) {
	            var oppNorm = Point_substract(opp, knotPoint).norm();
	            oppVec.sm(oppNorm / oppVec.norm());
	          }
	          opp.set(Point_add(knotPoint, oppVec));
	        } else if (_this._corner === 'symmetric') {
	          opp.set(Point_add(knotPoint, oppVec));
	        }
	        _this._oppHandle._point = opp;
	      }
	
	      _this.redraw();
	    },
	    up: function () {
	      this.onUpdate();
	      this.undoState();
	    }
	  })
	  // =========================================================
	};
	
	var NodeEditBaseTool = _view.Tool.extend({
	  Properties: {
	    alpha: { type: 'number', def: 1 }
	  },
	  initTool: function (view, figure) {
	    if (figure && this.canEdit(figure)) {
	      return this.startEditingFigure$(figure);
	    }
	  },
	  startEdition: function () /*figure*/{},
	  startEditingFigure$: function (figure) {
	    var _this = this,
	        view = this.view;
	    _this._figure = null;
	    return figure.update$().then(function () {
	      view.unlock();
	      _this._figure = figure;
	      _this.startEdition(figure);
	      _this._matrix = figure.matrix_();
	      _this._matrixInverted = _this._matrix.inverted();
	      _this._curves = _this.createCurves(figure);
	      _this._undoState = [];
	      _this._selectedKnots = [];
	      _this._state = new State.Iddle(_this);
	      _this.redraw();
	      view.preview$();
	    });
	  },
	  on_keydown: function (_ref7) {
	    var view = _ref7.view;
	    var event = _ref7.event;
	    var altKey = _ref7.altKey;
	    var which = _ref7.which;
	
	    if (altKey) {
	      event.preventDefault();
	      this.on_keydown_alt(event);
	    }
	
	    if (!view._keyShortcuts) {
	      return;
	    }
	
	    switch (which) {
	      case 46:
	        // 'Del'
	        event.preventDefault();
	        this._state.deleteAction();
	        break;
	    }
	  },
	  on_keyup: function (_ref8) {
	    var event = _ref8.event;
	    var altKey = _ref8.altKey;
	
	    if (!altKey) {
	      event.preventDefault();
	      return this.on_keyup_alt(event);
	    }
	  },
	  on_keydown_alt: function (_ref9) {
	    var view = _ref9.view;
	
	    if (!this._transparentMode) {
	      this._transparentMode = true;
	      view.redraw('document');
	      this.redraw();
	      view.render$();
	    }
	  },
	  on_keyup_alt: function (_ref10) {
	    var view = _ref10.view;
	
	    if (this._transparentMode) {
	      this._transparentMode = false;
	      view.redraw('document');
	      this.redraw();
	      view.render$();
	    }
	  },
	  state: function (s, sk) {
	    var _this = this,
	        undoState = _this._undoState;
	    undoState.push(_this._state);
	    if (undoState.length > 10) {
	      undoState.shift();
	    }
	
	    _this._selectedKnots = !sk ? [] : (0, _gear.isArray)(sk) ? sk : [sk];
	
	    for (var _len = arguments.length, params = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      params[_key - 2] = arguments[_key];
	    }
	
	    _this._state = new (Function.prototype.bind.apply(State[s], [null].concat([_this], _toConsumableArray(params))))();
	    _this.redraw();
	  },
	  undoState: function () {
	    this._state = this._undoState.pop();
	    this._state.focus();
	    this.redraw();
	  },
	  somethingToDraw: function () {
	    return !!this._figure;
	  },
	  draw: function (_ref11) {
	    var view = _ref11.view;
	    var context = _ref11.context;
	    var transform = _ref11.transform;
	
	    if (!this._figure) {
	      return;
	    }
	
	    // Draw figure being edited
	    view.drawIsolatedFigures(this._alpha * (this._transparentMode ? 0.6 : 1));
	
	    // Draw curves, knots and handles
	    context.lineJoin = 'round';
	    var ft = _cdl.Matrix.m(transform, this._matrix);
	    this._state.draw(context, ft);
	  },
	  try_pointerdown: function (_ref12) {
	    var event = _ref12.event;
	    var isPrimary = _ref12.isPrimary;
	    var docPoint = _ref12.docPoint;
	
	    if (!this._figure) {
	      return;
	    }
	    if (!isPrimary) {
	      return; // ignore multitouch
	    }
	    if (!this._state.down(event)) {
	      this._clickOut = { docPoint: docPoint };
	    } else {
	      event.stopPropagation();
	    }
	  },
	  on_pointerdown: function (event) {
	    this.try_pointerdown(event);
	  },
	  on_mousemove: function (_ref13) {
	    var event = _ref13.event;
	
	    if (!this._figure) {
	      return;
	    }
	    this._state.mousemove(event);
	  },
	  on_pointermove: function (_ref14) {
	    var event = _ref14.event;
	    var isPrimary = _ref14.isPrimary;
	
	    if (!this._figure) {
	      return;
	    }
	    if (!isPrimary) {
	      return; // ignore multitouch
	    }
	    var co = this._clickOut;
	    if (co && !event.docPoint.isEqual(co.docPoint)) {
	      this._clickOut = null;
	    }
	    this._state.move(event);
	  },
	  on_pointerup: function (_ref15) {
	    var isPrimary = _ref15.isPrimary;
	    var event = _ref15.event;
	
	    if (!isPrimary) {
	      return; // ignore multitouch
	    }
	    if (this._figure) {
	      this._state.up(event);
	    }
	
	    if (this._clickOut || !this._figure) {
	      this._clickOut = null;
	      this._onClickOut(event);
	    }
	  },
	  _onClickOut: function (_ref16) {
	    var view = _ref16.view;
	    var event = _ref16.event;
	    var docPoint = _ref16.docPoint;
	    var cmdKey = _ref16.cmdKey;
	
	
	    var _this = this;
	    var figure = event.figure; // [EVENTS] view.figureAtPoint( docPoint );
	    if (figure && _this.canEdit(figure)) {
	      _this.commitChanges$({ select: false }).then(function () {
	        _this.startEditingFigure$(figure);
	      });
	    } else if (cmdKey) {
	      _this.commit$();
	    }
	  },
	  on_dblclick: function (event) {
	    if (!this._figure || !this._state.on_dblclick(event)) {
	      this.commit$();
	    }
	  },
	  onUpdate: function () {
	    // ...
	  }
	});
	
	var NodeEditTool = exports.NodeEditTool = NodeEditBaseTool.extend({ typeName: 'NodeEditTool',
	  toolbarName: 'nodeEditTool',
	  _hideOriginal: true,
	  redraw: function () {
	    this.callParent();
	    if (this._figure) {
	      this._figure.invalidateView();
	    }
	    this.view.preview$();
	  },
	  createCurves: function (figure) {
	    var curves = [];
	    (0, _lodash.forEach)(figure.polyregions, function (p) {
	      (0, _lodash.forEach)(p.regions, function (r) {
	        (0, _lodash.forEach)(r.curves, function (c, i) {
	          if (!(c instanceof _cdl.Curve)) {
	            c = c.convertToCurve();
	            r.curves[i] = c;
	          }
	          // Curves are not currently properly owned
	          // I am thinking that we should remove lazyCDL curves loading so we can just include it in our type system
	          c._owner = r;
	          curves.push(c);
	        });
	      });
	    });
	    return curves;
	  },
	  canEdit: function (figure) {
	    return this.view.is(figure, 'nodeEditable');
	  },
	  startEdition: function (figure) {
	    this.view.startIsolatedFiguresEdition([figure]);
	  },
	  _cancel$: function (view, doc) {
	    view.stopIsolatedFiguresEdition();
	    view.selectedFigures.set(this._figure);
	    return doc.revert$();
	  },
	  _commit$: function (view) {
	    view.stopIsolatedFiguresEdition();
	    return this.commitChanges$();
	  },
	  commitChanges$: function (config) {
	    var view = this.view,
	        doc = view.document;
	    // This is really important, grab the first envelope point
	    // before the figure is invalidated
	    var figure = this._figure;
	    if (!figure) {
	      return (0, _gear.resolve)();
	    }
	    if (figure._polyregions.length === 0) {
	      view.remove(figure);
	      return doc.commit$();
	    }
	
	    var referencePoint = figure.referencePoint_().clone();
	
	    figure.invalidate();
	    figure.visible = true;
	
	    if (config && config.select !== false) {
	      view.selectedFigures.set(figure);
	    }
	
	    return (0, _gear.if$)(!(figure._anchor._absolute && figure._pin.anchorBased()), function () {
	      return figure._fixUpPin$('referencePoint_', referencePoint);
	    }).then(function () {
	      if (figure.document !== doc) {
	        view.add(figure);
	      }
	      return doc.commit$();
	    });
	  }
	});
	_view.Tool.NodeEdit = NodeEditTool;
	
	var NodeEditEnvelopeTool = exports.NodeEditEnvelopeTool = NodeEditBaseTool.extend({ typeName: 'NodeEditEnvelopeTool',
	  toolbarName: 'nodeEditEnvelopeTool',
	  canEdit: function (figure) {
	    return figure.isText && !figure.isMultiPart || !!(0, _gear.findByType)(figure._processes, _cdl.Process.FitEnvelope);
	  },
	  startEdition: function (figure) {
	    this.view.startIsolatedFiguresEdition([figure]);
	  },
	  _cancel$: function (view, doc) {
	    if (_config.Config.localFitEnvelope) {
	      return view.revert$();
	    } else {
	      view.selectedFigures.set(this._figure);
	    }
	    view.stopIsolatedFiguresEdition();
	  },
	  _commit$: function (view) {
	    view.stopIsolatedFiguresEdition();
	    return this.commitChanges$();
	  },
	  createCurves: function (figure) {
	    // We create a envelope { figure, process, editable } for every envelope in the figure
	    var process = (0, _gear.findByType)(figure.processes, _cdl.Process.FitEnvelope);
	    this._addOnCommit = !process;
	    if (!process) {
	      process = _cdl.Process.FitEnvelope.createFromFigure(figure);
	    }
	    this._process = process;
	
	    // Convert the envelope to one closed curve
	    var pieces = [];
	    (0, _lodash.forEach)(process.envelope().curves, function (c) {
	      // Flag it
	      var ps = (0, _gear.cloneDeep)(c.pieces);
	      ps[0].P0.__cadx_locked = true;
	      pieces = pieces.concat(ps);
	    });
	
	    return [_cdl.Curve.fromNonTiedPieces(pieces, true)];
	  },
	  onUpdate: function () {
	    var _this4 = this;
	
	    if (_config.Config.localFitEnvelope) {
	      var _ret = function () {
	        var view = _this4.view;
	        return {
	          v: _this4.updateFigure$().then(function () {
	            view.unlock();
	            _this4.redraw();
	            view.preview$();
	          })
	        };
	      }();
	
	      if (typeof _ret === "object") return _ret.v;
	    }
	  },
	  updateFigure$: function () {
	    var _this = this;
	    var figure = _this._figure;
	    if (!figure) {
	      return (0, _gear.resolve)();
	    }
	    var process = _this._process;
	    var addOnCommit = _this._addOnCommit;
	    return (0, _gear.if$)(addOnCommit, function () {
	      _this._addOnCommit = false;
	      return figure.center$().then(function (center) {
	        figure._processes.add(process);
	        figure.pin = center;
	      });
	    }).then(function () {
	
	      return figure.matrix$().then(function (matrix) {
	
	        var oldEnvelopeCenter = matrix.apply(process._envelope.center);
	
	        var curve = _this._curves[0];
	
	        // Get the four curves from envelopeCurve
	        var curves = [];
	        var currentPieces = [];
	        var createCurve = function () {
	          if (currentPieces.length > 0) {
	            curves.push(new _cdl.Curve.fromNonTiedPieces(currentPieces, false));
	            currentPieces = [];
	          }
	        };
	        (0, _lodash.forEach)(curve.pieces, function (p) {
	          if (p.P0.__cadx_locked === true) {
	            createCurve();
	          }
	          currentPieces.push(p.clone());
	        });
	        createCurve();
	
	        process.envelope(new _cdl.Envelope(curves));
	
	        var newEnvelopeCenter = matrix.apply(process._envelope.center);
	
	        var offset = _cdl.Point.substract(newEnvelopeCenter, oldEnvelopeCenter);
	        figure.translate(offset);
	
	        return figure;
	      });
	    });
	  },
	  commitChanges$: function (config) {
	    var view = this.view,
	        figure = this._figure;
	    return this.updateFigure$().then(function () {
	      if (config && config.select !== false) {
	        view.selectedFigures.set(figure);
	      }
	      return view.commit$();
	    });
	  }
	});
	_view.Tool.NodeEditEnvelope = NodeEditEnvelopeTool;

/***/ },

/***/ 165:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.RenderInfoTool = undefined;
	
	var _lodash = __webpack_require__(4);
	
	var _cdl = __webpack_require__(15);
	
	var _view = __webpack_require__(84);
	
	var _selectTransform = __webpack_require__(154);
	
	var RenderInfoTool = exports.RenderInfoTool = _view.Tool.extend({ typeName: 'RenderInfoTool',
	  type: 'Final',
	  toolbarName: 'renderInfoTool',
	  initTool: function (view, figure) {
	    var _this = this;
	
	    this.handles = new _selectTransform.SelectAndTransformHandles({
	
	      view: this.view,
	      tool: this,
	
	      editingItems: function () {
	        var figure = _this._figure;
	        return figure ? [figure] : [];
	      },
	
	      getOriginalTransforms: function () {
	        _this._downFrame = _this.computeRenderFrame_();
	        _this._downMatrix22 = _this._polyregion.renderMatrix || new _cdl.Matrix();
	      },
	
	      setOriginalTransforms: function () {
	        // Directly handle revert in transformItems
	      },
	
	      computeItemsFrame_: this.computeRenderFrame_.bind(this),
	
	      transformItems: this.transformItems.bind(this),
	
	      itemsEnabledTransforms: function () {
	        return {
	          translate: true,
	          scale: true,
	          rotate: true
	        };
	      }
	    });
	
	    if (figure) {
	      this.startEdit(figure);
	    }
	  },
	  computeRenderFrame_: function () {
	    var polyregion = this._polyregion;
	    return (polyregion.renderFrame || polyregion.initialRenderFrame()).transformed(this._figure.globalMatrix_());
	  },
	  transformItems: function (items, transform) {
	    var figure = this._figure,
	        polyregion = this._polyregion,
	        downFrame = this._downFrame,
	        downMatrix22 = this._downMatrix22;
	
	    var mi = figure.matrix_().inverted();
	
	    var mi_transform = _cdl.Matrix.m(mi, transform);
	
	    polyregion.renderMatrix = _cdl.Matrix.m(_cdl.Matrix.rotate(mi_transform.angle()), downMatrix22);
	    polyregion.renderFrame = downFrame.transformed(mi_transform);
	  },
	  startEdit: function (figure, point) {
	    var view = this.view;
	    this._figure = figure;
	    this._polyregion = point ? figure.polyregionAtPoint_(point) : (0, _lodash.last)(figure._polyregions);
	    this.handles.update();
	    this.redraw();
	    view.render$();
	  },
	  link: function (view) {
	    this.handles.create();
	    // [TODO] Abstract
	    var h = this.handles.handles; // grab internal handles
	    h._fillColor = '#6e78d1';
	    h._fillOverColor = '#243788';
	    h._fillActiveColor = '#fb603d';
	    h._strokeColor = '#243788';
	
	    view.on({ 'rendercomplete': this.on_rendercomplete }, this);
	  },
	  unlink: function (view) {
	    view.un(this);
	    this.handles.dispose();
	  },
	  on_rendercomplete: function () {
	    if (!(0, _lodash.includes)(this.view.figures, this._figure)) {
	      this._figure = null;
	    }
	    this.handles.update();
	  },
	  on_pointerdown: function (_ref) {
	    var view = _ref.view;
	    var event = _ref.event;
	    var isPrimary = _ref.isPrimary;
	    var docPoint = _ref.docPoint;
	
	    if (!isPrimary) {
	      return;
	    }
	
	    var hs = this.handles;
	    if (hs._editionMode) {
	      hs.up(event);
	      return;
	    }
	
	    var leftClick = event.which === 1;
	    if (!leftClick) {
	      return;
	    }
	
	    if (hs.isHandle(event)) {
	      event.stopPropagation();
	      hs.down(event);
	    } else {
	
	      var figure = event.figure; // [EVENTS] view.figureAtPoint(docPoint);
	      if (figure && figure.isShape) {
	        this.startEdit(figure, docPoint);
	      }
	    }
	  },
	  on_pointermove: function (event) {
	    this.handles.move(event);
	  },
	  on_pointerup: function (event) {
	    this.handles.up(event);
	  },
	  draw: function (config) {
	    this.handles.draw(config);
	  }
	});
	
	_view.Tool.ClippingBounds = _view.Tool.extend({ typeName: 'ClippingBoundsTool',
	  type: 'Final',
	  toolbarName: 'clippingBoundsTool',
	  initTool: function (view, figure) {
	    var _this2 = this;
	
	    this.handles = new _selectTransform.SelectAndTransformHandles({
	
	      view: this.view,
	      tool: this,
	
	      editingItems: function () {
	        var figure = _this2._figure;
	        return figure ? [figure] : [];
	      },
	
	      getOriginalTransforms: function () {
	        _this2._downFrame = _this2.clippingFrame();
	        _this2._downClippingBounds = _this2._brush.clippingBounds.clone();
	        _this2._downTextureOffset = _this2._brush.textureOffset.clone();
	        // this._downPin = this._figure.globalMatrix_().apply( this.clippingFrame().center );
	      },
	
	      setOriginalTransforms: function () {
	        // Directly handle revert in transformItems
	      },
	
	      computeItemsFrame_: this.clippingFrame.bind(this),
	
	      transformItems: this.transformItems.bind(this),
	
	      itemsEnabledTransforms: function () {
	        return {
	          translate: true,
	          scale: true
	        };
	      }
	    });
	
	    if (figure) {
	      this.startEdit(figure);
	    }
	  },
	  startEdit: function (figure, point) {
	    var view = this.view;
	    this._figure = null;
	    if (figure.isShape) {
	      var polyregion = point ? figure.polyregionAtPoint_(point) : (0, _lodash.last)(figure._polyregions);
	      var brush = polyregion.brush;
	      if (brush instanceof _cdl.TextureBrushBase) {
	        this._figure = figure;
	        this._polyregion = polyregion;
	        this._brush = brush;
	      }
	    }
	    this.handles.update();
	    this.redraw();
	    view.render$();
	  },
	  link: function (view) {
	    this.handles.create();
	
	    var h = this.handles.handles;
	    h._fillColor = '#6e78d1';
	    h._fillOverColor = '#243788';
	    h._fillActiveColor = '#fb603d';
	    h._strokeColor = '#243788';
	
	    view.on({ 'rendercomplete': this.on_rendercomplete }, this);
	  },
	  unlink: function (view) {
	    view.un(this);
	    this.handles.dispose();
	  },
	  on_rendercomplete: function () {
	    if (!(0, _lodash.includes)(this.view.figures, this._figure)) {
	      this._figure = null;
	    }
	    this.handles.update();
	  },
	  on_pointerdown: function (_ref2) {
	    var view = _ref2.view;
	    var event = _ref2.event;
	    var isPrimary = _ref2.isPrimary;
	    var which = _ref2.which;
	    var docPoint = _ref2.docPoint;
	
	    if (!isPrimary) {
	      return;
	    }
	
	    var hs = this.handles;
	    if (hs._editionMode) {
	      hs.up(event);
	      return;
	    }
	
	    var leftClick = which === 1;
	    if (!leftClick) {
	      return;
	    }
	
	    if (hs.isHandle(event)) {
	      event.stopPropagation();
	      hs.down(event);
	    } else {
	
	      var figure = event.figure; // [EVENTS] view.figureAtPoint(docPoint);
	      if (figure && figure.isShape) {
	        this.startEdit(figure, docPoint);
	      }
	    }
	  },
	  on_pointermove: function (event) {
	    this.handles.move(event);
	  },
	  on_pointerup: function (event) {
	    this.handles.up(event);
	  },
	  draw: function (config) {
	    this.handles.draw(config);
	  },
	  renderFrame: function () {
	    var figure = this._figure,
	        polyregion = this._polyregion;
	    var matrix = figure.globalMatrix_();
	    return (polyregion.renderFrame || polyregion.initialRenderFrame()).transformed(matrix);
	  },
	  clippingFrame: function () {
	    return this._brush.clippingFrame_(this.renderFrame());
	  },
	  transformItems: function (items, transform) {
	
	    var brush = this._brush,
	        frame_0 = this._downFrame;
	
	    var frame_1 = frame_0.transformed(transform);
	
	    var rotate = _cdl.Matrix.rotate(-frame_0.angle());
	
	    var fr_0 = frame_0.transformed(rotate);
	
	    var ocb = this._downClippingBounds;
	
	    var scale = _cdl.Matrix.scale(ocb.width / fr_0.width, ocb.height / fr_0.height);
	
	    var frs_0 = fr_0.transformed(scale);
	
	    var translate = _cdl.Matrix.translate(ocb.lx_ly.minus(frs_0.p0));
	
	    var ncb = frame_1.transformed(_cdl.Matrix.concat(translate, scale, rotate)).bounds;
	
	    brush.clippingBounds = ncb;
	
	    var dto = this._downTextureOffset;
	
	    var nto = new _cdl.Point((ocb.lx + dto.x * ocb.width - ncb.lx) / ncb.width, (ocb.ly + dto.y * ocb.height - ncb.ly) / ncb.height);
	
	    brush.textureOffset = nto;
	  }
	});
	
	_view.Tool.RenderInfo = RenderInfoTool;

/***/ },

/***/ 166:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SelectBrushTool = undefined;
	
	var _view = __webpack_require__(84);
	
	var SelectBrushTool = exports.SelectBrushTool = _view.Tool.extend({
	
	  type: 'Select',
	
	  toolbarName: 'selectBrush',
	  allowKeyShortcuts: true,
	
	  initTool: function (view, config) {
	    var th = ['Click to select a brush'];
	    this.toolhelp(th);
	  },
	  on_pointerdown: function (_ref) {
	    var view = _ref.view;
	    var event = _ref.event;
	    var which = _ref.which;
	    var cmdKey = _ref.cmdKey;
	    var docPoint = _ref.docPoint;
	    var pointers = _ref.pointers;
	
	    var leftClick = which === 1;
	    if (!leftClick) {
	      return;
	    }
	    view.fireEvent('brushselected', view.getBrushAtPoint(docPoint));
	    event.stopPropagation();
	  },
	  on_pointerup: function (event) {}
	});
	
	_view.Tool.SelectBrush = SelectBrushTool;

/***/ }

})
});
;


/** WEBPACK FOOTER **
 ** tools.js
 **/